import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import classNames from 'classnames';
import lodashMap from 'lodash/map';
import lodashFilter from 'lodash/filter';
import lodashFind from 'lodash/find';
import upperFirst from 'lodash/upperFirst';
import lowerFirst from 'lodash/lowerFirst';
import ReactTooltip from 'react-tooltip';
import { Link, withRouter } from 'react-router';
import { Field, FieldArray } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Breadcrumb, Tabs, Tab } from 'react-bootstrap';
import { Data } from 'react-data-grid-addons';
import ReactDOM from 'react-dom';
import { Translate, I18n } from 'react-redux-i18n';

import ConfirmModal from 'Common/confirmModal';
import { DatePicker, StartOfThisMonthDatePicker } from '../Common/datePicker';
import ContentWrapper from '../Layout/ContentWrapper';
import checkPermissionLocal from '../Common/permissions';
import MixProductAutoSuggest from '../Common/MixProductAutoSuggest';
import MixProductTypeRadios from '../Common/MixProductTypeRadios';
import { Selection, DisabledSelection, SelectionWithProps } from '../Common/selection'
import { InputField, DisabledInputField, ControlledInputField, ControllabledStateInputField } from '../Common/inputField';
import Spinner from '../Widgets/spinner';
import SpinnerButton from '../Common/SpinnerButton';
import VendorForm from '../../containers/Products/vendorForm'
import GroupForm from '../../containers/Products/groupForm'
import EditGroupForm from '../../containers/Products/editGroupForm';
import CategoryForm from '../../containers/Products/categoryForm'
import ProductFormNavigation_1, { productFormNavigation_2 as ProductFormNavigation_2, productFormNavigation_3 as ProductFormNavigation_3 } from '../../containers/Products/productFormNavigation'
import Editor from '../Common/Editor';
import PackageTypes from '../../containers/Products/packageTypes';
import ConfirmActionModal from '../Common/confirmActionModal';
import RichTextEditor from '../Common/RichTextEditor';
import TuiEditor from '../Common/TuiEditor';
import LinkProductsModal from './components/LinkProductsModal';
import ProductImagesTable from './components/ProductImagesTable';
import { fetchGlAccountRecords, fetchMobileDescriptionBoxText, fetchProductsByParams, fetchBarcodePdf } from '../../actions/products_actions';
import checkPermission from '../Common/permissions';
import { fetchPromoDetailsByProduct, savePromotion, deletePromotion, fetchPromoDetails } from '../../actions/promotions_actions';
import SkusTableModal from './components/SkusModal';
import { DisplayCategoryModal } from '../Common/displayCategoryModal';
import ProductMetaInfoModal from './components/ProductMetaInfoModal';
import ESLModal from './components/ESLModal';
import ScaleBarcodeModal from './components/ScaleBarcodeModal';
import RefNumberVerifyModal from './components/RefNumberVerifyModal';
import generalManagementModals from '../Common/modals/generalManagement';
const {
  BarcodeVerifyFailedModal
} = generalManagementModals;
import {
  roundTo,
  roundUp,
  calculatePriceLevelNormal,
  normalizeFourDecimals,
  calculatePricePercentage,
  priceLevelFieldsMap,
  priceLevelPercentageFieldsMap,
  roundToDecimals,
} from '../Common/NumberUtil';
import {
  isIncompleteForm,
  clearForm,
  desiredShapeByQuantity,
  desiredShapeBuyAGetB,
  desiredShapeByTotalPriceProduct,
  desiredShapeByTotalPriceDiscount,
} from '../Sales/PromotionsPage/utils';
import { PromotionSetup, ByQuantityFields, BuyAGetBFields, ByTotalPriceProductFields, EditPromotionModal } from '../Sales/PromotionsPage/components';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isABBLE, isOCM, isSH, isGGI, isHO, isJRC,
  isHMM, isLE, isSKH, isCPG, isARC, isSUN, isLAP, isGFD, isVAK, isOLG, isABCFF,
  isSW, isTQ, isAGD, isLMH, isSDR, isCRW, isEKC, isSV, isMH, isVIP, isCCW, isSC
} from '../../actions/root_url';
import _ from 'lodash';
import LargeImageModal from './components/LargeImageModal'
import MarketingModal from './components/MarketingModal'
import { fetchCustomerGroups } from '../../actions/groupList_actions';
import BomProductsModal from './components/BomProductsModal';

const isMyuMyu = ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" || ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isCalco = ROOT_API_URL === 'https://calco-scm.truckxi.com/api/' || ROOT_API_URL === 'https://calco-stage.truckxi.com/api/';
const isMMD = ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
const isPTS = ROOT_API_URL === 'https://phantoscope-scm.truckxi.com/api/' || ROOT_URL === 'https://phantoscope-scm.truckxi.com/api/';
const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_API_URL === 'https://afmstage-scm.truckxi.com/api/' || ROOT_URL === 'https://afmstage-scm.truckxi.com/api/';
const isPS = ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api/' || ROOT_URL === 'https://premiumstella-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isAN = ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || ROOT_URL === 'https://asian-scm.truckxi.com/api/';
const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isHF = ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
const isFACEX = ROOT_API_URL === "https://facex-scm.truckxi.com/api/" || ROOT_URL === "https://facex-scm.truckxi.com/api/";

const isMultiWH = true;

const customizedInputStyle = { width: "100%", borderRadius: '2px', border: '1px solid black', backgroundColor: 'rgb(207,216,220)', padding: '0 6px' };

const getObjectValue = (obj) => {
  if (typeof obj === 'object') {
    return obj.value
  }
  return obj
}

const refOptions = [{
  label: "Ref $ = Avg Cost",
  value: "avg_cost"
  }, {
  label: "Ref $ = Prod Cost",
  value: "prod_cost",
}, {
  label: "Manual Ref $",
  value: "as_is",
}];

const channelOptions = [{
  label: "Kohl's Dropship",
  value: "Kohl's Dropship"
  }, {
  label: "Kohl's In store",
  value: "Kohl's In store",
}]

const originOptions = isGGI ? [{
  label: 'Argentina',
  value: 'Argentina',
}, {
  label: 'Australia',
  value: 'Australia'
}, {
  label: 'Bahrain',
  value: 'Bahrain',
}, {
  label: 'Belgium',
  value: 'Belgium',
}, {
  label: 'Bengal',
  value: 'Bengal',
}, {
  label: 'Brazil',
  value: 'Brazil',
}, {
  label: 'Britain',
  value: 'Britain',
}, {
  label: 'Cambodia',
  value: 'Cambodia',
}, {
  label: 'Canada',
  value: 'Canada',
}, {
  label: 'Chile',
  value: 'Chile',
}, {
  label: 'China',
  value: 'China',
}, {
  label: 'Colombia',
  value: 'Colombia',
}, {
  label: 'Costarica',
  value: 'Costarica',
}, {
  label: 'Denmark',
  value: 'Denmark',
}, {
  label: 'Ecuador',
  value: 'Ecuador',
}, {
  label: 'Egypt',
  value: 'Egypt',
}, {
  label: 'Finland',
  value: 'Finland',
}, {
  label: 'France',
  value: 'France',
}, {
  label: 'French Guiana',
  value: 'French Guiana',
}, {
  label: 'Germany',
  value: 'Germany',
}, {
  label: 'Ghana',
  value: 'Ghana',
}, {
  label: 'Greece',
  value: 'Greece',
}, {
  label: 'Greenland',
  value: 'Greenland',
}, {
  label: 'Guyana',
  value: 'Guyana',
}, {
  label: 'Holand',
  value: 'Holand',
}, {
  label: 'Honduras',
  value: 'Honduras',
}, {
  label: 'Iceland',
  value: 'Iceland',
}, {
  label: 'India',
  value: 'India',
}, {
  label: 'Indonesia',
  value: 'Indonesia',
}, {
  label: 'Italy',
  value: 'Italy',
}, {
  label: 'Jamaica',
  value: 'Jamaica',
}, {
  label: 'Japan',
  value: 'Japan',
}, {
  label: 'Korea',
  value: 'Korea',
}, {
  label: 'Malaysia',
  value: 'Malaysia',
}, {
  label: 'Mauritania',
  value: 'Mauritania',
}, {
  label: 'Mexico',
  value: 'Mexico',
}, {
  label: 'Myanmar',
  value: 'Myanmar',
}, {
  label: 'New Zealand',
  value: 'New Zealand',
}, {
  label: 'Norway',
  value: 'Norway',
}, {
  label: 'Oman',
  value: 'Oman',
}, {
  label: 'Pakistan',
  value: 'Pakistan',
}, {
  label: 'Panama',
  value: 'Panama',
}, {
  label: 'Paraguay',
  value: 'Paraguay',
}, {
  label: 'Peru',
  value: 'Peru',
}, {
  label: 'Phillippines',
  value: 'Phillippines'
}, {
  label: 'Poland',
  value: 'Poland',
}, {
  label: 'Porto Rico',
  value: 'Porto Rico',
}, {
  label: 'Senegal',
  value: 'Senegal',
}, {
  label: 'Singapore',
  value: 'Singapore',
}, {
  label: 'South Africa',
  value: 'South Africa',
}, {
  label: 'South Korea',
  value: 'South Korea',
}, {
  label: 'Spain',
  value: 'Spain',
}, {
  label: 'Suriname',
  value: 'Suriname',
}, {
  label: 'Sweden',
  value: 'Sweden',
}, {
  label: 'Taiwan CN',
  value: 'Taiwan CN',
}, {
  label: 'Thailand',
  value: 'Thailand',
}, {
  label: 'Tunis',
  value: 'Tunis',
}, {
  label: 'Turkey',
  value: 'Turkey',
}, {
  label: 'Uruguay',
  value: 'Uruguay',
}, {
  label: 'USA',
  value: 'USA',
}, {
  label: 'Venezuela',
  value: 'Venezuela',
}, {
  label: 'Vietnam',
  value: 'Vietnam',
}, {
  label: 'Yemen',
  value: 'Yemen',
}] : [{
  label: 'China',
  value: 'China'
}, {
  label: 'USA',
  value: 'USA',
}, {
  label: 'Egypt',
  value: 'Egypt',
}, {
  label: 'Oman',
  value: 'Oman',
}, {
  label: 'Spain',
  value: 'Spain',
}, {
  label: 'Thailand',
  value: 'Thailand',
}, {
  label: 'Vietnam',
  value: 'Vietnam',
}, {
  label: 'India',
  value: 'India',
}, {
  label: 'Malaysia',
  value: 'Malaysia',
}, {
  label: 'Phillippines',
  value: 'Phillippines'
}, {
  label: 'Indonesia',
  value: 'Indonesia',
}, {
  label: 'Argentina',
  value: 'Argentina',
}, {
  label: 'Ecuador',
  value: 'Ecuador',
}, {
  label: 'Brazil',
  value: 'Brazil',
}, {
  label: 'Honduras',
  value: 'Honduras',
}, {
  label: 'Peru',
  value: 'Peru',
}, {
  label: 'Venezuela',
  value: 'Venezuela',
}, {
  label: 'Chile',
  value: 'Chile',
}, {
  label: 'Taiwan CN',
  value: 'Taiwan CN',
}, {
  label: 'Mexico',
  value: 'Mexico',
}, {
  label: 'Korea',
  value: 'Korea',
}, {
  label: 'Japan',
  value: 'Japan',
}];

const getSmallUnitPrice = (totalPrice, unit) => {
  let result = totalPrice * unit;
  if (isNaN(result) || typeof result !== 'number') return 0
  return result;
}

let renderInputField = (props) => {
  const inputClass = classNames({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control')
  return (
    <div>
      {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
      <Input {...props.input} className={inputClass} type="text"/>
    </div>
  )
}

let renderRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value={`${props.labelName}`}/>
      </label>
      <div className="col-xs-2">
        <input {...props.input} type="radio" value="true"
           checked={props.input.value === true || props.input.value === "true"}/>
           <Translate value="yes"/>
      </div>
      <div className="col-xs-2">
        <input {...props.input} type="radio" value="false"
           checked={props.input.value === false || props.input.value === "false"}/>
           <Translate value="no"/>
      </div>
    </div>
  )
}

const Checkbox = props => {
  return (
    <input
      {...props.input}
      type="checkbox"
      value={!props.input.value ? "true" : "false"}
      checked={props.input.value === true || props.input.value === "true"}
      disabled={props.disabled}
    />
  );
}

const renderPriceTypeRadio = props => {
  // since style 2 is gray out, the whole radio is useless
  // if (!isSUN) return;
  return (
    <Row style={{ position: "relative", top: "1px" }}>
      <Col xs={7} style={{ padding: 0 }}>
        <input
          {...props.input}
          type="radio"
          value="Percentge"
          checked={props.input.value === 'Percentge'}
          disabled={props.disabled}
        />
        <label><Translate value="percentage"/> </label>
      </Col>
      <Col xs={5} style={{ padding: 0 }}>
        <input
          {...props.input}
          type="radio"
          value="Fixed"
          checked={props.input.value === 'Fixed'}
          disabled={props.disabled}
        />
        <label><Translate value="fixed"/></label>
      </Col>
    </Row>
  )
}

let ConvertProductTypeRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-2">
        <Translate value="prod_type" />
      </label>
      <div className="col-xs-3 text-nowrap">
        <input {...props.input} type="radio" value="Fixed"
          checked={props.input.value === "Fixed" || props.input.value.value === "Fixed"}/>
        <Translate value="per-unit"/>
      </div>
      <div className="col-xs-3 text-nowrap">
          <input {...props.input} type="radio" value="Per-Pound"
            checked={props.input.value === "Per-Pound" || props.input.value.value === "Per-Pound"}/>
          <Translate value="per-weight"/>
      </div>
      <div className="col-xs-3 text-nowrap">
          <input {...props.input} type="radio" value="Non-Fixed"
            checked={props.input.value === "Non-Fixed" || props.input.value.value === "Non-Fixed"}/>
          <Translate value="Non-Fixed"/>
      </div>
    </div>
  )
}

let relatedRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value="related" />
      </label>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="true"
          checked={props.input.value === true || props.input.value === "true"}
          disabled={!props.disableIsRelated}
        />
        <Translate value="yes"/>
      </div>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="false"
          checked={props.input.value === false || props.input.value == "false"}
          disabled={!props.disableIsRelated}
        />
        <Translate value="no"/>
      </div>
    </div>
  )
}

let sizeRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value="size" />
      </label>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="true"
          checked={props.input.value === true || props.input.value === "true"}
          disabled={!props.disableIsLarge}
        />
        <Translate value="lg"/>
      </div>
      <div className="col-xs-3">
        <input {...props.input} type="radio" value="false"
          checked={props.input.value === false || props.input.value === "false"}
          disabled={!props.disableIsLarge}
        />
        <Translate value="sm"/>
      </div>
    </div>
  )
}

let convertNumRadios = props => {
  return (
    <div className="form-group">
      <label className="col-xs-4">
        <Translate value="convert_type"/><span className="asteriksReq">*</span>
      </label>
      <div className="col-xs-3 text-nowrap">
        <input {...props.input} type="radio" value="weight"
          checked={props.input.value === "weight"}
          disabled={isOLG || isVAK}/>
        <Translate value="by_weight"/>
      </div>
      <div className="col-xs-3 text-nowrap">
        <input {...props.input} type="radio" value="unit"
          checked={props.input.value === "unit"}
          disabled={isOLG || isVAK}/>
        <Translate value="by_unit"/>
      </div>
    </div>
  )
}

let renderSaleRadios = props => {
  const titleClass = classNames('col-xs-4')
  return (
    <div id="stopSale" className="form-group" >
      <label className="col-xs-4">
        <input {...props.input} type="radio" value="OnSale"
          checked={props.input.value === "OnSale"}/>
        <Translate value="on_sale"/>
      </label>
      <label className="col-xs-4">
        <input {...props.input} type="radio" value="StopSale"
          checked={props.input.value === "StopSale"}/>
        <Translate value="stop_sale"/>
      </label>
      <label className="col-xs-3 pull-right">
        <input {...props.input} type="radio" value="OnHold"
          checked={props.input.value === "OnHold"}/>
        <Translate value="on_hold"/>
      </label>
    </div>
  )
}

const renderConvertDetailsList = (props) => {
  const { fields } = props;
  return (
    <Row><Col xs={ 12 }><Row><Col xs={ 12 }>
      {fields.map((Product, index) =>
        <div>
          <Row key={index} className="prod-qty-adjuster">
            <Col xs={ 12 }>
              <Row>
                <label className="col-xs-2"><Translate value="prod_num"/></label>
                <Col xs={ 3 } className="prod-no-related">
                  <div className="form-group">
                    <div className="col-xs-12">
                    <Field name={`${Product}.ProductNum`} className="control-label" component={ DisabledInputField } />
                    </div>
                  </div>
                </Col>
                <Col xs={ 4 } className="convert-qty">
                  <div className="form-group">
                    <div className="col-xs-12">
                      <Field name={`${Product}.PackageSize`} className="control-label" component={ DisabledInputField } />
                    </div>
                  </div>
                </Col>
                <Col xs={ 3 } className="convert-qty">
                  <div className="form-group">
                    <div className="col-xs-12">
                      <Field name={`${Product}.ProductType`} className="control-label" component={ DisabledInputField } />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </Col></Row></Col></Row>
  )
}

// Mix Products field array with multiple products
const renderMixProductArrays = (props) => {
  const { fields, suggestProduct, packageTypeOptions } = props;
  return (
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={12} style={{ textAlign: 'right', height: '25px' }}>
            <Button
              style={{ marginBottom: '10px' }}
              bsStyle="primary"
              type="button"
              disabled={!suggestProduct}
              onClick={() => { fields.push({ ProductName: suggestProduct.Name, ProductNum: suggestProduct.ProductNum, ProductSKU: suggestProduct.RefNum }) }}
            >
              <em className="fa fa-plus" />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {!fields.length && <div><Translate value="no_mix_product" /> </div>}
            {fields.map((MixProduct, index) =>
              <Row key={index}>
                <Col xs={12}>
                  <Row className="nonbold-label-description textAlignStyle">
                    <Col sm={4}><Translate value="(ref_no)" /></Col>
                    <Col sm={1}></Col>
                    <Col sm={2}><Translate value="(num)" /></Col>
                    <Col sm={3}><Translate value="(pkg_size)" /></Col>
                    <Col sm={1}></Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <div className="form-group">
                        <div className="col-xs-12">
                          <Field name={`${MixProduct}.ProductSKU`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={1} className="textAlignStyle"><em className="fa fa-times times-sign" /></Col>
                    <Col xs={2}>
                      <div className="form-group">
                        <div className="col-xs-12">
                          <Field name={`${MixProduct}.Quantity`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="form-group">
                        <div className="col-xs-12 select-menu-drop-up">
                          <Field style={{ textAlign: 'left' }} name={`${MixProduct}.MixedUnit`} component={Selection} options={packageTypeOptions} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={1} style={{ position: "relative" }}>
                      <Button
                        bsStyle="danger"
                        type="reset"
                        onClick={() => { fields.remove(index); }} // remove from index
                      >
                        <em className="fa fa-trash" />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

// Vendors should be a field array with multiple vendors.
const renderVendorArrays = (props) => {
  const { fields, vendorNameOptions, vendorNumOptions } = props;
  const renderSource = (Vendor) => {
    if (isGFD) {
      const options = [{
        label: 'UPC (moleQ) - Related',
        value: 'UPC (moleQ) - Related',
      },{
        label: 'UPC (MoleQ)',
        value: 'UPC (MoleQ)',
      }, {
        label: 'UPC (IT Retail)',
        value: 'UPC (IT Retail)',
      }, {
        label: 'EAN-8',
        value: 'EAN-8',
      }, {
        label: 'UPC-E',
        value: 'UPC-E',
      }, {
        label: 'UPC-A 10',
        value: 'UPC-A 10',
      }, {
        label: 'UPC-A 11',
        value: 'UPC-A 11',
      }, {
        label: 'UPC-13',
        value: 'UPC-13',
      }];
      return <Col xs={12}>
        <div className="form-group">
          <label className="col-xs-3"><Translate value="source"/></label>
          <div className="col-xs-9">
            <Field name={`${Vendor}.Source`} component={Selection} options={options}/>
          </div>
        </div>
      </Col>
    }
  }

  const renderCaseBarcode = (Vendor) => {
    return <Col xs={12}>
      <div className="form-group">
        <label className="col-xs-3"><Translate value="unit_per_case"/></label>
        <div className="col-xs-9">
          <Field name={`${Vendor}.UnitPerCase`} component={InputField} />
        </div>
      </div>
      <div className="form-group">
        <label className="col-xs-3"><Translate value="case_price"/></label>
        <div className="col-xs-9">
          <Field name={`${Vendor}.CasePrice`} component={InputField} />
        </div>
      </div>
    </Col>
  }
    
  return (
    <Row>
      <Col xs={ 12 }>
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => { fields.push({})} }   // pushes empty child field onto the end of the array
        >
          <em className="fa fa-plus" />
        </Button>
        <Row>
          <Col xs={ 12 }>
            {!fields.length && <div><Translate value="no_vendor"/> </div>}
            {fields.map((Vendor, index) =>
              <Row key={index}>
                <Col xs={12}>
                  <h4><Translate value="barcode_poundsign"/> {index + 1}</h4>
                  <Row>
                    <Col xs={11}>
                    </Col>
                    <Col xs={1} style={{position: "relative", left: "-13px"}}>
                      <Button
                        bsStyle="danger"
                        type="reset"
                        onClick={() => { fields.remove(index); }} // remove from index
                      >
                        <em className="fa fa-trash" />
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    {renderSource(Vendor)}
                    {isGFD && renderCaseBarcode(Vendor)}
                    {isGGI ? <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="vendor_name"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_id`} component={Selection} options={vendorNameOptions}/>
                        </div>
                      </div>
                    </Col> : <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="name"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_id`} matchPos={isVAK ? 'any' : 'start'} component={Selection} options={vendorNameOptions}/>
                        </div>
                      </div>
                    </Col>}

                    {isGGI ? <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="vendor_num"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_id`} component={Selection} options={vendorNumOptions}/>
                        </div>
                      </div>
                    </Col> : <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="num"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_id`} component={Selection} options={vendorNumOptions}/>
                        </div>
                      </div>
                    </Col>}

                    <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="barcode"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Code`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                    {isSV &&
                       <Col xs={12}>
                       <div className="form-group">
                         <label className="col-xs-3"><Translate value="check_num"/></label>
                         <div className="col-xs-9">
                           <Field name={`${Vendor}.Check_Code`} disabled={true} component={InputField} />
                         </div>
                       </div>
                     </Col>
                    }
                    {isGGI ? <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="vendor_product_num"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_product_num`} component={InputField} />
                        </div>
                      </div>
                    </Col> : <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="VPN"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor_product_num`} component={InputField} />
                        </div>
                      </div>
                    </Col>}

                    {
                      (isOCM || isGGI)  &&
                      <Col xs={12}>
                        <Row className="formRow">
                          <Col xs={4}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="master"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name={`${Vendor}.MasterCS`} component={Checkbox} />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={4}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="medium"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name={`${Vendor}.MediumCS`} component={Checkbox} />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={4}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="unit"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name={`${Vendor}.Unit`} component={Checkbox} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    }
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

// Vendors Associated should be a field array with multiple vendors.
const renderVendorAccociatedArrays = (props) => {
  const { fields, vendorNameOptions, vendorNumOptions, vendorProducts, handleRemove } = props;
  const deleteVendor = (index) => {
    if (vendorProducts.length>0 && vendorProducts[index] && vendorProducts[index].Id) {
      const remove = {
        ...vendorProducts[index],
         is_deleted: true 
      }
      handleRemove(remove);
    }
    fields.remove(index);
  }
  
  return (
    <Row>
      <Col xs={ 12 }>
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => { fields.push({})} }   // pushes empty child field onto the end of the array
        >
          <em className="fa fa-plus" />
        </Button>
        <Row>
          <Col xs={ 12 }>
            {!fields.length && <div><Translate value="no_vendor"/> </div>}
            {fields.map((Vendor, index) =>
              <Row key={index}>
                <Col xs={12}>
                  <h4><Translate value="vendor_poundsign"/> {index + 1}</h4>
                  <Row>
                    <Col xs={11}>
                    </Col>
                    <Col xs={1} style={{position: "relative", left: "-13px"}}>
                      <Button
                        bsStyle="danger"
                        type="reset"
                        onClick={() => { deleteVendor(index); }}
                      >
                        <em className="fa fa-trash" />
                      </Button>
                    </Col>
                  </Row>   
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="name"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor`} matchPos={'start'} component={Selection} options={vendorNameOptions}/>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="num"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Vendor`} component={Selection} options={vendorNumOptions}/>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="price"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.Price`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="col-xs-3"><Translate value="VPN"/></label>
                        <div className="col-xs-9">
                          <Field name={`${Vendor}.VendorProductNum`} component={InputField} />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

var submitTrue = false;

const languages = [
  {
    label: 'English - EN',
    value: 'EN',
  },
  {
    label: 'Chinese - ZH',
    value: 'ZH',
  },
];
const isSoleStage = function() {
  return ( ROOT_URL === "https://ss-stage.truckxi.com/api/" ||  ROOT_URL === "https://solestage-scm.truckxi.com/api/" )
}
const isBD = function() {
  return ( ROOT_URL === "https://bd-stage.truckxi.com/api/" ||  ROOT_URL === "https://bd-scm.truckxi.com/api/" )
}
class ProductForm extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      eslEnabled: false,
      eslModalVisibility: false,
      scaleLabelModalVisibility: false,
      eslFetchData: null,
      formProps: {},
      confirmModalVisibility: false,
      suggestValue: '',
      productSearchType: 'Name',
      suggestProduct: null,
      MixedProductBaseUnit: null,
      MixedProduct: {
        Unit: null,
        MixedUnit: null,
        ProductName: null,
        ProductNum: null,
        ProductSKU: null,
        Quantity: null,
      },
      skusModal: false,
      marketingModal: false,
      vendorOpen: false,
      groupOpen: false,
      categoryOpen: false,
      packageTypeOpen: false,
      mobileDescBoxOpen: false,
      displayCategoryBoxOpen: false,
      addConvertProductsOpen: false,
      checkAuthorizeOpen: false,
      editProductGroup: false,
      vendorValue: null,
      dirty: false,
      p1Percentage: 0,
      p2Percentage: 0,
      p3Percentage: 0,
      p4Percentage: 0,
      p5Percentage: 0,
      priceLv1: 0,
      priceLv2: 0,
      priceLv3: 0,
      priceLv4: 0,
      priceLv5: 0,
      priceLevel1Sunsun: 0,
      priceLevel2Sunsun: 0,
      priceLevel3Sunsun: 0,
      priceLevel4Sunsun: 0,
      priceLevel5Sunsun: 0,
      applyLv1: true,
      applyLv2: true,
      applyLv3: true,
      applyLv4: true,
      applyLv5: true,
      changePrice: true,
      editableProductNum: true,
      crumbStyle: {},
      files: null,
      Product_id: 0,
      showProductCreatedOpen: false,
      productNavigationOpen: [false, false],
      selectedMarketing: [],
      marketingAll:[],
      productNavigation_1: {
        ProductDepartment_id: null,
        ProductCategory1_id: null,
        ProductGroup_id: null,
        ProductNum: null,
        RefNum: null,
        suggestedProdNum: null,
        isLinked: false,
        Name: null,
        Description: null,
        IsLarge: null,
        LastDigit: null,
        isMadePrev: null,
      },
      productNavigation_2: {
        ProdType: null,
        PackageType: null,
        PackageSize_1: null,
        PackageType_2: null,
        PackageSize_2: null,
        MeasureUnit_2: null,
        NetWeight_1: null,
        NetWeight_2: null,
        ProductCost: null,
        RefPrice: null,
        LowestSalePrice: null,
      },
      productNavigation_3: {
        ConvertNum: null,
        SmallProdType: null,
        SmallPackageType: null,
        ConvertType: null,
        GeneralNum: null,
      },
      // promo
      customerList: [],
      startDateSelected: null,
      endDateSelected: null,
      customerGroupSelected: '',
      paymentTypeSelected: '',
      tabsKey: 'ByQuantity',
      selectedProduct: {},
      promotionToEdit: {},
      methodSelected: '',
      discountValue: '',
      discountType: 'Dollar',
      quantityFrom: '',
      quantityTo: '',
      minPurchasePrice: '',
      productQuantityB: '',
      promotionDetails: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      isLoadingPromotions: false,
      isLoadingSavePromotion: false,
      isLoadingPromoDetails: false,
      promotionDetailsIsLoading: false,
      viewPromotion: false,
      deletePromotionOpen: false,
      editPromotionOpen: false,
      promotionToDeleteId: undefined,

      editRecPermissionOpen: false,
      case: null,

      isLoadingMobileDescBoxText: false,
      mobileDescriptionHTML: '',
      imagesModalOpen: false,
      updatedImage: undefined,
      relatedProducts: [],

      isLoadingCategoryProducts: false,
      isLoadingDisplayCategory: false,
      categoryProducts: [],
      deleteModalOpen: false,
      ProductSKU: '',

      displayCategories: null,
      permissionChecked: false,

      productMetaInfoVisibility: false,
      meta_info: {
        meta_title: '',
        meta_keywords: '',
        meta_description: '',
      },

      PackageTypeC: '',
      productInventoryQty: 0,
      refNumVerified: false,
      isRefNumVerifyModalVisible: false,
      isBarcodeVerifyFailedModalVisible: false,
      barcodeVerifyFailedMsg: '',
      palletBoxes: '',
      palletLevels: '',
      glAccountData: [],
      isShowProductLargeImg: false,
      productParts: {
        rows: [],
        filter: {},
      },
      isLoadingProductParts: false,
      isFirst: true,
      VendorProducts: [],
      removeVendorProducts: [],
    };
    this.openVendor = this.openVendor.bind(this);
    this.closeVendor = this.closeVendor.bind(this);
    this.openGroup = this.openGroup.bind(this);
    this.closeGroup = this.closeGroup.bind(this);
    this.openCategory = this.openCategory.bind(this);
    this.closeCategory = this.closeCategory.bind(this);
    this.handlePercentageChange = this.handlePercentageChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.openShowProductCreated = this.openShowProductCreated.bind(this);
    this.closeShowProductCreated = this.closeShowProductCreated.bind(this);
    this.openPackageType = this.openPackageType.bind(this);
    this.closePackageType = this.closePackageType.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.navigate = this.navigate.bind(this);
    this.saveCurrentModal = this.saveCurrentModal.bind(this);
    this.handleClickNext_1 = this.handleClickNext_1.bind(this);
    this.handleClickPrev_2 = this.handleClickPrev_2.bind(this);
    this.handleClickNext_2 = this.handleClickNext_2.bind(this);
    this.handleClickPrev_3 = this.handleClickPrev_3.bind(this);
    this.closeNavigation = this.closeNavigation.bind(this);
    this.saveProductFormNavigation_3 = this.saveProductFormNavigation_3.bind(this);
    this.handleClickFinish = this.handleClickFinish.bind(this);
    this.selectPackageType = this.selectPackageType.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
  }

  componentWillMount() {
    const { currentProduct } = this.props;

    if (!currentProduct && !this.props.params) {
      this.context.router.push('/products/new');
    }
    if (!currentProduct && this.props.params.id) {
      // this.props.fetchProductDetail(this.props.params.id);
      // alert('no current product');
    }
    if (isSV) {
      fetchGlAccountRecords().then(response => {
        this.setState({
          glAccountData: response.data
        })
      })
    }
    this.getZoneOptions();
    // if (currentProduct) {
    if (isGFD) {
      this.props.fetchDeps();
    }
    if (this.props.params.id) {
      const id = this.props.params.id;
      this.props.fetchCategories2();
      this.getDisplayCategories(id);
      this.props.fetchVendors();
      this.props.fetchGroups();
      // for facex
     if(isFACEX) {
      this.props.fetchProductInventoryBatches(id)
      .then(() => {
        this.setState({
          productInventoryQty: this.props.productInventory.total_quantity,
        });
      });
     }
      // if you open one product and then on the same page open another product (go back or go next) the zone sticks around from product to product
      // if customer changes price or unrelated item and then saves they save the old ZBL data.
      // general product/warehouse inventory search/
      this.setState({ editableProductNum: false });
    } else {
      this.props.fetchCategories2();
      this.props.fetchVendors();
      this.props.fetchGroups();
      if ((isHO || isJRC) && currentProduct===null) {
        this.props.fetchZones(1);
      } else {
        this.props.fetchZones()
      }
      this.props.setDefaultOfForm("PriceType", "weight", "productForm")
      if (isAFG || isMyuMyu || isWecom) {
        this.props.setDefaultOfForm("IsStopSale", "true", "productForm");
        this.props.setDefaultOfForm("IsOverSaleable", "false", "productForm");
      } else {
        this.props.setDefaultOfForm("IsStopSale", "false", "productForm");
        this.props.setDefaultOfForm("IsOverSaleable", "true", "productForm");
      }

      if (isGGI) {
        this.props.setDefaultOfForm("IsOverSaleable", "false", "productForm");
      }

      this.props.setDefaultOfForm("IsMobile", "false", "productForm");
      this.props.setDefaultOfForm("IsDiscontinued", "false", "productForm");
      this.props.setDefaultOfForm("IsWholesaleOnly", "false", "productForm");
      this.props.setDefaultOfForm("InventoryIsMobile", "false", "productForm");
      this.props.setDefaultOfForm("IsRetailPack", "false", "productForm");

      if (isEcity) {
        this.props.setDefaultOfForm("IsTaxable", "true", "productForm");
      } else {
        this.props.setDefaultOfForm("IsTaxable", false, "productForm");
      }
      this.props.setDefaultOfForm("IsAllTaxable", "false", "productForm");
      this.props.setDefaultOfForm("IsNonFood", "false", "productForm");
      this.props.setDefaultOfForm("IsSoldNationwide", "false", "productForm");
      this.props.setDefaultOfForm("IsSyncNuOrder", "false", "productForm");
      this.props.setDefaultOfForm("IsSyncShopify", "false", "productForm");
      this.props.setDefaultOfForm("IsRetailPack", "false", "productForm");
      this.props.setDefaultOfForm("IsCombo", "false", "productForm");
      this.props.setDefaultOfForm("IsGreatDeal", "false", "productForm");
      this.props.setDefaultOfForm("IsNewArrival", "false", "productForm");
      this.props.setDefaultOfForm("IsProposition65", "false", "productForm");
      this.props.setDefaultOfForm("IsSyncToScales", "false", "productForm");
      this.props.setDefaultOfForm("IsSyncToESL", "false", "productForm");
      this.props.setDefaultOfForm("IsAFGChioce", "false", "productForm");
      this.props.setDefaultOfForm("IsAlcohol", "false", "productForm");
      this.props.setDefaultOfForm("IsB2B", "false", "productForm");
      this.props.setDefaultOfForm("IsB2C", "true", "productForm");
      if (isOCM) {
        this.props.setDefaultOfForm("IsOverSaleable", "true", "productForm");
        this.props.setDefaultOfForm("InventoryIsMobile", "true", "productForm");
      }
    }
    if (this.props.location.pathname === "/products/new") {
      this.setState({productNavigationOpen: [true, false]})
    }
    if(isGGI && this.props.selectMarket && this.props.selectMarket != undefined) {
      this.setState({selectedMarketing: this.props.selectMarket})
    }
    if(isGGI && this.props.marketingAll && this.props.marketingAll != undefined) {
      this.setState({marketingAll: this.props.marketingAll})
    }
    this.props.fetchCRVValues();
    this.props.fetchDefaultBuyers();
    this.props.clearAttachedProductImage();
    this.props.fetchPackageTypes();
    this.props.fetchMeasurementUnit();
    // making a leaving hook to confirm leaving
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    if (this.props.params.id) {
      if(isGGI) {
        this.props.fetchMarketInfo();
      }

      setTimeout(() => {
        if (isGGI) {
          let path = location.href
          const lastPart = path.split('/').pop(); 
          this.props.fetchProductDetail(lastPart, this.props.selectedCompany, this.props.selectedWarehouse)
        } else {
          this.props.fetchProductDetail(this.props.params.id, this.props.selectedCompany, this.props.selectedWarehouse)
        }
      }, 1000);

      this.handleFetchCustomerGroups();
    }
    if (isTQ || isMH) {
      this.props.fetchProducts();
    }
    this.props.fetchWarehouses();
  }

  handleFetchCustomerGroups = () => {
    const handleSuccess = (response) => {
      this.setState({ customerList: response.data });
    };

    const handleFailure = (error) => {
      alert(JSON.stringify(error));
    };
    fetchCustomerGroups(handleSuccess, handleFailure);
  }


  changeLevelPrice(priceLevelPercentage, value,) {
    let price = calculatePriceLevelNormal(value, this.props.ProductCost, this.props.ArrivalPrice, this.props.ProductCost);
    const priceLevel = lowerFirst(priceLevelPercentageFieldsMap[upperFirst(priceLevelPercentage)]);
    this.setState({
      [priceLevel]: price,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (isSUN) {
      // if product cost, avg cost, or price mode changes , set the ref price based on RefPriceMode
      if ((prevProps.ProductCost !== this.props.ProductCost) || (prevProps.InStockPrice !== this.props.InStockPrice) || (this.props.RefPriceMode !== prevProps.RefPriceMode)) {
        if (getObjectValue(this.props.RefPriceMode) === refOptions[0].value) {
          // avg_cost
          this.props.setValue('productForm', 'RefPrice', this.props.InStockPrice);
        } else if (getObjectValue(this.props.RefPriceMode) === refOptions[1].value){
          // prod_cost
          this.props.setValue('productForm', 'RefPrice', this.props.ProductCost);
        }
      }

      if (this.props.RefPriceValue !== prevProps.RefPriceValue) {
        this.mapPriceLevelPanel(this.props.RefPriceValue);
      }
    }

    if (isARC && (this.props.RefPriceValue !== prevProps.RefPriceValue)) {
      this.setState({
        priceLv5: this.props.RefPriceValue,
      })
    }
    if (this.props.ProductCost !== prevProps.ProductCost) {
      this.handleProductCostChange();
      if(prevProps.ProductCost !== undefined && isLAP) {
        if (this.props.ProductCost && this.props.ProductCost !== '' && this.props.ProductCost !== '0'){
          this.state.p5Percentage = (0.1/Number(this.props.ProductCost))*100;
        }
        this.props.setValue('productForm', 'LowestSalePrice', this.props.ProductCost * 1.03)
        this.changeLevelPrice('p1Percentage',this.state.p1Percentage);
        this.changeLevelPrice('p2Percentage',this.state.p2Percentage);
        this.changeLevelPrice('p3Percentage',this.state.p3Percentage);
        this.changeLevelPrice('p4Percentage',this.state.p4Percentage);
        this.changeLevelPrice('p5Percentage',this.state.p5Percentage);
      }
    }
    let ConvertNum = this.props.ConvertNum;
    if (!ConvertNum && this.props.currentProductDetail && this.props.currentProductDetail.ConvertNum) {
      ConvertNum = this.props.currentProductDetail.ConvertNum;
    }
    if (this.state.priceLv1 !== prevState.priceLv1) {
      this.setState({
        smallUnitPrice1: getSmallUnitPrice(this.state.priceLv1, ConvertNum),
      })
    }
    if (this.state.priceLv2 !== prevState.priceLv2) {
      this.setState({
        smallUnitPrice2: getSmallUnitPrice(this.state.priceLv2, ConvertNum),
      })
    }
    if (this.state.priceLv3 !== prevState.priceLv3) {
      this.setState({
        smallUnitPrice3: getSmallUnitPrice(this.state.priceLv3, ConvertNum),
      })
    }
    if (this.state.priceLv4 !== prevState.priceLv4) {
      this.setState({
        smallUnitPrice4: getSmallUnitPrice(this.state.priceLv4, ConvertNum),
      })
    }
    if (this.state.priceLv5 !== prevState.priceLv5) {
      this.setState({
        smallUnitPrice5: getSmallUnitPrice(this.state.priceLv5, ConvertNum),
      })
    }
    if (this.state.palletBoxes !== prevState.palletBoxes || this.state.palletLevels !== prevState.palletLevels) {
      if (this.state.palletBoxes && this.state.palletLevels) {
        this.props.setValue('productForm', 'PalletSize', `${this.state.palletBoxes} x ${this.state.palletLevels} = ${this.state.palletBoxes * this.state.palletLevels}`);
      }
    }

  }

  componentWillUnmount() {
    if (this.props.currentProductDetail) {
      this.setState({Product_id: this.props.currentProductDetail.Product_id},
        () => { this.props.setCurrentProduct(this.props.currentProductDetail.Product_id); }
      );
    // this.props.clearSmallProdStatus();
    }
    // this.props.resetZone();
    this.props.resetBins();
  }

  componentWillReceiveProps(nextProps) {
    
    if (isGFD && nextProps.VendorProduct && nextProps.VendorProduct !== this.props.VendorProduct) {
      this.setState({ VendorProducts: nextProps.VendorProduct });
    }
    
    // error messages
    if (nextProps.createError && !this.props.createError) {
      let msg = "Error: ";
      if (JSON.stringify(nextProps.createError).length > 250) {
        msg += JSON.stringify(nextProps.createError).substring(0, 250);
      } else {
        msg += JSON.stringify(nextProps.createError);
      }
      alert(msg);
    }

    if (nextProps.editError && !this.props.editError) {
      let msg = "Error: ";
      // if (JSON.stringify(nextProps.editError).length > 250) {
      //   msg += JSON.stringify(nextProps.editError).substring(0, 250);
      // } else {
        msg += JSON.stringify(nextProps.editError);
      // }
      alert(msg);
    }

    if (nextProps.continueOrDiscontinueProductError && !this.props.continueOrDiscontinueProductError) {
      alert(JSON.stringify(nextProps.continueOrDiscontinueProductError));
    }
    if (nextProps.selectedWarehouse && (nextProps.selectedWarehouse !== this.props.selectedWarehouse)) {
      // const id = this.props.routeParams.id;
      if(isVAK) {
        this.props.fetchVendors()
      }
      const id = this.props.currentProductDetail && this.props.currentProductDetail.Product_id || this.props.routeParams.id;
      if (id) {
        this.props.fetchProductDetail(id, nextProps.selectedCompany, nextProps.selectedWarehouse);
      }
      this.props.fetchZones(nextProps.selectedWarehouse.value || nextProps.selectedWarehouse);
    }

    if (nextProps.continueOrDiscontinueProductSuccess && !this.props.continueOrDiscontinueProductSuccess) {
      this.props.fetchProductDetail(nextProps.currentProductDetail.Product_id, this.props.selectedCompany, this.props.selectedWarehouse);
    }
    if ((this.props.currentProductDetail && this.props.currentProductDetail.Product_id) === (nextProps.currentProductDetail && nextProps.currentProductDetail.Product_id)) {

      if (nextProps.ConvertType && nextProps.ConvertType !== this.props.ConvertType) {
        let convertNum = null;
        if (nextProps.ConvertType === 'weight') {
          convertNum = nextProps.NetWeight;
        } else if (nextProps.ConvertType === 'unit') {
          convertNum = nextProps.PackageSize_1;
        }
        this.props.setValue('productForm', 'ConvertNum', convertNum);
      }
      if (!isHF){
        if (nextProps.PackageSize_1 !== this.props.PackageSize_1) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }
          let packageSize = `${nextProps.PackageSize_1 || ''}${packageType_2}*${nextProps.PackageSize_2 || this.props.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
          let part3MU = `${ (this.props.MeasureUnit_3 && this.props.MeasureUnit_3.value) ? this.props.MeasureUnit_3.value : this.props.MeasureUnit_3}`
          const part3 = `${this.props.PackageSize_3 || ''}${this.props.MeasureUnit_3 ? part3MU : ''}`;
          let packageSizeOCM = `${packageSize}${part3 ? `*${part3}` : part3}`;
          packageSizeOCM = packageSizeOCM.replace("**", "*");
          this.props.setValue('productForm', 'PackageSize', packageSizeOCM);
          if (nextProps.ConvertType === 'unit') {
            this.props.setValue('productForm', 'ConvertNum', nextProps.PackageSize_1);
          }
        }

        if (nextProps.NetWeight !== this.props.NetWeight) {
          if (nextProps.ConvertType === 'weight') {
            this.props.setValue('productForm', 'ConvertNum', nextProps.NetWeight);
          }
        }

        if (nextProps.PackageType_2 !== this.props.PackageType_2) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }

          let packageSize = `${nextProps.PackageSize_1 || this.props.PackageSize_1 || ''}${packageType_2}*${(nextProps.PackageSize_2 && (nextProps.PackageSize_2.value || nextProps.PackageSize_2)) || this.props.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
          // this.props.setValue('productForm', 'PackageSize', packageSize)
          let part3MU = `${ (this.props.MeasureUnit_3 && this.props.MeasureUnit_3.value) ? this.props.MeasureUnit_3.value : this.props.MeasureUnit_3}`
          const part3 = `${this.props.PackageSize_3 || ''}${this.props.MeasureUnit_3 ? part3MU : ''}`;
          let packageSizeOCM = `${packageSize}${part3 ? `*${part3}` : part3}`;
          packageSizeOCM = packageSizeOCM.replace("**", "*");
          this.props.setValue('productForm', 'PackageSize', packageSizeOCM);
        }

        if (nextProps.PackageSize_2 !== this.props.PackageSize_2) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }
          let packageSize = `${nextProps.PackageSize_1 || this.props.PackageSize_1 || ''}${packageType_2}*${nextProps.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }

          let part3MU = `${ (this.props.MeasureUnit_3 && this.props.MeasureUnit_3.value) ? this.props.MeasureUnit_3.value : this.props.MeasureUnit_3}`
          const part3 = `${this.props.PackageSize_3 || ''}${this.props.MeasureUnit_3 ? part3MU : ''}`;
          let packageSizeOCM = `${packageSize}${part3 ? `*${part3}` : part3}`;
          packageSizeOCM = packageSizeOCM.replace("**", "*");
          this.props.setValue('productForm', 'PackageSize', packageSizeOCM);
        }

        if (nextProps.MeasureUnit_2 !== this.props.MeasureUnit_2) {
          let packageType_2 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
          }
          let measureUnit_2 = '';
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
          }
          let packageSize = `${nextProps.PackageSize_1 || this.props.PackageSize_1 || ''}${packageType_2}*${nextProps.PackageSize_2 || this.props.PackageSize_2 || ''}${measureUnit_2}`;
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }

          // this.props.setValue('productForm', 'PackageSize', packageSize);
          let part3MU = `${ (this.props.MeasureUnit_3 && this.props.MeasureUnit_3.value) ? this.props.MeasureUnit_3.value : this.props.MeasureUnit_3}`
          const part3 = `${this.props.PackageSize_3 || ''}${this.props.MeasureUnit_3 ? part3MU : ''}`;
          let packageSizeOCM = `${packageSize}${part3 ? `*${part3}` : part3}`;
          packageSizeOCM = packageSizeOCM.replace("**", "*");
          this.props.setValue('productForm', 'PackageSize', packageSizeOCM);
        }

        if ((nextProps.PackageSize_3 !== this.props.PackageSize_3) || (nextProps.MeasureUnit_3 !== this.props.MeasureUnit_3)) {
          let packageType_2 = '';
          let measureUnit_2 = '';
          let measureUnit_3 = '';
          if (nextProps.PackageType_2) {
            packageType_2 = nextProps.PackageType_2.value || nextProps.PackageType_2
          }
          if (nextProps.MeasureUnit_2) {
            measureUnit_2 = nextProps.MeasureUnit_2.value || nextProps.MeasureUnit_2
          }
          if (nextProps.MeasureUnit_3) {
            measureUnit_3 = nextProps.MeasureUnit_3.value || nextProps.MeasureUnit_3 || ''
          }
          let part3 = `${nextProps.PackageSize_3 || ''}${measureUnit_3}`
          let packageSize = `${nextProps.PackageSize_1 || ''}${packageType_2}*${nextProps.PackageSize_2 || ''}${measureUnit_2 || ''}${part3 ? `*${part3}` : ''}`
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
          if (packageSize[0] === '*') {
            packageSize = packageSize.slice(1);
          }
          packageSize = packageSize.replace("**", "*");
          this.props.setValue('productForm', 'PackageSize', packageSize);
        }
      }

      // Used to have these for Zone-Bin-Level functionality until recently. Leaving them here in case something goes wrong and we have revert to original.
      // if (nextProps.Zone && nextProps.Zone !== this.props.Zone && this.props.Zone !== undefined) {
      //   this.props.setValue('productForm', 'Bin', null);
      //   this.props.setValue('productForm', 'Level', null);
      //   this.props.zones.map( zone => {
      //     if (zone.zone_num === nextProps.Zone) {
      //       this.props.getBinsByZone(zone.id, 1);
      //     }
      //   });
      //   this.props.setValue('productForm', 'Zone', nextProps.Zone.label);
      // }
      // if (nextProps.Zone2 && nextProps.Zone2 !== this.props.Zone2 && this.props.Zone2 !== undefined) {
      //   this.props.setValue('productForm', 'Bin2', null);
      //   this.props.setValue('productForm', 'Level2', null);
      //   this.props.zones.map( zone => {
      //     if (zone.zone_num === nextProps.Zone2) {
      //       this.props.getBinsByZone(zone.id, 2);
      //     }
      //   });
      //   this.props.setValue('productForm', 'Zone2', nextProps.Zone2.label);
      // }
      // if (nextProps.Zone3 && nextProps.Zone3 !== this.props.Zone3 && this.props.Zone3 !== undefined) {
      //   this.props.setValue('productForm', 'Bin3', null);
      //   this.props.setValue('productForm', 'Level3', null);
      //   this.props.zones.map( zone => {
      //     if (zone.zone_num === nextProps.Zone3) {
      //       this.props.getBinsByZone(zone.id, 3);
      //     }
      //   });
      //   this.props.setValue('productForm', 'Zone3', nextProps.Zone3.label);
      // }

      if (nextProps.Zone && nextProps.Zone !== this.props.Zone && typeof nextProps.Zone === 'object') {
        this.props.setValue('productForm', 'Bin', null);
        this.props.setValue('productForm', 'Level', null);

        this.props.zones.map(zone => {
          if (zone.zone_num === nextProps.Zone.label) {
            this.props.getBinsByZone(zone.id, 1);
          }
        });
        this.props.setValue('productForm', 'Zone', nextProps.Zone.value);
      }
      if (nextProps.Zone2 && nextProps.Zone2 !== this.props.Zone2 && typeof nextProps.Zone2 === 'object') {
        this.props.setValue('productForm', 'Bin2', null);
        this.props.setValue('productForm', 'Level2', null);
        this.props.zones.map(zone => {
          if (zone.zone_num === nextProps.Zone2.label) {
            this.props.getBinsByZone(zone.id, 2);
          }
        });
        this.props.setValue('productForm', 'Zone2', nextProps.Zone2.label);
      }
      if (nextProps.Zone3 && nextProps.Zone3 !== this.props.Zone3 && typeof nextProps.Zone3 === 'object') {
        this.props.setValue('productForm', 'Bin3', null);
        this.props.setValue('productForm', 'Level3', null);
        this.props.zones.map(zone => {
          if (zone.zone_num === nextProps.Zone3.label) {
            this.props.getBinsByZone(zone.id, 3);
          }
        });
        this.props.setValue('productForm', 'Zone3', nextProps.Zone3.label);
      }

      if (nextProps.bins && nextProps.bins !== this.props.bins) {
        nextProps.bins.map(bin => {
          if (bin.section_num === this.props.Bin) {
            let foundBin = bin;
            this.props.setValue("productForm", "Bin", foundBin.section_num);
            this.props.getLevelsByBin(foundBin.id, 1);
          }
        });
      }
      if (nextProps.bins2 && nextProps.bins2 !== this.props.bins2) {
        nextProps.bins2.map(bin => {
          if (bin.section_num === this.props.Bin2) {
            let foundBin2 = bin;
            this.props.setValue("productForm", "Bin2", foundBin2.section_num);
            this.props.getLevelsByBin(foundBin2.id, 2);
          }
        });
      }
      if (nextProps.bins3 && nextProps.bins3 !== this.props.bins3) {
        nextProps.bins3.map(bin => {
          if (bin.section_num === this.props.Bin3) {
            let foundBin3 = bin;
            this.props.setValue("productForm", "Bin3", foundBin3.section_num);
            this.props.getLevelsByBin(foundBin3.id, 3);
          }
        });
      }
      if (nextProps.levels && nextProps.levels !== this.props.levels) {
        nextProps.levels.map(level => {
          if (level.bin_num === this.props.Level) {
            this.props.setValue("productForm", "Level", level.bin_num);
          }
        });
      }
      if (nextProps.levels2 && nextProps.levels2 !== this.props.levels2) {
        nextProps.levels2.map(level => {
          if (level.bin_num === this.props.Level2) {
            this.props.setValue("productForm", "Level2", level.bin_num);
          }
        });
      }
      if (nextProps.levels3 && nextProps.levels3 !== this.props.levels3) {
        nextProps.levels3.map(level => {
          if (level.bin_num === this.props.Level3) {
            this.props.setValue("productForm", "Level3", level.bin_num);
          }
        });
      }
      if (nextProps.Bin && nextProps.Bin !== this.props.Bin) {
        this.props.bins.map(bin => {
          if (bin.section_num === nextProps.Bin) {
            this.props.getLevelsByBin(bin.id, 1);
          }
        });
        this.props.setValue('productForm', 'Bin', nextProps.Bin.label);
      }
      if (nextProps.Bin2 && nextProps.Bin2 !== this.props.Bin2) {
        this.props.bins2.map(bin => {
          if (bin.section_num === nextProps.Bin2) {
            this.props.getLevelsByBin(bin.id, 2);
          }
        });
        this.props.setValue('productForm', 'Bin2', nextProps.Bin2.label);
      }
      if (nextProps.Bin3 && nextProps.Bin3 !== this.props.Bin3) {
        this.props.bins3.map(bin => {
          if (bin.section_num === nextProps.Bin3) {
            this.props.getLevelsByBin(bin.id, 3);
          }
        });
        this.props.setValue('productForm', 'Bin3', nextProps.Bin3.label);
      }
      if (nextProps.Level && nextProps.Level !== this.props.Level) {
        this.props.setValue('productForm', 'Level', nextProps.Level.label);
      }
      if (nextProps.Level2 && nextProps.Level2 !== this.props.Level2) {
        this.props.setValue('productForm', 'Level2', nextProps.Level2.label);
      }
      if (nextProps.Level3 && nextProps.Level3 !== this.props.Level3) {
        this.props.setValue('productForm', 'Level3', nextProps.Level3.label);
      }

      if (nextProps.RefPriceValue && nextProps.RefPriceValue !== this.props.RefPriceValue) {
        if(!isEcity) {
          // const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
          // this.setState({
          //   priceLv1,
          //   priceLv2,
          //   priceLv3,
          //   priceLv4,
          //   priceLv5,
          // });
        }
      }
    }

    if (nextProps.convertableProductsFetched && nextProps.convertableProductsFetched !== this.props.convertableProductsFetched && nextProps.convertableProductsFetched.relations.length > 0) {
      const { relations } = nextProps.convertableProductsFetched;
      this.setState({ relatedProducts: relations })
      this.props.setValue('productForm', 'Related_Products', relations);
    }
    if (nextProps.productPartsListFetched && nextProps.productPartsListFetched !== this.props.productPartsListFetched && nextProps.productPartsListFetched.relations.length > 0) {
      const { relations } = nextProps.productPartsListFetched;
      this.setState({
        productParts: {
          ...this.state.productParts,
          rows: relations.filter(product => product.index !== 0)
        }
      });
    }
    if (nextProps.ProductNum && nextProps.ProductNum !== this.props.ProductNum) {
      this.props.fetchConvertableProducts(nextProps.ProductNum);
      if (isVAK) {
        this.props.fetchProductPartsList(nextProps.ProductNum);
      }
      if (isGGI) {
        let path = location.href
        const lastPart = path.split('/').pop();
        if (lastPart !== 'new') {
          const newProductId = nextProps.currentProductDetail.Product_id;
          const newUrl = `/products/${newProductId}`;
          history.replaceState({ userId: newProductId }, '', newUrl);
        }
      }
    }
    if (nextProps.currentProductDetail && nextProps.currentProductDetail !== this.props.currentProductDetail) {
      this.props.zones.map(zone => {
        if (zone.zone_num === nextProps.currentProductDetail.Zone) {
          let foundZone = zone;
          this.props.setValue("productForm", "Zone", foundZone.zone_num);
          this.props.getBinsByZone(foundZone.id, 1);
        }
        if (zone.zone_num === this.props.Zone2) {
          let foundZone2 = zone;
          this.props.setValue("productForm", "Zone2", foundZone2.zone_num);
          this.props.getBinsByZone(foundZone2.id, 2);
        }
        if (zone.zone_num === this.props.Zone3) {
          let foundZone3 = zone;
          this.props.setValue("productForm", "Zone3", foundZone3.zone_num);
          this.props.getBinsByZone(foundZone3.id, 3);
        }
      });
      const productNavigation_1 = {
        ProductDepartment_id: nextProps.currentProductDetail.ProductDepartment_id,
        ProductGroup_id: nextProps.currentProductDetail.ProductGroup_id,
        ProductCategory1_id: nextProps.currentProductDetail.ProductCategory1_id,
        ProductNum: nextProps.currentProductDetail.ProductNum,
        RefNum: nextProps.currentProductDetail.RefNum,
        suggestedProdNum: nextProps.currentProductDetail.ProductNum.substring(4, 7),
        isLinked: false,
        Name: nextProps.currentProductDetail.Name,
        Description: nextProps.currentProductDetail.Description,
        IsLarge: nextProps.currentProductDetail.IsLarge,
        LastDigit: nextProps.currentProductDetail.ProductNum.substring(7, 8),
        isMadePrev: true,
      };

      let {
        P1Percentage: p1Percentage,
        P2Percentage: p2Percentage,
        P3Percentage: p3Percentage,
        P4Percentage: p4Percentage,
        P5Percentage: p5Percentage,
        PriceLv1,
        PriceLv2,
        PriceLv3,
        PriceLv4,
        PriceLv5,
        RefPrice,
      } = nextProps.currentProductDetail;
      const sunPriceLvlsObj = {};
      if (isSUN) {
        sunPriceLvlsObj.priceLevel1Sunsun = (PriceLv1 - RefPrice).toFixed(2);
        sunPriceLvlsObj.priceLevel2Sunsun = (PriceLv2 - RefPrice).toFixed(2);
        sunPriceLvlsObj.priceLevel3Sunsun = (PriceLv3 - RefPrice).toFixed(2);
        sunPriceLvlsObj.priceLevel4Sunsun = (PriceLv4 - RefPrice).toFixed(2);
        sunPriceLvlsObj.priceLevel5Sunsun = (PriceLv5 - RefPrice).toFixed(2);
        // p1Percentage = parseInt(p1Percentage);
        // p2Percentage = parseInt(p2Percentage);
        // p3Percentage = parseInt(p3Percentage);
        // p4Percentage = parseInt(p4Percentage);
        // p5Percentage = parseInt(p5Percentage);
        PriceLv1 = PriceLv1.toFixed(2);
        PriceLv2 = PriceLv2.toFixed(2);
        PriceLv3 = PriceLv3.toFixed(2);
        PriceLv4 = PriceLv4.toFixed(2);
        PriceLv5 = PriceLv5.toFixed(2);
      }
      // const priceLv1 = isEcity ? PriceLv1 : calculatePriceLevelNormal(p1Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv2 = isEcity ? PriceLv2 : calculatePriceLevelNormal(p2Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv3 = isEcity ? PriceLv3 : calculatePriceLevelNormal(p3Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv4 = calculatePriceLevelNormal(p4Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      // const priceLv5 = calculatePriceLevelNormal(p5Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
      const priceLv1 = PriceLv1;
      const priceLv2 = PriceLv2;
      const priceLv3 = PriceLv3;
      const priceLv4 = PriceLv4;
      const priceLv5 = PriceLv5;
      // const smallUnitPrice1 = getSmallUnitPrice(priceLv1, nextProps.currentProductDetail.PackageSize_1);
      // const smallUnitPrice2 = getSmallUnitPrice(priceLv2, nextProps.currentProductDetail.PackageSize_1);
      // const smallUnitPrice3 = getSmallUnitPrice(priceLv3, nextProps.currentProductDetail.PackageSize_1);
      // const smallUnitPrice4 = getSmallUnitPrice(priceLv4, nextProps.currentProductDetail.PackageSize_1);
      // const smallUnitPrice5 = getSmallUnitPrice(priceLv5, nextProps.currentProductDetail.PackageSize_1);
      this.setState({
        p1Percentage: (isEcity) ? calculatePricePercentage(PriceLv1, null, nextProps.ArrivalPrice) : p1Percentage,
        p2Percentage: (isEcity) ? calculatePricePercentage(PriceLv2, null, nextProps.ArrivalPrice) : p2Percentage,
        p3Percentage: (isEcity) ? calculatePricePercentage(PriceLv3, null, nextProps.ArrivalPrice) : p3Percentage,
        p4Percentage: false ? calculatePricePercentage(PriceLv4, null, nextProps.ArrivalPrice) : p4Percentage,
        p5Percentage: false ? calculatePricePercentage(PriceLv5, null, nextProps.ArrivalPrice) : p5Percentage,
        ...sunPriceLvlsObj,
        priceLv1,
        priceLv2,
        priceLv3,
        priceLv4,
        priceLv5,
        // smallUnitPrice1,
        // smallUnitPrice2,
        // smallUnitPrice3,
        // smallUnitPrice4,
        // smallUnitPrice5,
        Product_id: nextProps.currentProductDetail.Product_id,
        productNavigation_1,
        selectedProduct: {
          currentPackageSize: nextProps.currentProductDetail.PackageSize,
          currentProdId: nextProps.currentProductDetail.Product_id,
          currentProdName: nextProps.currentProductDetail.Name,
          currentProdNum: nextProps.currentProductDetail.ProductNum,
          currentProductCRV: nextProps.currentProductDetail.CRV,
          currentProductDescription: nextProps.currentProductDetail.Description,
          currentProductWeight: nextProps.currentProductDetail.NetWeight,
          currentRefNum: nextProps.currentProductDetail.RefNum,
          currentRefPrice: nextProps.currentProductDetail.RefPrice,
          netWeight: nextProps.currentProductDetail.NetWeight,
        },
        ProductSKU: nextProps.currentProductDetail.ProductSKU,
        MixedProduct: nextProps.currentProductDetail.MixedProducts,
        permissionChecked: false,
      });
      if (!nextProps.currentProductDetail.PriceType) {
        switch (nextProps.currentProductDetail.ProductType) {
          case 'Fixed':
            this.props.setValue('productForm', 'PriceType', 'unit')
            break;
          default:
            this.props.setValue('productForm', 'PriceType', 'weight')
        }
      }
      if (nextProps.currentProductDetail.MixedProducts) { //temporary fix for backend
        if (nextProps.currentProductDetail.MixedProducts.length > 0) {
          const mixedProductBaseUnit = {
            value: nextProps.currentProductDetail.MixedProducts[0].Unit,
            label: nextProps.currentProductDetail.MixedProducts[0].Unit,
          }
          this.setState({
            MixedProductBaseUnit: mixedProductBaseUnit,
          });
          this.props.setValue('productForm', 'MixedProductBaseUnit', nextProps.currentProductDetail.MixedProducts[0].Unit);
          this.props.setValue('productForm', 'MixedProduct', nextProps.currentProductDetail.MixedProducts);
        }
      }
      if (nextProps.currentProductDetail.Product_id) {
        this.getDisplayCategories(nextProps.currentProductDetail.Product_id);
      }
    }

    if((isGGI || isOLG || isVAK) && nextProps.ProductType && nextProps.ProductType != this.props.ProductType) {
      if(nextProps.ProductType == 'Non-Fixed' || nextProps.ProductType == 'Per-Pound' || nextProps.ProductType.value && (nextProps.ProductType.value == 'Non-Fixed' || nextProps.ProductType.value == 'Per-Pound')) {
        this.props.setValue('productForm', 'ConvertType', 'weight');
      } else {
        this.props.setValue('productForm', 'ConvertType', 'unit');
      }
    }

    if (nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id !== this.props.Default_Warehouse_id) {
      if (nextProps.Default_Warehouse_id.value)
        // this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
        this.props.fetchWarehouseDetail(this.props.selectedWarehouse ? this.props.selectedWarehouse.value : nextProps.Default_Warehouse_id.value);
    }
    if (nextProps.dirty != this.props.dirty) {
      this.setState({
        dirty: nextProps.dirty
      });
    }
    if (nextProps.ProductDepartment_id && nextProps.ProductDepartment_id !== this.props.ProductDepartment_id) {
      this.props.fetchDepCategories(nextProps.ProductDepartment_id.value || nextProps.ProductDepartment_id);
      if (this.props.ProductDepartment_id) {
        // this cause issue on product change
        // this.props.setValue('productForm', 'ProductGroup_id', null);
        // this.props.setValue('productForm', 'ProductCategory1_id', null);
      }
    }
    if (nextProps.ProductGroup_id && nextProps.ProductGroup_id !== this.props.ProductGroup_id) {
      this.props.fetchGroupCategories(nextProps.ProductGroup_id.value || nextProps.ProductGroup_id);
    }
  
    if (nextProps.initialValues && nextProps.initialValues !== this.props.initialValues) {
      this.props.setValue('productForm', 'GeneralNumber', nextProps.initialValues.GeneralNum);
      this.props.setValue('productForm', 'ProductNumber', nextProps.initialValues.ProductNum);
    }

    // if(!nextProps.currentProduct && nextProps.currentProduct != this.props.currentProduct) {
    //   this.forceUpdate();
    // }

    if (nextProps.smallProductDetail && nextProps.smallProductDetail !== this.props.smallProductDetail) {
      this.props.setValue('productForm', 'SmallNetWeight', nextProps.smallProductDetail.NetWeight);
      // this.props.setValue('productForm', 'SmallFixedWeight', nextProps.smallProductDetail);
      // this.props.setValue('productForm', 'SmallCatchWeight', nextProps.smallProductDetail);
    }

    if (nextProps.productSaved && nextProps.productSaved !== this.props.productSaved) {
      this.setState({
        priceLv1: null,
      }, () => {
        this.openShowProductCreated();
      })
    }

    // if (nextProps.promotionDetails && nextProps.promotionDetails !== this.props.promotionDetails) {
    //   let detailRows = (nextProps.promotionDetails) ? [...nextProps.promotionDetails.Promotion_Line] : [];
    //   let promotionDetails = {...this.state.promotionDetails, rows: detailRows};
    //   this.setState({promotionDetails})
    // }
    if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
      if (nextProps.checkPermissionSuccess.manager) {
        this.closeEditRecPermission();
        this.openProductGroupEdit();
      }
    }

    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      if (this.state.deleteModalOpen === true) {
        this.closeDeleteModal();
        this.props.deleteProduct(this.props.currentProductDetail.Product_id);
      } else {
        this.closeCheckAuthorize();
        this.openProductGroupEdit();
      }
    }
    
    if (nextProps.deleteProductSuccess && nextProps.deleteProductSuccess !== this.props.deleteProductSuccess) {
      // window.history.back();
      this.context.router.push(`/products`);
    }

    if (this.props.currentProductDetail) {
      // this.props.fetchWarehouseDetail(this.props.currentProductDetail.Default_Warehouse_id);
      let id = this.props.selectedWarehouse ? this.props.selectedWarehouse.value : this.props.currentProductDetail.Default_Warehouse_id;
      if (id) {
        this.props.fetchWarehouseDetail(id);
      }
      this.setState({ PackageTypeC: this.props.currentProductDetail.PackageType });
    }

    if(nextProps.ProductCost !== this.props.ProductCost) {
      // let arrivalPrice = Number(nextProps.ProductCost) + ( nextProps.currentProductDetail ? Number(nextProps.currentProductDetail.ShippingFeeUnitPrice) + Number(nextProps.currentProductDetail.MiscUnitPrice) : 0 );
      if(isEcity && !this.state.priceLv1 && nextProps.currentProductDetail) {
        // const p1Percentage = calculatePricePercentage(this.priceLv1.PriceLv1, this.props.RefPriceValue, basePrice)
        // const p2Percentage = calculatePricePercentage(this.priceLv1.PriceLv2, this.props.RefPriceValue, basePrice)
        // const p3Percentage = calculatePricePercentage(this.priceLv1.PriceLv3, this.props.RefPriceValue, basePrice)
        // const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.RefPriceValue, arrivalPrice);
        const priceLv1 = nextProps.currentProductDetail.PriceLv1;
        const priceLv2 = nextProps.currentProductDetail.PriceLv2;
        const priceLv3 = nextProps.currentProductDetail.PriceLv3;
        // const priceLv4 = nextProps.currentProduct.PriceLv4;
        // const priceLv5 = nextProps.currentProduct.PriceLv5;
        this.setState({
          priceLv1,
          priceLv2,
          priceLv3,
          // priceLv4,
          // priceLv5,
        });
      }
      if(!isHMM && !this.state.priceLv1 && nextProps.currentProductDetail && nextProps.currentProductDetail.PriceLv1) {
        // const p1Percentage = calculatePricePercentage(this.priceLv1.PriceLv1, this.props.RefPriceValue, basePrice)
        // const p2Percentage = calculatePricePercentage(this.priceLv1.PriceLv2, this.props.RefPriceValue, basePrice)
        // const p3Percentage = calculatePricePercentage(this.priceLv1.PriceLv3, this.props.RefPriceValue, basePrice)
        // const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, nextProps.RefPriceValue, arrivalPrice);
        // const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.RefPriceValue, arrivalPrice);
        const priceLv1 = nextProps.currentProductDetail.PriceLv1;
        const priceLv2 = nextProps.currentProductDetail.PriceLv2;
        const priceLv3 = nextProps.currentProductDetail.PriceLv3;
        const priceLv4 = nextProps.currentProductDetail.PriceLv4;
        const priceLv5 = nextProps.currentProductDetail.PriceLv5;
        this.setState({
          priceLv1,
          priceLv2,
          priceLv3,
          priceLv4,
          priceLv5,
        });
      }
      if (isLAP) {
        this.props.setValue('productForm', 'RefPrice', nextProps.ProductCost);
      }

      if(isOLG && this.props.ProductCost) {
        let priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.ProductCost);
        const p1Percentage = calculatePricePercentage(this.state.priceLv1, nextProps.ProductCost)
        const p2Percentage = calculatePricePercentage(this.state.priceLv2, nextProps.ProductCost)
        const p3Percentage = calculatePricePercentage(this.state.priceLv3, nextProps.ProductCost)
        const p4Percentage = calculatePricePercentage(this.state.priceLv3, nextProps.ProductCost)
        this.setState({
          priceLv5,
          p1Percentage,
          p2Percentage,
          p3Percentage,
          p4Percentage,
        });
        this.props.setValue('productForm', 'RefPrice', priceLv5);
      }
    }
    if (nextProps.ArrivalPrice !== this.props.ArrivalPrice && this.state.priceLv1 && isEcity) {
      const p1Percentage = calculatePricePercentage(this.state.priceLv1, this.props.RefPriceValue, nextProps.ArrivalPrice)
      const p2Percentage = calculatePricePercentage(this.state.priceLv2, this.props.RefPriceValue, nextProps.ArrivalPrice)
      const p3Percentage = calculatePricePercentage(this.state.priceLv3, this.props.RefPriceValue, nextProps.ArrivalPrice)
      this.setState({
        p1Percentage,
        p2Percentage,
        p3Percentage,
      })
    }

    if (nextProps.ArrivalPrice && nextProps.ArrivalPrice !== this.props.ArrivalPrice && isHMM) {
      const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, this.props.RefPriceValue, nextProps.ArrivalPrice);
      const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, this.props.RefPriceValue, nextProps.ArrivalPrice);
      const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, this.props.RefPriceValue, nextProps.ArrivalPrice);
      const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, this.props.RefPriceValue, nextProps.ArrivalPrice);
      const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, this.props.RefPriceValue, nextProps.ArrivalPrice);
      this.setState({
        priceLv1,
        priceLv2,
        priceLv3,
        priceLv4,
        priceLv5,
      });
    }

    if(nextProps.confirmPasscodeModal.verified) {
      this.setState({
        permissionChecked: true,
      }, () => {
        this.props.setPasscodeVerificationStatus(false);
      })
    }

    if (nextProps.currentProductDetail) {
      const meta_info = {
        meta_title: nextProps.currentProductDetail.meta_title,
        meta_keywords: nextProps.currentProductDetail.meta_keywords,
        meta_description: nextProps.currentProductDetail.meta_description,
      };
      this.setState({ meta_info });

      if (nextProps.currentProductDetail.IsSyncToESL) {
        this.setState({ eslEnabled: true });
      } else {
        this.setState({ eslEnabled: false });
      }
      if (nextProps.currentProductDetail.PalletSize) {
        this.syncPalletSize(nextProps.currentProductDetail.PalletSize)
      }
    }

    if (nextProps.CalcoDispatchCase) {
      this.props.setValue('productForm', 'SmallNetWeight', nextProps.CalcoDispatchCase);
    }
    if (nextProps.CalcoDispatchBag) {
      this.props.setValue('productForm', 'SmallNetWeight', nextProps.CalcoDispatchBa);
    }

    if (nextProps && (nextProps.IsAllTaxable === true || nextProps.IsAllTaxable === 'true')) {
      this.props.setDefaultOfForm("IsTaxable", "true", "productForm");
    }
    // if (!nextProps.DimensionUnit) {
    //   this.props.setValue('productForm', 'DimensionUnit', 'inch');
    // }
    // if ((this.props.selectedCompany !== nextProps.selectedCompany) && nextProps && nextProps.currentProductDetail) {
    //   // if (this.props.selectedCompany !== nextProps.selectedCompany) {
    //   this.props.fetchProductDetail(nextProps.currentProductDetail.Product_id, nextProps.selectedCompany);
    // }
    // if ((this.props.selectedWarehouse !== nextProps.selectedWarehouse && nextProps.selectedWarehouse.value) && this.props.currentProductDetail) {
    //   this.props.fetchProductDetail(nextProps.currentProductDetail.Product_id, this.props.selectedCompany, nextProps.selectedWarehouse);
    // }
    if(isGGI && this.props.selectMarket && this.props.selectMarket != undefined && this.props.selectMarket != nextProps.selectMarket) {
      this.setState({selectedMarketing: nextProps.selectMarket})
    }
    if(isGGI && this.props.marketingAll && this.props.marketingAll != undefined && this.props.marketingAll != nextProps.marketingAll) {
      this.setState({marketingAll: nextProps.marketingAll})
    }
    if(isGGI && nextProps.ConvertNum && nextProps.ConvertNum != this.props.ConvertNum) {
      const smallUnitPrice1 = getSmallUnitPrice(this.state.priceLv1, nextProps.ConvertNum);
      const smallUnitPrice2 = getSmallUnitPrice(this.state.priceLv2, nextProps.ConvertNum);
      const smallUnitPrice3 = getSmallUnitPrice(this.state.priceLv3, nextProps.ConvertNum);
      const smallUnitPrice4 = getSmallUnitPrice(this.state.priceLv4, nextProps.ConvertNum);
      const smallUnitPrice5 = getSmallUnitPrice(this.state.priceLv5, nextProps.ConvertNum);
      this.setState({
        smallUnitPrice1,
        smallUnitPrice2,
        smallUnitPrice3,
        smallUnitPrice4,
        smallUnitPrice5,
      })
    }
  }

  calculatePriceLevels = (refPrice) => {
    let priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, refPrice);
    let priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, refPrice);
    let priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, refPrice);
    let priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, refPrice);
    let priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, refPrice);
    const sunPriceObj = {
      priceLevel1Sunsun: (priceLv1 - refPrice).toFixed(2),
      priceLevel2Sunsun: (priceLv2 - refPrice).toFixed(2),
      priceLevel3Sunsun: (priceLv3 - refPrice).toFixed(2),
      priceLevel4Sunsun: (priceLv4 - refPrice).toFixed(2),
      priceLevel5Sunsun: (priceLv5 - refPrice).toFixed(2),
    }
    this.setState({
      priceLv1,
      priceLv2,
      priceLv3,
      priceLv4,
      priceLv5,
      ...sunPriceObj,
    })
  }

  calcualtePercentages = (refPrice) => {
    const {
      priceLevel1Sunsun,
      priceLevel2Sunsun,
      priceLevel3Sunsun,
      priceLevel4Sunsun,
      priceLevel5Sunsun,
      priceLv1,
      priceLv2,
      priceLv3,
      priceLv4,
      priceLv5,
    } = this.state;

    const newPriceLv1 = (parseFloat(refPrice) + parseFloat(priceLevel1Sunsun)).toFixed(2);
    const newPriceLv2 = (parseFloat(refPrice) + parseFloat(priceLevel2Sunsun)).toFixed(2);
    const newPriceLv3 = (parseFloat(refPrice) + parseFloat(priceLevel3Sunsun)).toFixed(2);
    const newPriceLv4 = (parseFloat(refPrice) + parseFloat(priceLevel4Sunsun)).toFixed(2);
    const newPriceLv5 = (parseFloat(refPrice) + parseFloat(priceLevel5Sunsun)).toFixed(2);

    const sunPriceObj = {
      priceLv1: newPriceLv1,
      priceLv2: newPriceLv2,
      priceLv3: newPriceLv3,
      priceLv4: newPriceLv4,
      priceLv5: newPriceLv5,
    }
    const p1Percentage = calculatePricePercentage(newPriceLv1, refPrice);
    const p2Percentage = calculatePricePercentage(newPriceLv2, refPrice);
    const p3Percentage = calculatePricePercentage(newPriceLv3, refPrice);
    const p4Percentage = calculatePricePercentage(newPriceLv4, refPrice);
    const p5Percentage = calculatePricePercentage(newPriceLv5, refPrice);
  
    this.setState({
      p1Percentage,
      p2Percentage,
      p3Percentage,
      p4Percentage,
      p5Percentage,
      ...sunPriceObj,
    })
  }

  mapPriceLevelPanel = (refPrice) => {
    if (this.props.LevelType === 'Fixed') {
      this.calcualtePercentages(refPrice);
    } else {
      this.calculatePriceLevels(refPrice)
    }
  }


  handleProductCostChange = () => {
    if (!isARC) return;
    this.handlePriceChange("priceLv1", { target: { value: this.state.priceLv1 }});
    this.handlePriceChange("priceLv2", { target: { value: this.state.priceLv2 }});
    this.handlePriceChange("priceLv3", { target: { value: this.state.priceLv3 }});
    this.handlePriceChange("priceLv4", { target: { value: this.state.priceLv4 }});
    this.handlePriceChange("priceLv5", { target: { value: this.state.priceLv5 }});
  }

  ESLCheckbox = props => {
    return (
      <input
        {...props.input}
        type="checkbox"
        value={!props.input.value ? "true" : "false"}
        checked={props.input.value === true || props.input.value === "true"}
        disabled={props.disabled}
        onClick={(e)=>this.handleESLCheckbox(e)}
      />
    );
  }

  syncPalletSize = palletSize => {
    if (isOCM) {
      const matches = palletSize.match(/^([^\s|x|×\*]+)\s?[x|×|\*]\s?([^\s|=]+)\s?=\s?(\d+)$/i);
      if (matches) {
        this.setState({
          palletBoxes: +matches[1],
          palletLevels: +matches[2],
        });
      }
    }
  }

  handleESLCheckbox(e) {
    let productId = this.props.currentProductDetail.Product_id;
    if (e.target.value === 'true' || e.target.value === true) {
      this.props.initializeESL(productId)
        .then((response) => {
          this.setState({ eslEnabled: true });
        }, (err) => {
          alert("ESL Error: " + err.data);
          this.props.setValue('productForm', 'IsSyncToESL', 'false')
        });
    }
    if (e.target.value === 'false' || e.target.value === false) {
      this.props.deleteESL(productId)
        .then((response) => {
          this.setState({ eslEnabled: false });
        }, (err) => {
          alert("ESL Error: " + err.data);
          this.props.setValue('productForm', 'IsSyncToESL', 'true')
        });
    }
  }

  //Get Display Categories
  getDisplayCategories = (id) => {
    this.props.fetchDisplayCategories(id).then(() => {
      if (this.props.display_categories) {
        // this.state.displayCategories = this.props.display_categories;
        this.setState({displayCategories: this.props.display_categories});
      }
    });
  }

  //Mix Product Search
  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  // Helper function of popups
  closeDeleteModal() { this.setState({ deleteModalOpen: false }); }
  openDeleteModal() {
    this.setState({ deleteModalOpen: true });
    this.props.clearCheckPassword();
  }
  openVendor() { this.setState({ vendorOpen: true }); }
  closeVendor() { this.setState({ vendorOpen: false }); }
  openGroup() { this.setState({ groupOpen: true }); }
  closeGroup() { this.setState({ groupOpen: false }); }
  openCategory() { this.setState({ categoryOpen: true }); }
  closeCategory() { this.setState({ categoryOpen: false }); }
  openShowProductCreated() { this.setState({ showProductCreatedOpen: true }); }
  closeShowProductCreated() { this.setState({ showProductCreatedOpen: false }); }
  closeNavigation() { this.setState({ productNavigationOpen: []}); }
  openPackageType() { this.setState({ packageTypeOpen: true }); }
  closePackageType() { this.setState({ packageTypeOpen: false }); }

  updateSKU = (newSkus) => {
    this.setState({
      ProductSKU: newSkus,
    });
    this.closeSkusModal();
  }

  openMobileDescBox = () => {
    this.setState({ mobileDescBoxOpen: true });
  }

  openDisplayCategoryBox = () => {
    this.setState({ displayCategoryBoxOpen: true });
  }

  openSkusModal = () => {
    this.setState({ skusModal: true });
  }

  closeSkusModal = () => {
    this.setState({ skusModal: false });
  }

  openMarketingModal = () => {
    this.setState({ marketingModal: true });
  }

  updateMarketSelect= (id, check) => {
    let stList = [...this.state.marketingAll]
    stList.map((item)=>{
      if(item.id == id) {
        item.checked = check;
      }
    })
    if(check) {
      this.setState({
        selectedMarketing: [...this.state.selectedMarketing, id],
        marketingAll:stList,
      })
    } else {
      let checkedList = [];
      this.state.selectedMarketing.map((item)=>{
        if(item != id) {
          checkedList.push(item);
        }
      })
      this.setState({
        selectedMarketing: checkedList,
        marketingAll:stList,
      })
    }
  }

  closeMarketingModal = () => {
    this.setState({ marketingModal: false});
  }

  closeMobileDescBox = () => {
    this.setState({ mobileDescBoxOpen: false });
  }

  closeDisplayCategoryBox = () => {
    this.setState({ displayCategoryBoxOpen: false });
  }

  openAddConvertProducts = () => {
    this.setState({ addConvertProductsOpen: true });
  }

  closeAddConvertProducts = () => {
    this.setState({ addConvertProductsOpen: false });
  }

  openImageModal = () => {
    this.setState({ imagesModalOpen: true });
  }

  closeImageModal = () => {
    this.setState({ imagesModalOpen: false });
  }

  openProductGroupEdit = () => {
    this.setState({ editProductGroup: true });
  }
  closeProductGroupEdit = () => {
    this.setState({ editProductGroup: false });
  }

  openESLModal = () => {
    this.setState({ eslModalVisibility: true });
  }
  closeESLModal = () => {
    this.setState({ eslModalVisibility: false });
  }
  
  openScaleLabelModal = () => {
    this.setState({ scaleLabelModalVisibility: true });
  }
  closeScaleLabelModal = () => {
    this.setState({ scaleLabelModalVisibility: false });
  }

  openEditRecPermission = (editGroupFormAction = 'changeGroup'/* for moving products to other groups */) => {
    this.setState({
      case: 'editRecPermission',
      editRecPermissionOpen: true,
      editGroupFormAction,
    });
  }

  checkAuthorize = (password) => {
    this.props.checkPassword(password);
  }

  openCheckAuthorize = (editGroupFormAction) => {
    this.props.clearCheckPassword();
    this.setState({
      checkAuthorizeOpen: true,
      editGroupFormAction,
    });
  }

  closeCheckAuthorize = () => {
    this.setState({
      checkAuthorizeOpen: false
    });
  }

  closeEditRecPermission = () => {
    this.setState({ editRecPermissionOpen: false });
  }

  selectPackageType(row) {
    this.props.setValue("productForm", 'PackageType_2', row.Simple);
    this.closePackageType();
  }

  handleFetchPromotionDetails = (productId) => {
    const handleSuccess = (response) => {
      const promotionDetails = { ...this.state.promotionDetails, rows: response.data.promotions };
      this.setState({
        promotionDetailsIsLoading: false,
        promotionDetails,
      });
    }

    const handleFailure = (error) => {
      this.setState({ promotionDetailsIsLoading: false }, () => {
        alert(JSON.stringify(error));
      });
    }

    this.setState({ promotionDetailsIsLoading: true }, () => {
      fetchPromoDetailsByProduct(productId, handleSuccess, handleFailure);
    });
  }

  handleMobileDescBoxClick = () => {
    const handleSuccess = (response) => {
      this.setState({
        isLoadingMobileDescBoxText: false,
        mobileDescriptionHTML: response.data.rich_text_description,
      }, () => {
        this.openMobileDescBox();
      });
    };
    const handleFailure = (err) => {
      this.setState({ isLoadingMobileDescBoxText: false }, () => {
        alert(JSON.stringify(err));
      });
    };
    this.setState({ isLoadingMobileDescBoxText: true }, () => {
      fetchMobileDescriptionBoxText(this.props.currentProductDetail.Product_id, handleSuccess, handleFailure);
    });
  }

  handleDisplayCategoryBoxClick = () => {
    this.openDisplayCategoryBox();
  }

  handleSkusClick = () => {
    this.openSkusModal();
  }
  handleMarketingClick = () => {
    this.openMarketingModal();
  }

    handleClickFinish(productNavigation_3) {
      let packageSize = `${this.state.productNavigation_2.PackageSize_1 || ""}
      ${(this.state.productNavigation_2.PackageType_2 && this.state.productNavigation_2.PackageType_2.value) || ""}
      *${this.state.productNavigation_2.PackageSize_2 || ""}
      ${(this.state.productNavigation_2.MeasureUnit_2 && this.state.productNavigation_2.MeasureUnit_2.value) || ""}`;
      if(packageSize[0] == '*') {
        packageSize = packageSize.slice(1);
      }
      let netWeightUnit = this.state.productNavigation_2.NetWeight_2 && this.state.productNavigation_2.NetWeight_2.value;
      let netWeight = parseFloat(this.state.productNavigation_2.NetWeight_1) || 0;
      if(netWeightUnit == "kg") {
        netWeight = 2.20462 * netWeight;
      }
      let diffWeight = 0;
      if(this.state.productNavigation_2.ProdType && this.state.productNavigation_2.ProdType.value == "Non-Fixed") {
        if(netWeight > 10) {
          diffWeight = 10;
        }
        else if(netWeight > 0) {
          diffWeight = 5;
        }
      }

      let convertNum = null;
      if(productNavigation_3.ConvertType === "weight") {
        convertNum = netWeight
      }
      else if (productNavigation_3.ConvertType === "unit") {
        convertNum = this.state.productNavigation_2.PackageSize_1
      }
      this.props.setValue('productForm', 'ProductDepartment_id', this.state.productNavigation_1.ProductDepartment_id)
      this.props.setValue('productForm', 'ProductGroup_id', this.state.productNavigation_1.ProductGroup_id)
      this.props.setValue('productForm', 'ProductCategory1_id', this.state.productNavigation_1.ProductCategory1_id)
      this.props.setValue('productForm', 'Name', this.state.productNavigation_1.Name)
      if (isGFD) {
        this.props.setValue('productForm', 'RefNum', this.state.productNavigation_1.RefNum)
      }
      if (isWIZ) {
        this.props.setValue('productForm', 'RefNum', this.state.productNavigation_1.Name)
      }
      this.props.setValue('productForm', 'Description', this.state.productNavigation_1.Description)
      this.props.setValue('productForm', 'ProductNum', this.state.productNavigation_1.ProductNum)
      this.props.setValue('productForm', 'IsRelated', this.state.productNavigation_1.isLinked.toString())
      this.props.setValue('productForm', 'IsLarge', this.state.productNavigation_1.IsLarge)

      this.props.setValue('productForm', 'ProductType', this.state.productNavigation_2.ProdType)
      this.props.setValue('productForm', 'PackageType', this.state.productNavigation_2.PackageType)
      this.props.setValue('productForm', 'PackageSize', packageSize)
      this.props.setValue('productForm', 'PackageSize_1', this.state.productNavigation_2.PackageSize_1)
      this.props.setValue('productForm', 'PackageType_2', this.state.productNavigation_2.PackageType_2)
      this.props.setValue('productForm', 'PackageSize_2', this.state.productNavigation_2.PackageSize_2)
      this.props.setValue('productForm', 'MeasureUnit_2', this.state.productNavigation_2.MeasureUnit_2)
      this.props.setValue('productForm', 'MeasureUnit', this.state.productNavigation_2.NetWeight_2);
      this.props.setValue('productForm', 'NetWeight', netWeight);
      this.props.setValue('productForm', 'ShippingWeight', netWeight);

      this.props.setValue('productForm', 'MinWeightRange', Math.max(0, netWeight-diffWeight));
      this.props.setValue('productForm', 'MaxWeightRange', netWeight+diffWeight);
      if (isOLG) {
        this.props.setValue('productForm', 'ProductCost', this.state.productNavigation_2.ProductCost);
      }
      this.props.setValue('productForm', 'RefPrice', this.state.productNavigation_2.RefPrice)
      this.props.setValue('productForm', 'LowestSalePrice', this.state.productNavigation_2.LowestSalePrice)

      this.props.setValue('productForm', 'ConvertNum', convertNum)
      this.props.setValue('productForm', 'SmallProdType', productNavigation_3.SmallProdType)
      this.props.setValue('productForm', 'SmallPackageType', productNavigation_3.SmallPackageType)
      this.props.setValue('productForm', 'ConvertType', productNavigation_3.ConvertType)
      this.props.setValue('productForm', 'ActualNW', 100)
      if (isVAK) {
        this.props.setValue('productForm', 'GeneralNum', productNavigation_3.GeneralNum)
      }
      // break points
      const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
      // const smallUnitPrice1 = getSmallUnitPrice(priceLv1, this.props.PackageSize_1);
      // const smallUnitPrice2 = getSmallUnitPrice(priceLv2, this.props.PackageSize_1);
      // const smallUnitPrice3 = getSmallUnitPrice(priceLv3, this.props.PackageSize_1);
      // const smallUnitPrice4 = getSmallUnitPrice(priceLv4, this.props.PackageSize_1);
      // const smallUnitPrice5 = getSmallUnitPrice(priceLv5, this.props.PackageSize_1);
      this.setState({
        priceLv1,
        priceLv2,
        priceLv3,
        priceLv4,
        priceLv5,
        // smallUnitPrice1,
        // smallUnitPrice2,
        // smallUnitPrice3,
        // smallUnitPrice4,
        // smallUnitPrice5,
      })
    }

    handleOnFocus(event) {
      event.target.select();
    }

    getFormattedGLOptions = () => {
      return (this.state.glAccountData || []).map(item => ({label: item.Name, value: item.id, level: item.level}))
    }

    onDrop(files) {
      // this.props.attachProductImage(this.props.currentProduct.Product_id, files);
      this.setState({
          files: files
      });
    }

    onOpenClick() {
      this.props.clearAttachedProductImage();
      // this.refs.dropzone.open();
    }

    title() {
      if (!this.props.params.id) {
        return <h3><Translate value="create_a_new_product"/></h3>
      }
      return <h3><Translate value="edit_product"/>{this.props.currentProduct.Name}</h3>
    }

    navigate(page) {
      let productNavigationOpen = [...this.state.productNavigationOpen];
      productNavigationOpen = productNavigationOpen.map(r => {
        return false
      })
      productNavigationOpen[page] = true;
      this.setState({productNavigationOpen});
    }

    saveCurrentModal(ProductDepartment_id, ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum, RefNum) {
      let productNavigation_1 = {...this.state.productNavigation_1, ProductCategory1_id, ProductGroup_id, ProductDepartment_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum, RefNum}
      this.setState({productNavigation_1})
    }

    handleClickNext_1(ProductDepartment_id, ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum, RefNum) {
      this.saveCurrentModal(ProductDepartment_id, ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum, RefNum);
      this.navigate(1);
    }

    handleClickPrev_2(
      ProdType,
      PackageType,
      PackageSize_1,
      PackageType_2,
      PackageSize_2,
      MeasureUnit_2,
      NetWeight_1,
      NetWeight_2,
      ProductCost,
      RefPrice,
      LowestSalePrice,
    ) {
      let productNavigation_2 = {
        ...this.state.productNavigation_2,
        ProdType,
        PackageType,
        PackageSize_1,
        PackageType_2,
        PackageSize_2,
        MeasureUnit_2,
        NetWeight_1,
        NetWeight_2,
        RefPrice,
        LowestSalePrice,
      }
      if (isOLG) {
        productNavigation_2.ProductCost = ProductCost
      }
      this.setState({ productNavigation_2 })
      this.navigate(0);
    }

    handleClickNext_2(
      ProdType,
      PackageType,
      PackageSize_1,
      PackageType_2,
      PackageSize_2,
      MeasureUnit_2,
      NetWeight_1,
      NetWeight_2,
      ProductCost,
      RefPrice,
      LowestSalePrice,
    ) {
      let productNavigation_2 = {
        ...this.state.productNavigation_2,
        ProdType,
        PackageType,
        PackageSize_1,
        PackageType_2,
        PackageSize_2,
        MeasureUnit_2,
        NetWeight_1,
        NetWeight_2,
        RefPrice,
        LowestSalePrice,
      }
      if (isOLG) {
        productNavigation_2.ProductCost = ProductCost
      }
      // this.setState({ productNavigation_2 });
      this.setState({ productNavigation_2 }, () => {
        if (!isHMM) {
          if (isVAK) {
            let convertType = null;
            if (ProdType.value === 'Fixed') {
              convertType = 'unit';
            }
            if (ProdType.value === 'Non-Fixed') {
              convertType = 'weight';
            }
            this.setState({
              productNavigation_3: {
                ...this.state.productNavigation_3,
                ConvertType: convertType
              }
            });
          }
          this.navigate(2);
        } else {
          this.saveProductFormNavigation_3(1, null, null, "unit");
          this.closeNavigation();
        }
      });
    }

    handleClickPrev_3(
      ConvertNum,
      SmallProdType,
      SmallPackageType,
      ConvertType,
      GeneralNum,
    ) {
      this.saveProductFormNavigation_3(
        ConvertNum,
        SmallProdType,
        SmallPackageType,
        ConvertType,
        GeneralNum,
      )
      this.navigate(1);
    }

    saveProductFormNavigation_3(
      ConvertNum,
      SmallProdType,
      SmallPackageType,
      ConvertType,
      GeneralNum,
    ) {
      let productNavigation_3 = {
        ...this.state.productNavigation_3,
        ConvertNum,
        SmallProdType,
        SmallPackageType,
        ConvertType,
        GeneralNum,
      }
      this.setState({ productNavigation_3 })
      this.handleClickFinish(productNavigation_3);
    }

    saveRichText(htmlText) {
      const { Product_id } = this.props.currentProductDetail;
      this.props.saveMobileDescriptionBoxText(Product_id, htmlText);
    }

    handleKeyPress(value, event){
      if (event.charCode == 13){
        event.preventDefault()
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    handleAutoConvertClick = (product) => {
      const relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      lodashMap(relatedProducts, (relatedProduct) => {
        relatedProduct.auto_convert = false;
      });
      relatedProducts[product.index].auto_convert = !this.state.relatedProducts[product.index].auto_convert;
      this.setState({ relatedProducts });
    }

    handleRelatedProductDelete = (productToRemove) => {
      let relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      relatedProducts = lodashFilter(relatedProducts, product => product.index !== productToRemove.index);
      lodashMap(relatedProducts, (product, index) => {
        product.index = index;
      });
      this.setState({ relatedProducts });
    }

    handleAddConvertProductClick = () => {
      const handleSuccess = (response) => {
        this.setState({
          isLoadingCategoryProducts: false,
          categoryProducts: response.data,
        }, this.openAddConvertProducts);
      };

      const handleFailure = (error) => {
        this.setState({ isLoadingCategoryProducts: false });
        alert(JSON.stringify(error));
      };

      const { currentProductDetail } = this.props;
      const { productNavigation_1 } = this.state;
      if ((currentProductDetail && currentProductDetail.ProductCategory1_id)
        || (productNavigation_1 && productNavigation_1.ProductCategory1_id.value)
      ) {
        this.setState({ isLoadingCategoryProducts: true }, () => {
          const productCategoryId = (currentProductDetail) ? currentProductDetail.ProductCategory1_id : productNavigation_1.ProductCategory1_id.value
          // const vakkerCombinationFlag = isVAK
          this.props.fetchProductsByCategory(productCategoryId, handleSuccess, handleFailure, true);
        });
      }
    }

    // modifyConvertableProductList = (product) => {
    //   let relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
    //   const existingProduct = lodashFind(this.state.relatedProducts, relatedProduct => relatedProduct.ProductNum === product.ProductNum);
    //   if (existingProduct) {
    //     relatedProducts = lodashFilter(relatedProducts, relatedProduct => relatedProduct.ProductNum !== existingProduct.ProductNum);
    //   } else {
    //     const newProduct = {
    //       PackageSize: product.PackageSize,
    //       ProductType: product.ProductType,
    //       ProductNum: product.ProductNum,
    //       Product_id: product.Product_id,
    //       auto_convert: false,
    //       index: relatedProducts.length,
    //     };
    //     relatedProducts.push(newProduct);
    //   }
    //   this.setState({ relatedProducts });
    // }

    modifyConvertableProductList = (product) => {
      let relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      const existingProduct = lodashFind(this.state.relatedProducts, relatedProduct => relatedProduct.ProductNum === product.ProductNum);
      if (existingProduct) {
        relatedProducts = lodashFilter(relatedProducts, relatedProduct => relatedProduct.ProductNum !== existingProduct.ProductNum);
      } else {
        const newProduct = (isABBLE || isSV || isEKC || isLMH || isSDR || isCRW || isSC || isVAK || isOLG || isAGD) ? {
          PackageSize: product.PackageSize,
          ProductType: product.ProductType,
          PackageType: product.PackageType,
          ProductNum: product.ProductNum,
          Product_id: product.Product_id,
          auto_convert: false,
          ConvertNum: 1,
          RefNum: product.RefNum,
          index: relatedProducts.length,
        } : {
          PackageSize: product.PackageSize,
          ProductType: product.ProductType,
          ProductNum: product.ProductNum,
          Product_id: product.Product_id,
          auto_convert: false,
          index: relatedProducts.length,
        };
        relatedProducts.push(newProduct);
      }
      this.setState({ relatedProducts });
    }


    // Mix Products Render
    renderMixedProduct() {
      const packageTypeOptions = this.getPackageTypeOptions();
      return (
        <FieldArray name="MixedProduct" component={renderMixProductArrays} suggestProduct={this.state.suggestProduct} packageTypeOptions={packageTypeOptions}/>
      )
    }

    // Render the vendor, group and category options dynamically with the information
    // on the server.

    renderVendors() {
      if (this.props.vendorIsLoading) return <Spinner/> // If vendor is loading, show a spinner.
      const vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
      const vendorNumOptions = this.getVendorNumOptions();
      return (
        <FieldArray name="Vendors" component={renderVendorArrays} openVendor={this.openVendor} vendorNumOptions={vendorNumOptions} vendorNameOptions={vendorNameOptions} />
      )
    }
    
    renderVendorAssociateds() {
      const vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
      const vendorNumOptions = this.getVendorNumOptions();
      // saved ans set is_delete to true and saved with VendorProduct on save
      const handleRemove = (vendor) => {
        this.setState( prevState => ({
          removeVendorProducts: [...prevState.removeVendorProducts, vendor]
        }));
      }
      return (
        <FieldArray
          name="VendorProduct"
          component={renderVendorAccociatedArrays}
          handleRemove={handleRemove}
          vendorNumOptions={vendorNumOptions}
          vendorNameOptions={vendorNameOptions}
          vendorProducts={this.state.VendorProducts}
        />
      )
    }

    handleConvertInput = (product, e) => {
      const relatedProducts = JSON.parse(JSON.stringify(this.state.relatedProducts));
      relatedProducts[product.index].ConvertNum = +e;
      this.setState({ relatedProducts });
    }


   WebDisplayCheckbox = props => {
      return (
        <input
          {...props.input}
          type="checkbox"
          value={!props.input.value ? "true" : "false"}
          checked={props.input.value === true || props.input.value === "true" || props.isLarge}
          disabled={props.disabled}
          onChange={()=>{
            if(this.state.isFirst) {
              this.setState({isFirst: false})
            }
          }}
        />
      );
    }

    renderBigPrd() {
      if(!isOLG) return null
      return <Row>
      <Col xs={12}>
        <div className="form-group">
          <label className="col-xs-5"><Translate value="big_prd" /></label>
          <div className="col-xs-7 convert-prod-qty">
            <Field name="IsWebDisplay" isLarge={(this.state.productNavigation_1.IsLarge === 'true' || this.state.productNavigation_1.IsLarge === true) && this.state.isFirst && this.context.router.routes && this.context.router.routes.length > 1 && this.context.router.routes[1].path == 'products/new'}
            component={(props) => {
              return (
                <input
                  {...props.input}
                  type="checkbox"
                  value={!props.input.value ? "true" : "false"}
                  checked={props.input.value === true || props.input.value === "true" || props.isLarge}
                  disabled={props.disabled}
                  onChange={(event)=>{
                    if(props.isLarge) {
                      this.setState({isFirst: false}, () => {
                        props.input.onChange(event)
                       })
                       return
                    }
                    props.input.onChange(event)
                  }}
                />
              );
            }} />
          </div>
        </div>
      </Col>
    </Row>
    }

    renderConvertDetails() {
      if (this.state.productNavigationOpen[2] === true) {
        return <div />
      }
      const { relatedProducts, productNavigation_1, productNavigation_2 } = this.state;
      let currentProductNum;
      let currentRefNum;
      let currentPackageSize;
      let currentProductType;
      const isCreate = (!this.props.params.id);
      if (isCreate) {
        if (!productNavigation_1.ProductNum
          || !productNavigation_1.RefNum
          || !productNavigation_2.PackageSize_1
          || !productNavigation_2.PackageSize_2
          || !productNavigation_2.PackageType_2
          || !productNavigation_2.MeasureUnit_2
        ) {
          return <div />;
        }
        currentProductNum = productNavigation_1.ProductNum;
        currentRefNum = productNavigation_1.RefNum;
        currentPackageSize = `${productNavigation_2.PackageSize_1}${productNavigation_2.PackageType_2.value}*${productNavigation_2.PackageSize_2}${productNavigation_2.MeasureUnit_2.value}`;
        currentProductType = productNavigation_2.ProdType.value;
      } else if (relatedProducts.length > 0) {
        currentProductNum = relatedProducts[0].ProductNum;
        currentRefNum = relatedProducts[0].RefNum;
        currentPackageSize = relatedProducts[0].PackageSize;
        currentProductType = relatedProducts[0].ProductType;
      }
      if (this.props.fetchingConvertableProducts && !this.props.convertableProductsFetchError) {
        return <Spinner />;
      }
      return (
        (relatedProducts.length > 0) &&
          <div>
            {
              lodashMap(relatedProducts, (product, index) => (
                (index === 0)
                  ? (
                    <div key={index}>
                      <div className="related-products-heading1">
                        <div className="related-products-current">
                          <span>{ (isABBLE || isSV || isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isAGD) ? currentRefNum : currentProductNum }</span>
                          <span>{ currentPackageSize }</span>
                        </div>
                        <div className="related-products-heading2">
                          <span>{ currentProductType }</span>
                          <SpinnerButton
                            className="related-products-link-product"
                            bsStyle="primary"
                            icon="fa-plus"
                            onClick={this.handleAddConvertProductClick}
                            disabled={this.state.isLoadingCategoryProducts}
                            loading={this.state.isLoadingCategoryProducts}
                          />
                        </div>
                      </div>
                      <hr style={{ borderTopColor: '#000' }} />
                    </div>
                  ) : (
                    <div key={index} className="related-products">
                      <div>
                        <span>{ (isABBLE || isSV || isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isAGD) ? product.RefNum : product.ProductNum }</span>
                      </div>
                      { isVAK &&
                        <div>
                         <span>{ product.RefNum }</span>
                       </div>
                      }
                      {
                        !(isEKC || isLMH || isSDR || isCRW || isSC || isVAK) &&
                        <div>
                          <span style={{display: 'inline-block', textOverflow: 'ellipsis', paddingTop: '5px', overflow: 'hidden', whiteSpace: 'nowrap', width: "70px"}}>{ product.PackageSize }</span>
                        </div>
                      }
                      <div className="related-products-auto-convert">
                        {
                          (isABBLE || isSV || isEKC || isLMH || isSDR || isCRW || isSC || isVAK || isAGD) &&  <input
                            type="text"
                            style={{border: '1px solid black', width: '50px', marginRight: '12px', paddingLeft: '5px'}}
                            name="link-product"
                            value={product.ConvertNum}
                            onChange={(e) => {
                              this.handleConvertInput(product, e.target.value)
                            }}
                          />
                        }
                        { isVAK &&
                          <div style={{width: '23px', marginRight: '10px'}}>
                            <span>{ product.PackageType }</span>
                          </div>
                        }
                        <span>{ product.ProductType }</span>
                        {!(isOLG || isVAK) && <div className="auto-convert-block">
                          <input
                            type="checkbox"
                            name="link-product"
                            checked={product.auto_convert}
                            onClick={() => this.handleAutoConvertClick(product)}
                          />
                          <span><Translate value="auto" /></span>
                        </div>}
                        <Button
                          className="related-products-link-product"
                          bsStyle="danger"
                          onClick={() => this.handleRelatedProductDelete(product)}
                        >
                          <em className="fa fa-trash" />
                        </Button>
                      </div>
                    </div>
                  )
              ))
            }
          </div>
      );
      // return (
      //     <FieldArray name="Related_Products" component={renderConvertDetailsList} />
      // )
    }

    renderSearchStatus() {
      if (this.props.smallProductDetailIsLoading) return <Col xs={2}><Spinner/></Col>
      else if (this.props.smallProductDetailError || (this.props.smallProductDetail && this.props.smallProductDetail.length == 0)) {
        return (
          <Col xs={2}>
            <i className="fa fa-times alert alert-danger" />
          </Col>
        )
      } else if (this.props.smallProductDetail) {
        return (
          <Col xs={2}>
            <i className="fa fa-check alert alert-success" />
          </Col>
        )
      } else {
        return;
      }
    }

    // Push vendor name and number in to 2 JSON arrays.
    getVendorNameOptions() {
      const vendorNameOptions = [];
      this.props.vendors.map(vendor => {
        vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name })
      });
      return vendorNameOptions;
    }

    getVendorNumOptions() {
      const vendorNumOptions = [];
      this.props.vendors.map(vendor => {
        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum })
      });
      return vendorNumOptions;
    }

    // promotion function
    getCustomerOptions = () => {
      const { customerList } = this.state;
      const customerOptions = [{ value: 'All', label: 'All' }];
      lodashMap(customerList, (customer) => {
        const option = { value: customer.Name, label: customer.Name };
        customerOptions.push(option);
      });
      return customerOptions;
    }

    setStartDate = (e) => {
      if (this.state.endDateSelected && e > this.state.endDateSelected) {
        alert(I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
        return;
      }
      this.setState({ startDateSelected: e });
    }

    setEndDate = (e) => {
      if (this.state.startDateSelected && e < this.state.startDateSelected) {
        alert(I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
        return;
      }
      this.setState({ endDateSelected: e });
    }

    openDeletePromotion = (promotionToDeleteId) => {
      this.setState({ deletePromotionOpen: true, promotionToDeleteId });
    }

    closeDeletePromotion = () => {
      this.setState({ deletePromotionOpen: false });
    }

    openEditPromotion = () => {
      this.setState({ editPromotionOpen: true });
    }

    closeEditPromotion = (refresh) => {
      this.setState({ editPromotionOpen: false }, () => {
        if (refresh) {
          this.handleFetchPromotionDetails(this.state.Product_id);
        }
      });
    }

    handleSelectionChange = (value, fieldName) => {
      this.setState({ [fieldName]: value });
    }
    handleTextInputChange = (event) => {
      this.setState({ [event.target.name]: event.target.value });
    }
    handleDiscountButtonClick = (discountType) => {
      this.setState({ discountType });
    }
    handleTabSelect = (key) => {
      if (this.state.isLoadingSavePromotion) {
        return;
      }
      const rows = lodashFilter(this.state.promotions, row => row.Method === key);
      const promotionsTableData = { ...this.state.promotionsTableData, rows };
      this.setState({ tabsKey: key, promotionsTableData });
    }
    handleSavePromotion = () => {
      const handleSuccess = () => {
        this.setState({
          isLoadingSavePromotion: false,
          startDateSelected: undefined,
          endDateSelected: undefined,
          customerGroupSelected: '',
          paymentTypeSelected: '',
        }, () => {
          const state = clearForm(this.state);
          this.handleFetchPromotionDetails(this.state.Product_id);
          this.setState(state);
          this.setState({
            selectedProduct: {
              currentPackageSize: this.props.currentProductDetail.PackageSize,
              currentProdId: this.props.currentProductDetail.Product_id,
              currentProdName: this.props.currentProductDetail.Name,
              currentProdNum: this.props.currentProductDetail.ProductNum,
              currentProductCRV: this.props.currentProductDetail.CRV,
              currentProductDescription: this.props.currentProductDetail.Description,
              currentProductWeight: this.props.currentProductDetail.NetWeight,
              currentRefNum: this.props.currentProductDetail.RefNum,
              currentRefPrice: this.props.currentProductDetail.RefPrice,
              netWeight: this.props.currentProductDetail.NetWeight,
            }
          });
        });
      };
      const handleFailure = (error) => {
        this.setState({ isLoadingSavePromotion: false });
        alert(JSON.stringify(error));
      };
      let promotionLine;
      switch (this.state.tabsKey) {
        case 'ByQuantity':
          promotionLine = desiredShapeByQuantity(this.state);
          break;
        case 'BuyAGetB':
          promotionLine = desiredShapeBuyAGetB(this.state);
          break;
        case 'ByTotalPriceProduct':
          promotionLine = desiredShapeByTotalPriceProduct(this.state);
          break;
        case 'ByTotalPriceDiscount':
          promotionLine = desiredShapeByTotalPriceDiscount(this.state);
          break;
        default:
          break;
      }
      this.setState({ isLoadingSavePromotion: true }, () => {
        savePromotion(promotionLine, handleSuccess, handleFailure, this.props.selectedCompany);
      });
    }
    handleDeletePromotion = () => {
      const handleSuccess = () => {
        this.handleFetchPromotionDetails(this.state.Product_id);
      };

      const handleFailure = (error) => {
        alert(JSON.stringify(error));
      };

      const { promotionToDeleteId } = this.state;
      deletePromotion(promotionToDeleteId, handleSuccess, handleFailure);
    }

    handleOpenEditPromotion = (promotionLineId) => {
      const handleSuccess = (response) => {
        this.setState({
          isLoadingPromoDetails: false,
          promotionToEdit: response.data,
        });
      };

      const handleFailure = (error) => {
        this.setState({ isLoadingPromoDetails: false });
        alert(JSON.stringify(error));
      };

      this.setState({ isLoadingPromoDetails: true }, () => {
        this.openEditPromotion();
        fetchPromoDetails(promotionLineId, handleSuccess, handleFailure);
      });
    }

    renderByQuantityTab = () => {
      const byQuantityTitle = (<Translate value="by_quantity" />);
      return (
        <Tab eventKey="ByQuantity" title={byQuantityTitle}>
          <div className="by-quantity-tab">
            { this.renderByQuantityPromoDetails() }
          </div>
        </Tab>
      );
    }

    renderBuyAGetBTab = () => {
      const buyAGetBTitle = (<Translate value="by_quantity_product" />);
      return (
        <Tab eventKey="BuyAGetB" title={buyAGetBTitle}>
        <div className="buy-a-get-b-tab">
          { this.renderBuyAGetBPromoDetails() }
        </div>
      </Tab>
      );
    }

    renderByTotalPriceProductTab = () => {
      const byTotalPriceProductTitle = (
        <span>
          <Translate value="by_total_price" /> (<Translate value="product" />)
        </span>
      );
      return (
        <Tab eventKey="ByTotalPriceProduct" title={byTotalPriceProductTitle}>
          <div className="by-total-price-product-tab">
            { this.renderByTotalPriceProductPromoDetails() }
          </div>
        </Tab>
      );
    }

    renderByTotalPriceDiscountTab = () => {
      const byTotalPriceDiscountTitle = (
        <span>
          <Translate value="by_total_price" /> (<Translate value="discount" />)
        </span>
      );
      return (
        <Tab eventKey="ByTotalPriceDiscount" title={byTotalPriceDiscountTitle}>
          <div className="by-total-price-discount-tab">
            {/* { this.renderByTotalPriceDiscountPromoDetails() } */}
          </div>
        </Tab>
      );
    }

    renderByQuantityPromoDetails = () => (
      <div className="promo-section" style={{ width: '100%' }}>
        <PromotionSetup
          setStartDate={this.setStartDate}
          startDateSelected={this.state.startDateSelected}
          setEndDate={this.setEndDate}
          endDateSelected={this.state.endDateSelected}
          handleSelectionChange={this.handleSelectionChange}
          customerGroupSelected={this.state.customerGroupSelected}
          paymentTypeSelected={this.state.paymentTypeSelected}
          customerOptions={this.getCustomerOptions()}
        />
        <ByQuantityFields
          paymentTypeSelected={this.state.paymentTypeSelected}
          methodSelected={this.state.methodSelected}
          quantityFrom={this.state.quantityFrom}
          quantityTo={this.state.quantityTo}
          discountValue={this.state.discountValue}
          discountType={this.state.discountType}
          handleSelectionChange={this.handleSelectionChange}
          handleTextInputChange={this.handleTextInputChange}
          handleDiscountButtonClick={this.handleDiscountButtonClick}
        />
        <SpinnerButton
          bsStyle="success"
          className="save-button"
          onClick={this.handleSavePromotion}
          disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'ByQuantity')}
          loading={this.state.isLoadingSavePromotion}
          icon="fa-save"
          translation={<Translate value="save" />}
        />
      </div>
    );

    renderBuyAGetBPromoDetails = () => (
      <div className="promo-section" style={{ width: '100%' }}>
        <PromotionSetup
          setStartDate={this.setStartDate}
          startDateSelected={this.state.startDateSelected}
          setEndDate={this.setEndDate}
          endDateSelected={this.state.endDateSelected}
          handleSelectionChange={this.handleSelectionChange}
          customerGroupSelected={this.state.customerGroupSelected}
          paymentTypeSelected={this.state.paymentTypeSelected}
          customerOptions={this.getCustomerOptions()}
        />
        <BuyAGetBFields
          methodSelected={this.state.methodSelected}
          productQuantityA={this.state.productQuantityA}
          productQuantityB={this.state.productQuantityB}
          discountValue={this.state.discountValue}
          discountType={this.state.discountType}
          handleSelectionChange={this.handleSelectionChange}
          handleDiscountButtonClick={this.handleDiscountButtonClick}
          handleTextInputChange={this.handleTextInputChange}
        />
        <SpinnerButton
          bsStyle="success"
          className="save-button"
          onClick={this.handleSavePromotion}
          // onClick={this.handleSavePromotionConfirm}
          disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'BuyAGetB')}
          loading={this.state.isLoadingSavePromotion}
          icon="fa-save"
          translation={<Translate value="save" />}
        />
      </div>
    );

    renderByTotalPriceProductPromoDetails = () => (
      <div className="promo-section" style={{ width: '100%' }}>
        <PromotionSetup
          setStartDate={this.setStartDate}
          startDateSelected={this.state.startDateSelected}
          setEndDate={this.setEndDate}
          endDateSelected={this.state.endDateSelected}
          handleSelectionChange={this.handleSelectionChange}
          customerGroupSelected={this.state.customerGroupSelected}
          paymentTypeSelected={this.state.paymentTypeSelected}
          customerOptions={this.getCustomerOptions()}
        />
        <ByTotalPriceProductFields
          minPurchasePrice={this.state.minPurchasePrice}
          productQuantityB={this.state.productQuantityB}
          SalesType={this.state.SalesType}
          handleSelectionChange={this.handleSelectionChange}
          handleTextInputChange={this.handleTextInputChange}
        />
        <SpinnerButton
          bsStyle="success"
          className="save-button"
          onClick={this.handleSavePromotion}
          disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'ByTotalPriceProduct')}
          loading={this.state.isLoadingSavePromotion}
          icon="fa-save"
          translation={<Translate value="save" />}
        />
      </div>
    );

    renderPromoDetails() {
      const that = this;
      if (this.state.promotionDetailsIsLoading) return <Spinner />;
      // else if (this.props.promotionDetailsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.promotionDetailsError)}</div></ContentWrapper>
      // Parameters of the react-data-grid
      const tableHeight = (window.innerHeight < 900) ? 200 : 200;
      const getRows = () => Data.Selectors.getRows(this.state.promotionDetails);
      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const promotionDetails = Object.assign({}, this.state.promotionDetails, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState({ promotionDetails });
      }
      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.promotionDetails.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const promotionDetails = {...this.state.promotionDetails, filters: newFilters};
        this.setState({ promotionDetails });
      }

      const onRowsDeselected = (rows) => {
        let newRows = this.state.promotionDetails.rows;
        rows.map (r => {
         newRows[r.rowIdx].isSelected = false;
        });
        var promotionDetails = {...this.state.promotionDetails, rows: newRows};
        this.setState({promotionDetails});
      }

      const onRowClick = (rowIdx, row) => {
        this.openEditPromotion();
        this.props.resetCurrentPromotions();
        this.handleFetchPromotionDetails(row.Promotion_id);
      }

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let date = new Date(this.props.value)
            let index = dateMap.indexOf(date.toString().slice(4, 3));
            let localDate = index + date.toString().slice(8, 6);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        }
      });

      const DeleteButtonFormatter = React.createClass({
        render() {
          return (
            <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={() => {
                  const { dependentValues } = this.props;
                  that.openDeletePromotion(dependentValues.PromotionLine_id);
                }}
              >
                X
              </Button>
            </span>
          );
        },
      });

      const EditButtonFormatter = React.createClass({
        render() {
          return (
            <span>
              <Button
                bsStyle="warning"
                className="textAlignStyle"
                style={{ height: '23px', width: '45px', padding: '0px' }}
                onClick={() => {
                  const { dependentValues } = this.props;
                  that.handleOpenEditPromotion(dependentValues.PromotionLine_id);
                }}
              >
                <Translate value="edit" />
              </Button>
            </span>
          );
        },
      });

      // Column difinition
      const columns = [
        {
          key: 'Delete',
          name: <Translate value="del" />,
          width: 50,
          formatter: DeleteButtonFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Edit',
          name: <Translate value="edit" />,
          width: 55,
          formatter: EditButtonFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'DiscountDescription',
          name: <Translate value="discount_description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 260,
        },
        {
          key: 'StartDate',
          name: <Translate value="start_date" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'EndDate',
          name: <Translate value="end_date" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: DateFormatter,
        },
      ];

      return (
        <Row>
          <Col xs={12}>
            <div id="ProductForm-dataGrid1">
              <ReactDataGrid
                rowKey="Promotion_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowHeight={25}
                headerRowHeight={30}
                minHeight={tableHeight}
                rowsCount={getSize()}
                // onRowClick={onRowClick}
             />
            </div>
          </Col>
        </Row>
      );
    }

    renderDepartments() {
      const productDepOptions = this.getProductDepOptions();
      return (
        <Row className="formRow">
          <Col xs={3}>
            <label><Translate value="department" /></label>
          </Col>
          <Col xs={9}>
            <Field
              name="ProductDepartment_id"
              component={Selection}
              withRef={true}
              ref="ProductDepartment"
              options={productDepOptions}
              onKeyPress={(event) => {
                if (event.keyCode == 13) {
                  this.refs["ProductCat0"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </Col>
        </Row>
      );
    }

    renderGroups() {
      const productGroupOptions = this.getProductGroupOptions();
      const productGroupOptionsGfd = this.getProductGroupOptionsGfd();
      return (
        <Row className="formRow">
          <Col xs={3}>
            <label><Translate value={ isSoleStage() ? "brand" : "group" } /></label>
          </Col>
          <Col xs={9}>
            {
              ((!this.props.currentProduct && !this.props.params.id) || isGFD)
              ?
                <Field
                  name="ProductGroup_id"
                  component={Selection}
                  withRef={true}
                  ref="ProductGroup"
                  options={isGFD ? productGroupOptionsGfd : productGroupOptions}
                  onKeyPress={(event) => {
                    if (event.keyCode == 13) {
                      this.refs["ProductCat1"].getRenderedComponent().refs.select.focus();
                    }
                  }}
                />
              :
                <Field name="ProductGroup_id" component={DisabledSelection} options={productGroupOptions} />
            }
          </Col>
        </Row>
      );
    }

    getProductDepOptions() {
      var productDepOptions = [];
      if (this.props.deps) {
        this.props.deps.map(dep => {
          productDepOptions.push({ value: dep.ProductDepartment_id, label: dep.Name })
        });
      }
      return productDepOptions;
    }

    getProductGroupOptionsGfd() {
      var productGroupOptions = [];
      if (this.props.depCategories) {
        this.props.depCategories.map(group => {
          productGroupOptions.push({ value: group.ProductGroup_id, label: group.Name })
        });
      }
      return productGroupOptions;
    }


    getProductGroupOptions() {
      var productGroupOptions = [];
      if (this.props.groups) {
        this.props.groups.map(group => {
          productGroupOptions.push({ value: group.ProductGroup_id, label: group.Name })
        });
      }
      return productGroupOptions;
    }

    CRV() {
      let CRVOptions = this.getCRVOptions();
      return (
        <Field name="CRV_id" component={ Selection } withRef={true} ref="CRVOptions" options={CRVOptions} onKeyPress={(event) => {
          if (event.keyCode == 13)
            ReactDOM.findDOMNode(this.refs["MeasureUnit"].getRenderedComponent().myInput.refs.input).focus();
        }}/>
      )
    }

    getCRVOptions() {
      var CRVOptions = [];
      this.props.CRVs.map(CRV => {
        CRVOptions.push({ value: CRV.Product_id, label: CRV.Name});
      });
      return CRVOptions;
    }

    renderDefaultBuyers() {
      const defaultBuyerOptions = this.getDefaultBuyerOptions();
      return (
        <Field name="Purchaser_User_id" withRef={true} ref="defaultBuyerOptions" component={Selection} options={defaultBuyerOptions} onKeyPress={(event) => {
            if (event.keyCode == 13)
              ReactDOM.findDOMNode(this.refs["MeasureUnit"].getRenderedComponent().myInput.refs.input).focus();
        }} />
      );
    }

    defaultSales() {
      const defaultBuyerOptions = this.getDefaultBuyerOptions();
      return (
        <Field name="Sales_User_id" component={Selection} options={defaultBuyerOptions} />
      );
    }

    getDefaultBuyerOptions() {
      return this.props.defaultBuyers.map((defaultBuyer) => {
        return {
          value: defaultBuyer.BaseUser_id,
          label: isGGI ? defaultBuyer.FirstName : defaultBuyer.username,
        };
      });
    }

    renderCategories() {
      let productCategoryOptions = this.getProductCategoryOptions();
      let productCategory2Options = this.getProductCategory2Options(); // this not been used
      return (
        <div>
          <Row className="formRow">
            <Col xs={3}>
              <label><Translate value={isSoleStage() ? "style" : "category_1" }/></label>
            </Col>
            <Col xs={9}>
              {
                ((!this.props.currentProduct  && !this.props.params.id) || isGFD) ?
                  <Field name="ProductCategory1_id" className="control-label" component={Selection} withRef={true} ref="ProductCat1" options={productCategoryOptions} onKeyPress={(event) => {
                    if (event.keyCode == 13) {
                      this.refs["ProductCat2"].getRenderedComponent().refs.select.focus();
                    }
                  }}/> :
                  <Field name="ProductCategory1_id" className="control-label" component={DisabledSelection}  options={productCategoryOptions} />
              }
            </Col>
          </Row>
        </div>
      );
    }

    renderDisplayCategories() {
      if (this.props.params.id) {
        return (
          <div>
            <Row>
              <Col xs={3}>
                <label><Translate value="display"/></label>
              </Col>
                <Col xs={9}>
                  <SpinnerButton
                    bsStyle="primary"
                    icon="fa-pencil"
                    onClick={this.handleDisplayCategoryBoxClick}
                    disabled={this.state.isLoadingDisplayCategory}
                    loading={this.props.editCategoryLoading}
                    translation={<Translate value="edit_display_category" />}
                  />
                </Col>
            </Row>
          </div>
        );
      } else {
        return (
          <div>
            <Row>
              <Col xs={3}>
                <label><Translate value="display" /></label>
              </Col>
              <Col xs={9}>
                <span style={{ color: 'red' }}><Translate value="edit_display_category_warning" /></span>
              </Col>
            </Row>
          </div>
        );
      }
    }

    renderBrandInformation = () => {
      return (
        <div>
          <Row>
            <Col xs={4}></Col>
            <Col xs={4}>
              <label>English</label>
            </Col>
            <Col xs={4}>
              <label>繁體</label>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Brand"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Brand" withRef={true} ref="English_Details_Brand" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Brand" withRef={true} ref="Chinese_Details_Brand" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Brand Origin"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Brand_Origin" withRef={true} ref="English_Brand_Origin" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Brand_Origin" withRef={true} ref="Chinese_Brand_Origin" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Net Content"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_NetContent" withRef={true} ref="English_Details_NetContent" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_NetContent" withRef={true} ref="Chinese_Details_NetContent" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Made In"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Made_In" withRef={true} ref="English_Details_Made_In" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Made_In" withRef={true} ref="Chinese_Details_Made_In" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Ingredients"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Ingredients" withRef={true} ref="English_Details_Ingredients" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Ingredients" withRef={true} ref="Chinese_Details_Ingredients" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Organic"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Organic" withRef={true} ref="English_Details_Organic" component={ InputField } placeholder="EN" />
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Organic" withRef={true} ref="Chinese_Details_Organic" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Contains Sugar"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Contains_Sugar" withRef={true} ref="English_Details_Contains_Sugar" component={ InputField } placeholder="EN"/>
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Contains_Sugar" withRef={true} ref="Chinese_Details_Contains_Sugar" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label><Translate value={"Flavor"}/></label>
            </Col>
            <Col xs={4}>
              <Field name="English_Details_Flavor" withRef={true} ref="English_Details_Flavor" component={ InputField } placeholder="EN" />
            </Col>
            <Col xs={4}>
              <Field name="Chinese_Details_Flavor" withRef={true} ref="Chinese_Details_Flavor" component={ InputField } placeholder="CH"/>
            </Col>
          </Row>
        </div>
      )
    }

    getProductCategoryOptions() {
      var productCategoryOptions = [];
      this.props.groupCategories.map(category => {
        productCategoryOptions.push({ value: category.ProductCategory_id, label: category.Name })
      });
      return productCategoryOptions;
    }

    getProductCategory2Options() {
      var productCategory2Options = [];
      if (this.props.categories2) {
        this.props.categories2.map(category2 => {
          productCategory2Options.push({ value: category2.ProductCategory2_id, label: category2.Name })
        });
      }
      return productCategory2Options;
    }

    getZoneOptions() {
      let zoneOptions = [];
      this.props.zones.map( zone => {
        if (isVAK) {
          zoneOptions.push({ value: zone.zone_num, label: this.props.locale === 'ch' ? zone.Description : zone.Name });
        } else {
          zoneOptions.push({ value: zone.zone_num, label: zone.zone_num });
        }
      });
      zoneOptions.sort( (a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      // for horizontal initial to DZ-DS-DB
      if (!this.props.Zone && (isHO || isJRC)) {
        this.props.setValue('productForm', 'Zone', 'DZ'); //zoneOptions[0].label
        this.props.getBinsByZone(1, 1);
      }
      
      // for abble initial to GD-01
      if (!this.props.Zone && isABBLE) {
        this.props.setValue('productForm', 'Zone', 'GD');
        this.props.getBinsByZone(1, 1);
      }

      return zoneOptions;
    }

    getBinOptions = () => {
      let binOptions = [];
      if (this.props.bins) {
        this.props.bins.map( bin => {
          binOptions.push({value: bin.section_num, label: bin.section_num});
        });
      }
      binOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      // for horizontal initial to DZ-DS-DB
      if (!this.props.Bin && (isHO || isJRC)) {
        this.props.setValue('productForm', 'Bin', 'DS');
      }
      // for abble initial to GD-01
      if (!this.props.Zone && isABBLE) {
        this.props.setValue('productForm', 'Zone', '01');
      }
      
      return binOptions;
    }
    getBin2Options = () => {
      let binOptions = [];
      if (this.props.bins2) {
        this.props.bins2.map( bin => {
          binOptions.push({value: bin.section_num, label: bin.section_num});
        });
      }
      binOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return binOptions;
    }
    getBin3Options = () => {
      let binOptions = [];
      if (this.props.bins3) {
        this.props.bins3.map( bin => {
          binOptions.push({value: bin.section_num, label: bin.section_num});
        });
      }
      binOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return binOptions;
    }

    getLevelOptions = () => {
      let levelOptions = [];
      if (this.props.levels) {
        this.props.levels.map( level => {
          levelOptions.push({value: level.bin_num, label: level.bin_num})
        });
      }
      levelOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      // for horizontal initial to DZ-DS-DB
      if (!this.props.Level && (isHO || isJRC)) {
        this.props.setValue('productForm', 'Level', 'DB');
      }
      return levelOptions;
    }
    getLevel2Options = () => {
      let levelOptions = [];
      if (this.props.levels2) {
        this.props.levels2.map( level => {
          levelOptions.push({value: level.bin_num, label: level.bin_num})
        });
      }
      levelOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return levelOptions;
    }
    getLevel3Options = () => {
      let levelOptions = [];
      if (this.props.levels3) {
        this.props.levels3.map( level => {
          levelOptions.push({value: level.bin_num, label: level.bin_num})
        });
      }
      levelOptions.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return levelOptions;
    }

    // isAGD
    renderCartonInfo() {
      return (
        <div>
          <Row>
            <Col xs={12}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="carton_dim" /></label>
                <div className="col-xs-2">
                  <Field
                    name="CartonHeight"
                    className="control-label"
                    component={InputField}
                    withRef={true}
                    ref="CartonHeight"
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        this.refs["CartonLength"].getRenderedComponent().refs.select.focus();
                      }
                    }}
                  />
                </div>
                <div className="col-xs-1">
                  <label>x</label>
                </div>
                <div className="col-xs-2">
                  <Field
                    name="CartonLength"
                    className="control-label"
                    component={InputField}
                    withRef={true}
                    ref="CartonLength"
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        this.refs["CartonWidth"].getRenderedComponent().refs.select.focus();
                      }
                    }}
                  />
                </div>
                <div className="col-xs-1">
                  <label>x</label>
                </div>
                <div className="col-xs-2">
                  <Field
                    name="CartonWidth"
                    className="control-label"
                    component={InputField}
                    withRef={true}
                    ref="CartonWidth"
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        this.refs["CartonHeight"].getRenderedComponent().refs.select.focus();
                      }
                    }}
                  />
                </div>
                <div className="nonbold-label-description textAlignStyle" >
                  <Translate value="(in)" />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <div className="form-group">
                <label className="col-xs-5"><Translate value="carton_vol" /></label>
                <div className="col-xs-7">
                  <Field name="CartonVolume" withRef={true} ref="CartonVolume" component={ InputField } onFocus={this.handleOnFocus} />
                </div>
              </div>
            </Col>
            <Col xs={6}>
              <div className="form-group">
                <label className="col-xs-5"><Translate value="carton_inner_qty" /></label>
                <div className="col-xs-7">
                  <Field name="CartonInnerQuantity" withRef={true} ref="CartonInnerQuantity" component={ InputField } onFocus={this.handleOnFocus} />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="form-group">
                <label className="col-xs-4"><Translate value="carton_inner_qty" /></label>
                <div className="col-xs-8">
                  <Field name="CartonInnerQuantity" withRef={true} ref="CartonInnerQuantity" component={ InputField } onFocus={this.handleOnFocus} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    // isSV
    renderCaseVolumeDimension() {
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="case_dimension" /></label>
          <div className="col-xs-2">
            <Field
              name="CaseHeight"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["CaseLength"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="CaseLength"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["CaseWidth"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="CaseWidth"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["CaseHeight"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="nonbold-label-description textAlignStyle" >
            <Translate value="(in)" />
          </div>
        </div>
      );
    }

    // isSV
    renderPalletVolumeDimension() {
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="pallet_dimension"/></label>
          <div className="col-xs-2">
            <Field
              name="PalletHeight"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["PalletLength"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="PalletLength"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["PalletWidth"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="PalletWidth"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["PalletHeight"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
            <div className="nonbold-label-description textAlignStyle" >
              <Translate value="(in)" />
            </div>
        </div>
      );
    }

    renderVolumeDimension() {
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value={isSV ? "unit_dimension" : isVAK ? "item_dimension" : "dimension"} /></label>
          <div className="col-xs-2">
            <Field
              placeholder='height'
              name="DimensionHeight"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["DimensionLength"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
            { isLMH && <div className="dimension-title-style"><Translate value="(height)" /></div> }
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              placeholder='length'
              name="DimensionLength"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["DimensionWidth"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
            { isLMH && <div className="dimension-title-style"><Translate value="(length)" /></div> }
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              placeholder='width'
              name="DimensionWidth"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["DimensionHeight"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
            { isLMH && <div className="dimension-title-style"><Translate value="(width)" /></div> }
          </div>
          {
            (!isPS && !isHMM && !isWIZ && !isJTB && !isABBLE && !isSV && !isGGI && !isOLG && !isABCFF) &&
            <div className="nonbold-label-description textAlignStyle" >
              <Translate value={(isVAK || isLMH) ? "(inch)" : "(ft)"} />
            </div>
          }
          {
            (isPS || isWIZ || isABBLE || isSV) &&
            <div className="nonbold-label-description textAlignStyle" >
              <Translate value="(in)" />
            </div>
          }
          {
            (isGGI || isOLG || isABCFF) &&
            <div className="nonbold-label-description textAlignStyle" >
              <Translate value="(Inch)" />
            </div>
          }
        </div>
      );
    }

    renderPKGDimension() {
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="pkg_dimension" /></label>
          <div className="col-xs-2">
            <Field
              name="BoxDimensionHeight"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => { 
                if (event.key === 'Enter') {
                  this.refs["BoxDimensionLength"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="BoxDimensionLength"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["BoxDimensionWidth"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="BoxDimensionWidth"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["BoxDimensionHeight"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div> 
          <div className="nonbold-label-description textAlignStyle" >
            <Translate value="(inch)" />
          </div>
        </div>
      );
    }

    renderPackageDimension() {
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value={"case_pack_dim"} /></label>
          <div className="col-xs-2">
            <Field
              name="CartonHeight"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["CartonLength"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="CartonLength"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["CartonWidth"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="col-xs-1">
            <label>x</label>
          </div>
          <div className="col-xs-2">
            <Field
              name="CartonWidth"
              className="control-label"
              component={InputField}
              withRef={true}
              ref="ProductType"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  this.refs["CartonHeight"].getRenderedComponent().refs.select.focus();
                }
              }}
            />
          </div>
          <div className="nonbold-label-description textAlignStyle" >
            <Translate value="(ft)" />
          </div>
        </div>
      );
    }

    renderPackageWeight() {
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value={"case_pack_wt"}/></label>
          <div className="col-xs-2" style={{ paddingRight: 0 }}>
            <Field name="CartonWeight" className="control-label" withRef={true} ref="CartonWeight" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
              this.handleKeyPress('ShippingWeight', event);}}
            />
          </div>
        </div>
      )
    }

    renderItemMeasurement = () => {
      if (isSH) {
        return (
          <Row style={{ marginBottom: '-10' }}>
            <Col xs={12}>
              <div className="form-group">
                <label className="col-xs-4"><Translate value="item_measurement" /></label>
                <div className="col-xs-5">
                  <Field
                    name="ItemMeasurement"
                    className="control-label"
                    component={InputField}
                    withRef={true}
                  />
                </div>
              </div>
            </Col>
          </Row>
        )
      }
      return null;
    }

    renderTotalVolume() {
      return (
      <div className="form-group">
        <label className="col-xs-4"><Translate value="total_volume" /></label>
        <div className="col-xs-3">
          <Field
            name="Volume"
            className="control-label"
            component={InputField}
            withRef={true}
            ref="ProductType"
            // onKeyPress={(event) => {
            //   if (event.key === 'Enter') {
            //     this.refs["DimensionLength"].getRenderedComponent().refs.select.focus();
            //   }
            // }}
          />
        </div>
        {/* <div>
              <Translate value="(cubic inch)" />
            </div> */}
      </div>
      );
    }

    renderUnitCBF() {
      const {DimensionHeight, DimensionLength, DimensionWidth } = this.props;
      let cbf = 0;
      if (DimensionHeight && DimensionLength && DimensionWidth) {
        cbf = (DimensionHeight/12)*(DimensionLength/12)*(DimensionWidth/12);
        // cbm = Math.round(cbm * 1000000000000) / 1000000000000
        cbf = cbf.toFixed(6);
      } else {
        cbf = 0;
      }
      this.props.setValue('productForm', 'UnitCBF', cbf);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.UnitCBF } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }
    renderUnitCBM() {
      const {DimensionHeight, DimensionLength, DimensionWidth } = this.props;
      let cbm = 0;
      if (DimensionHeight && DimensionLength && DimensionWidth) {
        cbm = (DimensionHeight*0.0254)*(DimensionLength*0.0254)*(DimensionWidth*0.0254);
        // cbm = Math.round(cbm * 1000000000000) / 1000000000000
        cbm = cbm.toFixed(6);
      } else {
        cbm = 0;
      }
      this.props.setValue('productForm', 'UnitCBM', cbm);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.UnitCBM } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }

    renderCaseCBF() {
      const {CaseHeight, CaseLength, CaseWidth } = this.props;
      let cbf = 0;
      if (CaseHeight && CaseLength && CaseWidth) {
        cbf = (CaseHeight/12)*(CaseLength/12)*(CaseWidth/12);
        // cbm = Math.round(cbm * 1000000000000) / 1000000000000
        cbf = cbf.toFixed(6);
      } else {
        cbf = 0;
      }
      this.props.setValue('productForm', 'CaseCBF', cbf);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.CaseCBF } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }
    renderCaseCBM() {
      const {CaseHeight, CaseLength, CaseWidth } = this.props;
      let cbm = 0;
      if (CaseHeight && CaseLength && CaseWidth) {
        cbm = (CaseHeight*0.0254)*(CaseLength*0.0254)*(CaseWidth*0.0254);
        // cbm = Math.round(cbm * 1000000000000) / 1000000000000
        cbm = cbm.toFixed(6);
      } else {
        cbm = 0;
      }
      this.props.setValue('productForm', 'CaseCBM', cbm);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.CaseCBM } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }



    renderPalletCBF() {
      const {PalletHeight, PalletLength, PalletWidth } = this.props;
      let cbf = 0;
      if (PalletHeight && PalletLength && PalletWidth) {
        cbf = (PalletHeight/12)*(PalletLength/12)*(PalletWidth/12);
        // cbm = Math.round(cbm * 1000000000000) / 1000000000000
        cbf = cbf.toFixed(6);
      } else {
        cbf = 0;
      }
      this.props.setValue('productForm', 'PalletCBF', cbf);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.PalletCBF } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }
    renderPalletCBM() {
      const {PalletHeight, PalletLength, PalletWidth } = this.props;
      let cbm = 0;
      if (PalletHeight && PalletLength && PalletWidth) {
        cbm = (PalletHeight*0.0254)*(PalletLength*0.0254)*(PalletWidth*0.0254);
        // cbm = Math.round(cbm * 1000000000000) / 1000000000000
        cbm = cbm.toFixed(6);
      } else {
        cbm = 0;
      }
      this.props.setValue('productForm', 'PalletCBM', cbm);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.PalletCBM } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }

    renderCasePerPallet() {
      const { CaseCBM, PalletCBM } = this.props;

      let cpp = 0;
      if (PalletCBM && CaseCBM) {
        cpp = PalletCBM/CaseCBM;
        cpp = cpp.toFixed(0);
      } else {
        cpp = 0;
      }
      this.props.setValue('productForm', 'CasePerPallet', cpp);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.CasePerPallet } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }


    renderBoxWt() {
      const {NetWeight, Units_Case, Units_InnerBox } = this.props;
      let weight = 0;
      if (NetWeight && Units_Case && Units_InnerBox) {
        weight = (NetWeight/Units_Case) * (Units_InnerBox);
        // cbm = Math.round(cbm * 1000000000000) / 1000000000000
        weight = weight.toFixed(2);
      } else {
        weight = 0;
      }
      this.props.setValue('productForm', 'BoxWt', weight);
      return (
        <div className="form-group">
          <div >
             <input value={ this.props.BoxWt } disabled style={customizedInputStyle}/>
          </div>
        </div>
      );
    }


    renderCBM() {
      const { DimensionUnit, DimensionHeight, DimensionLength, DimensionWidth } = this.props;

      let cbm = 0;
      if (DimensionUnit) {
        if (DimensionUnit === 'cm' || DimensionUnit.value === 'cm') {
          cbm = (DimensionHeight/100)*(DimensionLength/100)*(DimensionWidth/100);
          // cbm = cbm.toFixed(15);
          cbm = Math.round(cbm * 1000000000000) / 1000000000000
        }
        if (DimensionUnit === 'inch' || DimensionUnit.value === 'inch') {
          cbm = (DimensionHeight*0.0254)*(DimensionLength*0.0254)*(DimensionWidth*0.0254);
          cbm = Math.round(cbm * 1000000000000) / 1000000000000
        }
      } else {
        cbm = 'N/A';
      }

      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="CBM" /></label>
          <div className="col-xs-5">
             <input value={ cbm } disabled style={customizedInputStyle}/>

          </div>
          {/* <div>
                <Translate value="(cubic)" />
              </div> */}
        </div>
      );
    }

    renderCBMUnit() {
      const dimensionUnitOption = [
        { value: "inch", label: "inch"},
        { value: "cm", label: "cm"},
      ];

      return (
      <div className="form-group">
        <label className="col-xs-4"><Translate value="dimension_unit" /></label>
        <div className="col-xs-4">
          <Field name="DimensionUnit" component={ Selection } options={dimensionUnitOption}
          onKeyPress={(event) => {
            setTimeout(() => {
              this.props.setValue('productForm', 'DimensionUnit', event.target.value);
            }, 200);
            //   event.stopPropagation();
            // if (event.keyCode == 13) {
            //   this.refs["PackageType"].getRenderedComponent().refs.select.focus();
            // }
          }}
          />
        </div>
        {/* <div>
              <Translate value="(cubic inch)" />
            </div> */}
      </div>
      );
    }

    renderProductType() {
      const typeOptions = [
        { value: 'Fixed', label: 'Fixed' },
        { value: 'Non-Fixed', label: 'Non-Fixed' },
        { value: 'Service', label: 'Service' },
        { value: 'Non-Product', label: 'Non-Product' },
        { value: 'Per-Pound',label: 'Per-Pound' }
      ];
      if (isGFD) {
        typeOptions.push({
          value: 'Gift-Card',
          label: 'Gift-Card',
        })
      }
      const colorOptions = [
        { value: 'Black', label: 'Black' },
        { value: 'White', label: 'White' },
        { value: 'Red', label: 'Red' },
        { value: 'Gery', label: 'Gery' },
        { value: 'Blue', label: 'Blue' },
        { value: 'Pink', label: 'Pink' }
      ]
      return isSoleStage(ROOT_URL) ? (
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="prod_type"/><span className="asteriksReq">*</span></label>
              <div className="col-xs-8">
                <Field name="ProductType" className="control-label" component={Selection} withRef={true} ref="ProductType" options={typeOptions} onKeyPress={(event) => {
                  if (event.keyCode === 13) {
                    this.refs["ProductColor"].getRenderedComponent().refs.select.focus();
                  }
                }}/>
              </div>
            </div>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-3"><Translate value="color" /><span className="asteriksReq">*</span></label>
              <div className="col-xs-9">
                <Field name="ProductColor" className="control-label" component={Selection} withRef={true} ref="ProductColor" options={colorOptions} onKeyPress={(event) => {
                  if (event.keyCode === 13) {
                    this.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
                  }
                }}/>
              </div>
            </div>
          </Col>
        </Row>
      )
      :
      (
      <div className="form-group">
        <label className="col-xs-4"><Translate value="prod_type"/><span className="asteriksReq">*</span></label>
        <div className="col-xs-8">
          <Field name="ProductType" className="control-label" component={Selection} withRef={true} ref="ProductType" options={typeOptions} onKeyPress={(event) => {
            if (event.keyCode === 13) {
              this.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
            }
          }}/>
        </div>
      </div>
      )
    }

    // this not being used
    renderWarehouse() {
      if (this.props.warehouseIsLoading) return <Spinner/> // If group is loading, show a spinner.
      else {
        let warehouseOptions = this.getWarehouseOptions();
        return (
          <Row>
            <Col xs={6}>
              <div className="form-group">
                <label><Translate value="default_warehouse"/></label>
                <Field name="Default_Warehouse_id" component={Selection} options={warehouseOptions}/>
              </div>
            </Col>
          </Row>
        )
      }
    }

    getWarehouseOptions() {
      var warehouseOptions = [];
      this.props.warehouses.map(warehouse => {
        warehouseOptions.push({ value: warehouse.Warehouse_id + '', label: warehouse.Name })
      });
      return warehouseOptions;
    }

    getMeasureUnitOptions() {
      let measureUnitOptions = [];
      if (this.props.measurementUnitFetched) {
        this.props.measurementUnitFetched.map(measureUnit => {
          measureUnitOptions.push({value: measureUnit.Simple, label: measureUnit.Simple})
        })
      }
      return measureUnitOptions;
    }

    getPackageTypeOptions() {
      let packageTypeOptions = [];
      if (this.props.packageTypesFetched) {
        this.props.packageTypesFetched.map(packageType => {
          packageTypeOptions.push({value: packageType.Simple, label: packageType.Simple})
        })
      }
      return packageTypeOptions;
    }

    routerWillLeave(nextLocation) {
      if (this.state.dirty) return <Translate value="work_not_saved_warning" />
      this.props.clearSmallProdStatus();
    }

    renderPackageInfo() {
      const packageTypeOptions = this.getPackageTypeOptions();
      return (
        <div className="form-group">
          <label className="col-xs-6">
            <Translate value="package_type"/><span className="asteriksReq">*</span>
          </label>
          <div className="col-xs-6">
            <Field name="PackageType" className="control-label" component={Selection} withRef={true} ref="PackageType" options={packageTypeOptions} onKeyPress={(event) => {
                if (event.keyCode === 13) {
                  ReactDOM.findDOMNode(this.refs["NetWeight"].getRenderedComponent().myInput.refs.input).focus();
                }
              }}
            />
          </div>
        </div>
      )
    }

    // If the user was directed to the page with a parameter,
    // then this page is edit page. Otherwise this is a create
    // page.

    VPNCheck = (vendors = []) => {
      let allVPNHasVendorId = true;
      if (isARC) {
        return true;
      }
      vendors.forEach(elem => {
        if(elem.Vendor_product_num && !elem.Vendor_id) {
          allVPNHasVendorId = false;
        }
      })
      return allVPNHasVendorId;
    }

    DuplicateCode = (vendors = []) => {
      let counts = vendors.reduce((acc, item) => {
        let key = ``;
        if(item.Source) {
          if(item.Source.value) {
            key = `${item.Source.value},${item.Code}`
          } else {
            key = `${item.Source},${item.Code}`
          }
        } else {
          key = `${item.Code}`
        }
        if (acc[key]) {
          acc[key]++;
        } else {
          acc[key] = 1;
        }
        return acc;
      }, {});
      
      // 使用 filter 来找出出现次数大于 1 的元素
      let duplicates = Object.entries(counts).filter(([key,value]) => value > 1)
      .map(([key,value]) => `{${key}}`)
      .join(', ');
      return duplicates;
    }

    CaseCheck = (vendors = []) => {
      let barcodeNotEmpty = true;
      vendors.forEach(elem => {
        if (isGFD) {
          if (elem.Source === 'UPC (moleQ) - Related') {
            if (!(elem.CasePrice && elem.UnitPerCase)) {
              barcodeNotEmpty = false;
            }
          }
        }
      })
      return barcodeNotEmpty;
    }
    
    BarcodeCheck = (vendors = []) => {
      let barcodeNotEmpty = true;
      vendors.forEach(elem => {
        if(!elem.Code && elem.Vendor_id) {
          barcodeNotEmpty = false;
        }
        if (isARC) {
          if (!elem.Code) {
            barcodeNotEmpty = false;
          }
        }
        if (isGFD) {
          if (elem.Source === 'UPC (moleQ) - Related') {
            if (!elem.Code) {
              barcodeNotEmpty = false;
            }
          }
        }
      })
      return barcodeNotEmpty;
    }

    findNewBarcode = (vendors) => {
      return vendors.filter(vendor => {
        return !vendor.Barcode_id;
      });
    }

    handleFormSubmit(formProps) {
      if(isVAK || isOLG) {
        delete formProps.InternalBarcode;
        delete formProps.UnitPerPallet
      }
      if((formProps.ShippingWeight < formProps.NetWeight) && !isSV) {
        this.setState({
          confirmModalVisibility: true,
          formProps,
        })
        return;
      }
      
      if (!this.props.params.id && !this.state.refNumVerified && isOCM) {
        this.setRefNumVerifyModalVisibility(true);
      } else {
        this.submitForm(formProps)
      }
    }

    setRefNumVerifyModalVisibility = (isRefNumVerifyModalVisible = false) => this.setState({ isRefNumVerifyModalVisible });

    submitForm = (formProps, barcodeVerify) => {
      // Temp VPN and barcode validation
      let temp = [];
      if(!this.CaseCheck(formProps.Vendors)) {
        alert('Case price and unit per case can not be empty for UPC (moleQ) - Related');
        return;
      };
      if(isGFD) {
        let cc = this.DuplicateCode(formProps.Vendors);
        if(cc) {
          alert(`Barcode: ${cc} repeated`);
          return
        }
      }
      if(!this.VPNCheck(formProps.Vendors)) {
        alert('Each VPN must has a vendor id. please check the barcode panel');
        return;
      };
      if (!this.BarcodeCheck(formProps.Vendors)) {
        if (!isAFG && !isMyuMyu && !isWecom && !isMMD && !isARC && !isVAK) {
          alert('Barcode can not be empty');
          return;
        } else {
          formProps.Vendors.map(v => {
            if (!v.Code) {
              v.Code = "";
            }
            temp.push(v);
          });
          if (isGFD) return;
          if(isVAK) {
            formProps.Vendors = temp;
          } else {
            formProps.Vendors = temp.filter(t => (t.Code || t.Vendor_product_num));
          }
        }
      };

      this.setState({ dirty: false });
      this.state.selectedCompany = this.props.selectedCompany;
      this.state.selectedWarehouse = this.props.selectedWarehouse;
      // only ocm has barcode verify
      if (isOCM && !barcodeVerify) {
        //check there is barcode has not been verified
        const newBarocde = this.findNewBarcode(formProps.Vendors);
        if (newBarocde.length) {
          // find barcode s not been verified
          const handleResult = (valid, errMsg) => {
            const continueSaving = () => {
              if (this.props.params.id) {
                if(!this.checkPermission("change_product")){
                    this.props.editProduct(formProps, this.state);
                  } else {
                  alert("You have no permission!");
                }
              }
              else {
                this.props.createProduct(formProps, this.state, this.state.productNavigation_1.ProductNum)
              };
            }
            if (valid) {
              //barcode is valid, save product
              continueSaving();
            } else {
              // invalid barcode, prompt user
              this.handleOCMBarcodeVerifyFailed(errMsg);
            }
          }
          // going to verify barcode
          this.props.verifyBarcode(formProps, this.state, handleResult);
          return;
        } else {
          this.submitForm(formProps, true);
        }
        return;
      }

      if(isGFD && this.state.removeVendorProducts.length > 0) {
        const array = formProps.VendorProduct.concat(this.state.removeVendorProducts);
        formProps.VendorProduct = array;
      }
      
      if (this.props.params.id) {
        if(!this.checkPermission("change_product")){
            this.props.editProduct(formProps, this.state);
          } else {
          alert("You have no permission!");
        }
      }
      else {
        this.props.createProduct(formProps, this.state, this.state.productNavigation_1.ProductNum)
      };
      if (isAFG || isMyuMyu) {
        setTimeout(() => {
          window.history.back();
        }, 500);
      }
    }

    handleOCMBarcodeVerifyFailed = (errMsg) => {
      this.setState({
        barcodeVerifyFailedMsg: errMsg,
      }, () => {
        this.setBarcodeVerifyFailedModalVisibility(true);
      })
    }

    setBarcodeVerifyFailedModalVisibility = (isBarcodeVerifyFailedModalVisible = false) => this.setState({ isBarcodeVerifyFailedModalVisible });

    handleOCMBarcodeVerifyFailedConfirm = () => {
      this.setBarcodeVerifyFailedModalVisibility();
      const run = this.props.handleSubmit((formProps) => {
        this.submitForm(formProps, true)
      });
      run();
    }

    refreshPage(event) {
      event.preventDefault();
      this.setState({ showProductCreatedOpen: false, editProductGroup: false });
      const { productSaved } = this.props;
      this.props.resetCurrentProduct();
      this.props.selectProduct(productSaved);
      this.context.router.push('/products/'+productSaved.Product_id);
    }

    viewPromotion = () => {
      this.setState(
        { viewPromotion: true },
        () => {
          this.handleFetchPromotionDetails(this.state.Product_id);
        }
      );
    }

    closeViewPromotion = () => {
      const state = clearForm(this.state);
      this.setState(state);
      this.setState({
        viewPromotion: false,
        startDateSelected: undefined,
        endDateSelected: undefined,
        customerGroupSelected: '',
        paymentTypeSelected: '',
        selectedProduct: {
          currentPackageSize: this.props.currentProductDetail.PackageSize,
          currentProdId: this.props.currentProductDetail.Product_id,
          currentProdName: this.props.currentProductDetail.Name,
          currentProdNum: this.props.currentProductDetail.ProductNum,
          currentProductCRV: this.props.currentProductDetail.CRV,
          currentProductDescription: this.props.currentProductDetail.Description,
          currentProductWeight: this.props.currentProductDetail.NetWeight,
          currentRefNum: this.props.currentProductDetail.RefNum,
          currentRefPrice: this.props.currentProductDetail.RefPrice,
          netWeight: this.props.currentProductDetail.NetWeight,
        }
      });
    }

    checkPermission(permission) {
      return false;
    }

    handlePercentageChange(priceLevelPercentage, event) {
      const priceLevel = lowerFirst(priceLevelPercentageFieldsMap[upperFirst(priceLevelPercentage)]);
      let price = 0;
      if(isOLG) {
        price = calculatePriceLevelNormal(event.target.value, this.props.ProductCost);
        if(priceLevelPercentage == 'p5Percentage') {
          this.props.setValue('productForm', 'RefPrice', price);
        }
      } else {
        price = calculatePriceLevelNormal(event.target.value, this.props.RefPriceValue, this.props.ArrivalPrice, this.props.ProductCost);
      }
      const moreState = {};
      if (isSUN) {
        price = price && price.toFixed(2);
        const sunsunPrice = {
          p1Percentage: 'priceLevel1Sunsun',
          p2Percentage: 'priceLevel2Sunsun',
          p3Percentage: 'priceLevel3Sunsun',
          p4Percentage: 'priceLevel4Sunsun',
          p5Percentage: 'priceLevel5Sunsun',
        };
        // const sunsun = {
        moreState[sunsunPrice[priceLevelPercentage]] = (price - this.props.RefPriceValue).toFixed(2);
        // };
      }
      this.setState({
        [priceLevel]: price,
        [priceLevelPercentage]: event.target.value,
        ...moreState,
      });
    }

    handlePriceChange(priceLevel, event) {
      const basePrice = (isEcity || isHMM || isUSPride) ? this.props.ArrivalPrice : null;
      let percentage = 0;
      if(isOLG) {
        percentage = calculatePricePercentage(event.target.value, this.props.ProductCost, basePrice, this.props.ProductCost);
        if(priceLevel == 'priceLv5') {
          this.props.setValue('productForm', 'RefPrice', event.target.value);
        }
      } else {
        percentage = calculatePricePercentage(event.target.value, this.props.RefPriceValue, basePrice, this.props.ProductCost);
      }
      const priceLevelPercentage = lowerFirst(priceLevelFieldsMap[upperFirst(priceLevel)]);
      let priceLevelObj = {};
      if (isSUN) {
        percentage = percentage
        const value = (event.target.value - this.props.RefPriceValue).toFixed(2)
        if (priceLevel === 'priceLv1') {
          priceLevelObj.priceLevel1Sunsun = value
        }
        if (priceLevel === 'priceLv2') {
          priceLevelObj.priceLevel2Sunsun = value
        }
        if (priceLevel === 'priceLv3') {
          priceLevelObj.priceLevel3Sunsun = value
        }
        if (priceLevel === 'priceLv4') {
          priceLevelObj.priceLevel4Sunsun = value
        }
        if (priceLevel === 'priceLv5') {
          priceLevelObj.priceLevel5Sunsun = value
        }
      }
      this.setState({
        [priceLevel]: event.target.value,
        [priceLevelPercentage]: percentage,
        ...priceLevelObj,
      });
    }

    pushInventoryDetail() {
      this.props.selectInventory(this.props.currentProductDetail);
      this.context.router.push(`/inventories/detail/${this.props.currentProductDetail.Product_id}`);
    }

    handleImageUpdated = (updatedImage) => {
      this.setState({ updatedImage });
    }

    handleBarcodePdfPrint = () => {
      fetchBarcodePdf(this.props.params.id);
    }

    renderProductNum() {
      let p = this.props.currentProductDetail && this.props.currentProductDetail.ProductNum;
      let isDisabled = true;
      return(
        <div className="form-group" >
          <label className="col-xs-5" >
            <Translate value="product_num" />
          </label>
          <div className="col-xs-7" >
            <Field name="ProductNum" className="control-label" isDisabled={isDisabled} component={ ControllabledStateInputField } placeholder={p} onKeyPress={(event) => {
                this.handleKeyPress('GeneralNum', event)
              }}/>
          </div>
        </div>
      )
    }
    generateRefNo = () => {
      let rNo;
      const { PackageType_2, MeasureUnit_2 } = this.props;
      if (!PackageType_2 && !MeasureUnit_2) {
        alert('Please fill out Pkg Size 1 and Pkg Size 2 to generate Reference Number.')
      } else if (isBD()) {
        if (!this.props.currentProductDetail) {
          const groupTag = this.props.ProductGroup_id.label;
          const catTag = this.state.productNavigation_1.ProductCategory1_id.label;
          rNo = `${groupTag}-${catTag}-${this.props.PackageType_2.label}-${this.props.MeasureUnit_2.label}`;
        } else {
          let matchedProductId = this.props.ProductGroup_id;
          let matchedCategoryId = this.props.currentProductDetail.ProductCategory1_id;
          const groupTag = this.props.groups.find((value) => {
            if (value.ProductGroup_id === matchedProductId) {
              return value;
            }
          });
          const catTag = this.props.groupCategories.find((value) => {
            if (value.ProductCategory_id === matchedCategoryId) {
              return value;
            }
          });
          rNo = `${groupTag.Name}-${catTag.Name}-${this.props.PackageType_2}-${this.props.MeasureUnit_2}`;
        }
      } else if (isSoleStage()) {
        if (!this.props.currentProductDetail) {
          const catTag = this.state.productNavigation_1.ProductCategory1_id.label;
          rNo = `${catTag}-${this.props.PackageType_2.label}/${this.props.MeasureUnit_2.label}`;
        } else {
          let matchedCategoryId = this.props.currentProductDetail.ProductCategory1_id;
          const catTag = this.props.groupCategories.find((value) => {
            if (value.ProductCategory_id === matchedCategoryId) {
              return value;
            }
          });
          rNo = `${catTag.Name}-${this.props.PackageType_2.value ? this.props.PackageType_2.value : this.props.PackageType_2}/${this.props.MeasureUnit_2.value ? this.props.MeasureUnit_2.value : this.props.MeasureUnit_2 }`;
        }
      }
      this.props.change('RefNum', rNo);
    }

  renderGenerateReferenceNumber = () => {
    if (isBD()) {
      return (
        <div style={{ marginBottom: 8 }}>
          <Button
            bsStyle="primary"
            type="button"
            onClick={this.generateRefNo}
          >
            <em className="fa fa-save" />
            <Translate value="Generate Ref No" />
          </Button>
        </div>
      )
    }
  }

  handleFocusQty = (suggestProduct) => {
    this.state.suggestProduct = suggestProduct;
  }

  renderAutoSuggest() {
    return (
      <MixProductAutoSuggest
        value={this.state.suggestValue}
        onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
        handleKeyPress={this.handleKeyPress}
        handleFocusQty={this.handleFocusQty}
        SearchType={this.state.productSearchType}
      />
    );
  }

  renderAvgCost() {
    const showProductCost = () => {
      if (checkPermissionLocal('no_show_product_cost')) {
        return false
      }
      return true
    }
    if (this.props.currentProductDetail) {
      let currentProductDetail = this.props.currentProductDetail;
      let netCost = currentProductDetail.NetCost;
      let productCost = currentProductDetail.ProductCost
      const message = `FOB: ${this.props.currentProductDetail.FOBUnitPrice}  <br>  CIF: ${this.props.currentProductDetail.CIFUnitPrice} `
      if (isEcity) {
        return(
          <div>
            <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label className="col-xs-6"> <Translate value="Shipping_fee"/></label>
              <div className="col-xs-6">
                {/* <input value={this.props.currentProductDetail.ShippingFeeUnitPrice} disabled style={customizedInputStyle}/> */}
                <Field name="ShippingFeeUnitPrice" disabled={!checkPermission('change_shipping_misc')} className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label className="col-xs-6"> <Translate value="Misc_fee"/></label>
              <div className="col-xs-6">
                {/* <input value={this.props.currentProductDetail.MiscUnitPrice} disabled style={customizedInputStyle}/> */}
                <Field name="MiscUnitPrice" disabled={!checkPermission('change_shipping_misc')} className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            {
              showProductCost() && <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }}  onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="prod_cost"/></label>
              <ReactTooltip multiline={true}/>
              <div className="col-xs-6">
                <Field name="ProductCost" className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            }
            <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }}  onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="shipping" /></label>
              <ReactTooltip multiline={true}/>
              <div className="col-xs-6">
                <Field name="ShippingFeeUnitPrice" disabled={true} className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  // this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
          </div>
        )
      } else if(isHMM || isUSPride) {
        if (checkPermission('hmm_view_arrival') || isUSPride) {
          return (
            <div>
              <div className="form-group mb0">
                <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="prod_cost" /></label>
                <ReactTooltip multiline={true} />
                <div className="col-xs-6">
                  <Field name="ProductCost" className="control-label" withRef={true} ref="ProductCost" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    this.handleKeyPress('Shipping', event);
                  }} />
                </div>
              </div>
              <div className="form-group mb0">
                <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="Shipping_fee" /></label>
                <ReactTooltip multiline={true} />
                <div className="col-xs-6">
                  <Field name="ShippingFeeUnitPrice" className="control-label" withRef={true} ref="Shipping" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    this.handleKeyPress('TaxAmount', event);
                  }} />
                </div>
              </div>
              <div className="form-group mb0">
                <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="tax_amount" /></label>
                <ReactTooltip multiline={true} />
                <div className="col-xs-6">
                  <Field name="TaxAmount" className="control-label" withRef={true} ref="TaxAmount" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    this.handleKeyPress('Overhead', event);
                  }} />
                </div>
              </div>
              <div className="form-group mb0">
                <p ref={ref => this.fooRef = ref} data-tip={message} style={{ position: 'absolute', marginLeft: '40px' }}></p>
                <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }} onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="over_head" /></label>
                <ReactTooltip multiline={true} />
                <div className="col-xs-6">
                  <Field name="MiscUnitPrice" className="control-label" withRef={true} ref="Overhead" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    this.handleKeyPress('RefPrice', event);
                  }} />
                </div>
              </div>
            </div>
          )
        } else {
          <div></div>
        }
      } else {
        return (
          <div>
            {
              showProductCost() && <div className="form-group">
                <label className="col-xs-6"><Translate value="avg_cost"/></label>
                <div className="col-xs-6">
                  <Field name="InStockPrice" className="control-label" withRef={true} ref="InStockPrice" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    this.handleKeyPress('ProductCost', event);
                  }}/>
                </div>
              </div>
            }
            {
              showProductCost() && <div className="form-group mb0">
              <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
              <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }}  onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="prod_cost"/></label>
              <ReactTooltip multiline={true}/>
              <div className="col-xs-6">
                <Field name="ProductCost" className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}/>
              </div>
            </div>
            }
            {
              !((isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_product_cost')) &&
              <div className="form-group mb0">
                <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
                <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }}  onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="shipping"/></label>
                <ReactTooltip multiline={true}/>
                <div className="col-xs-6">
                  <Field name="ShippingFeeUnitPrice" className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                    // this.handleKeyPress('RefPrice', event);
                  }}/>
                </div>
              </div>
            }
             {
              isGFD &&
              <div className="form-group mb0" style={{marginTop: '10px'}}>
                <label className="col-xs-6">
                <Translate value="case_cost"/>
                </label>
                <div className="col-xs-6">
                <Field name="CaseCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="CaseCost" onKeyPress={(event) => {}}/>
                </div>
              </div>
            }
            {
              isGGI &&
              <div className="form-group mb0">
                <p ref={ref => this.fooRef = ref} data-tip={message} style={{position: 'absolute', marginLeft: '40px'}}></p>
                <label onMouseEnter={() => { ReactTooltip.show(this.fooRef) }}  onMouseLeave={() => { ReactTooltip.hide(this.fooRef) }} className="col-xs-6"> <Translate value="surcharge"/></label>
                <ReactTooltip multiline={true}/>
                <div className="col-xs-6">
                  <Field name="SurchargeUnitPrice" disabled={true} className="control-label" withRef={true} ref="ProductCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                  }}/>
                </div>
              </div>
            }
            {
              isSV &&
              <div className="form-group mb0" style={{marginTop: '10px'}}>
                <label className="col-xs-6">
                 HTMS
                </label>
                <div className="col-xs-6">
                <Field name="HtmsNum" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="HtmsNum" onKeyPress={(event) => {}}/>
                </div>
              </div>
            }
          </div>
        )
      }
    } else {
      return (
        <div>
          <div className="form-group">
            <label className="col-xs-6"><Translate value="inv_cost"/></label>
            <div className="col-xs-6">
              <Field name="NetCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="NetCost" onKeyPress={(event) => {
                  this.handleKeyPress('ProductCost', event)
              }}/>
            </div>
          </div>
          {
            showProductCost() && <div className="form-group mb0">
              <label className="col-xs-6"><Translate value="prod_cost"/></label>
              <div className="col-xs-6">
                <Field name="ProductCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="ProductCost" onKeyPress={(event) => {
                    this.handleKeyPress('RefPrice', event)
                }}/>
              </div>
            </div>
          }
        </div>
      )
    }
  }

  renderCloseButton() {
    if (this.props.originPage === 'products') {
      return (
        <Button bsStyle="danger" type="button" onClick={() => { this.setState({ showProductCreatedOpen: false }); this.context.router.push(`/${this.props.originPage}`); }} type="button" ><Translate value="no" /></Button>
        )
    }
    if (!this.props.originPage || this.props.originPage === 'inventories') {
      return (
        <Button bsStyle="danger" type="button" onClick={() => { this.setState({ showProductCreatedOpen: false }); window.history.back(); }} type="button" ><Translate value="no" /></Button>
      )
    }
  }

  renderImage() {
    let newImageFile = (this.state.files && this.state.files[0].preview)
    let ImageFile = ((this.state.updatedImage || (this.props.currentProductDetail && this.props.currentProductDetail.Thumbnail)) || '/img/dummy.png');
    let large = ((this.state.updatedImage || (this.props.currentProductDetail && this.props.currentProductDetail.Thumbnail)));
    if (newImageFile) {
      return (
        <div className="product-img-editor">
          <Editor
            image={newImageFile}
            upload={this.props.attachProductImage}
            Product_id={this.props.currentProductDetail && this.props.currentProductDetail.Product_id}
            clearAttachedProductImage={this.props.clearAttachedProductImage}
            width={100}
            height={100}
          />
        </div>
      )
    }
    if(isLAP) {
      return (
        <div className="product-img-view" onDoubleClick={() => {if(!!large)this.changeShowProductLargeImage(true)}}>
          <img src={ImageFile} alt="Upload image" className="img-thumbnail" />
        </div>
      )
    }
    return (
      <div className="product-img-view">
        <img src={ImageFile} alt="Upload image" className="img-thumbnail" />
      </div>
    )
  }

  checkPasscode = (e) => {
    e.preventDefault()
    this.props.setConfirmPasscodeModalVisibility(true);
  }

  changeShowProductLargeImage = (visible) => {
    this.setState({isShowProductLargeImg:visible})
  }

  setProductMetaInfoVisibility = (isVisible) => {
    this.setState({
      productMetaInfoVisibility: isVisible
    })
  }

  handleProductMetaInfoSave = (info) => {
    this.setState({
      meta_info: info,
    }, () => {
      this.setProductMetaInfoVisibility(false);
    });
  }

  handleFetchESL = () => {
    let productId = this.props.currentProductDetail.Product_id;
    this.props.fetchESL(productId)
      .then((response) => {
        this.setState({ eslFetchData: response.data });
      }, (err) => {
        alert("ESL Error: " + err.data);
      });
  }

  handleSaveESL = (ESLCode, TemplateId, TemplateName) => {
    let productId = this.props.currentProductDetail.Product_id;
    this.props.saveESL(productId, ESLCode, TemplateId, TemplateName)
      .then((response) => {
        alert("ESL Bind Successful");
        this.setState({ eslModalVisibility: false });
      }, (err) => {
        alert("ESL Error: " + err.data);
      });
  }

  renderGFDFields = () => {
    if (isGFD) {
      let warehouseOptions = this.getWarehouseOptions()
      return <div>
          <Row>
            <Col xs={3}>
              <label><Translate value="IsDepartment"/></label>
            </Col>
            <Col xs={9}>
              <Field name="IsDepartment" component={Checkbox} />
            </Col>
          </Row>
          <div className="form-group prod-name-input">
            <label className="col-xs-3"><Translate value="XFactor" /></label>
            <div className="col-xs-9">
              <Field name="XFactor" withRef={true} ref="XFactor" component={ InputField } onFocus={this.handleOnFocus} />
            </div>
          </div>
          <div className="form-group prod-name-input">
            <label className="col-xs-3"><Translate value="Stores" /></label>
            <div className="col-xs-9">
              <Field
                multi
                removeSelected
                simpleValue
                closeOnSelect={false}
                name="Warehouse"
                component={SelectionWithProps}
                options={warehouseOptions}
                placeholder={I18n.t('stores')}
                className={"autoHeight"}
              />
              {/* <Field name="Warehouse" withRef={true} ref="Warehouse" component={ Selection } options={this.props.warehouseSelection} onFocus={this.handleOnFocus} matchPos="any"/> */}
            </div>
          </div>
      </div>
    }
  }

  renderTargetProduct = () => {
    const options1 = this.props.products.map(p => ({
      label: p.Name.slice(0, 30),
      value: p.Product_id + '',
    }));
    const options2 = this.props.products.map(p => ({
      label: p.Name.slice(0, 30),
      value: p.Product_id,
    }));

    if (isTQ) {
      return <div className="form-group prod-name-input">
      <label className="col-xs-3"><Translate value="target_prod" /></label>
      <div className="col-xs-9">
        <Field
          multi
          removeSelected
          simpleValue
          closeOnSelect={false}
          name="ConvertTargetProducts"
          component={SelectionWithProps}
          options={options1}
          placeholder={I18n.t('target_prod')}
          className={"autoHeight"}
        />
      </div>
    </div>
    }
    return <div className="form-group prod-name-input">
      <label className="col-xs-3"><Translate value="target_prod" /></label>
      <div className="col-xs-9">
        <Field
          name="RelocateTargetProduct"
          withRef={true}
          ref="RelocateTargetProduct"
          component={ Selection }
          options={options2}
          onFocus={this.handleOnFocus}
          matchPos="any"
        />
      </div>
    </div>
  }

  renderBasicInfoBottom = () => {
    if (isAGD ) {
      return <Col xs={12}>
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="short_des" /></label>
          <div className="col-xs-9">
            <Field name="ShortDescription" withRef={true} ref="ShortDescription" component={ InputField } onFocus={this.handleOnFocus} />
          </div>
        </div>
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="origin" /></label>
          <div className="col-xs-9">
            <Field name="MadeIn" withRef={true} ref="MadeIn" component={ Selection } options={originOptions} onFocus={this.handleOnFocus} />
          </div>
        </div>
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="type" /></label>
          <div className="col-xs-9">
            <Field name="Type" withRef={true} ref="Type" component={ Selection } options={originOptions} onFocus={this.handleOnFocus} />
          </div>
        </div>
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-5"><Translate value="NRF_color" /></label>
              <div className="col-xs-7">
                <Field name="NRF_Color_Code" withRef={true} ref="NRF_Color_Code" component={ InputField } onFocus={this.handleOnFocus} />
              </div>
            </div>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-5"><Translate value="NRF_size" /></label>
              <div className="col-xs-7">
                <Field name="NRF_Size_Code" withRef={true} ref="NRF_Size_Code" component={ InputField } onFocus={this.handleOnFocus} />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-5"><Translate value="Gender" /></label>
              <div className="col-xs-7">
                <Field name="Gender" withRef={true} ref="Gender" component={ InputField } onFocus={this.handleOnFocus} />
              </div>
            </div>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-5"><Translate value="US_HTS" /></label>
              <div className="col-xs-7">
                <Field name="US_HTS_Codes" withRef={true} ref="US_HTS_Codes" component={ InputField } onFocus={this.handleOnFocus} />
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    }
    if (isSH) {
      return <Col xs={12}>
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="print_number" /></label>
          <div className="col-xs-9">
            <Field name="PrintNumber" withRef={true} ref="PrintNumber" component={ InputField } onFocus={this.handleOnFocus} />
          </div>
        </div>
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="shortDescription" /></label>
          <div className="col-xs-9">
            <Field name="Size" withRef={true} ref="Size" component={ Selection } options={[{label: 'CK', value: 'CK'}, {label: 'K', value: 'K'}, {label: 'Q', value: 'Q'}, {label: 'T', value: 'T'}]}onFocus={this.handleOnFocus} />
          </div>
        </div>
      </Col>
    }
    return <Col xs={12}>
      <div className="form-group prod-name-input">
        <label className="col-xs-3"><Translate value="origin" /></label>
        <div className="col-xs-9">
          <Field name="MadeIn" withRef={true} ref="MadeIn" component={ Selection } options={originOptions} onFocus={this.handleOnFocus} />
        </div>
      </div>
      {
        isSKH ?
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="customer" /></label>
          <div className="col-xs-9">
            <Field name="CustomerStr" withRef={true} ref="CustomerStr" component={InputField} onFocus={this.handleOnFocus} />
          </div>
        </div>
        :
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="fw" /></label>
          <div className="col-xs-9">
            <Field name="FW" withRef={true} ref="FW" component={ Selection } options={[{label: 'F', value: 'F'}, {label: 'W', value: 'W'}, {label: 'N.A', value: 'N.A'}]} onFocus={this.handleOnFocus} />
          </div>
        </div>
      }
      { (isTQ || isMH) && this.renderTargetProduct() }
      {this.renderGFDFields()}
      {
        isSKH &&
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="channel" /></label>
          <div className="col-xs-9">
            <Field name="Channel" withRef={true} ref="Channel" component={ Selection } options={channelOptions} onFocus={this.handleOnFocus} />
          </div>
        </div>
      }
      {
        isSV &&
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="gl" /></label>
          <div className="col-xs-9">
            <Field
                name="GLaccount"
                withRef={true}
                ref="GLaccount"
                component={ Selection }
                options={this.getFormattedGLOptions()}
                onFocus={this.handleOnFocus}
                optionRenderer={option => <span dangerouslySetInnerHTML={{__html: `&nbsp;&nbsp;&nbsp;&nbsp;`.repeat(option.level) + option.label}}/>}/>
          </div>
        </div>
      }
      {
        isGFD &&
        <div className="form-group prod-name-input">
          <label className="col-xs-3"><Translate value="top_flag" /></label>
          <div className="col-xs-9">
            <Field name="TopFlag" withRef={true} ref="TopFlag" component={InputField} />
          </div>
        </div>
      }
    </Col>
  }

  renderNetWeightLabel = () => {
    if (isSH) return <label className="col-xs-4"><Translate value="net_pcs"/></label>
    return <label className="col-xs-4"><Translate value={isSV ? "case_wt" : "net_wt"}/><span className="asteriksReq">*</span></label>
  }

  renderShipWeightLabel = () => {
    if (isSV) return <label className="col-xs-4"><Translate value="unit_ship_wt"/></label>

    if (isSH) return <label className="col-xs-4"><Translate value="ship_pcs"/></label>
    if (isGGI) return <label className="col-xs-4"><Translate value="gross_weight"/><span className="asteriksReq">*</span></label>
    return <label className="col-xs-4"><Translate value="ship_weight"/><span className="asteriksReq">*</span></label>
  }

  renderFobCost = () => {
    if(isSH) {
      return <Row className="formRow">
        <Col xs={3}>
          <label><Translate value="fob_cost" /></label>
        </Col>
        <Col xs={9}>
          <Field name="FOBCost" withRef={true} ref="FOBCost" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
            this.handleKeyPress('FOBCost', event);
          }}/>
        </Col>
      </Row>
    }
  }

  renderArrivalPrice = () => {
    if ((isOCM || isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isGGI) && checkPermissionLocal('no_show_product_cost')) {
      return;
    }
    if (isHMM) {
      return;
    }
    return (<div className="form-group mb0">
      <label className="col-xs-6">
        <Translate value="arrival_price"/>
      </label>
      <div className="col-xs-6">
        <input value={ this.props.ArrivalPrice } disabled style={customizedInputStyle}/>
      </div>
    </div>)
  }


  renderCustomDutyCost = () => {
    return (<div className="form-group mb0">
      <label className="col-xs-6">
      <Translate value="cstm_duty"/> ($)
      </label>
      <div className="col-xs-6">
        <input value={ this.props.CustomDutyCost } disabled style={customizedInputStyle}/>
      </div>
    </div>)
  }

  renderMultipleQtyOrder = () => {
    if (!isOCM) return null;
    return (<Row className="formRow">
      <Col xs={6}>
        <Row>
          <Col xs={8}>
            <label><Translate value="multiple_qty_order" /></label>
          </Col>
          <Col xs={4}>
            <Field placeholder='0' name="MultipleQuantityPerOrder" component={InputField} />
          </Col>
        </Row>
      </Col>
      <Col xs={6}>
        <Row>
          <Col xs={8}>
            <label><Translate value="limit_qty_order_desc" /></label>
          </Col>
        </Row>
      </Col>
    </Row>)
  }

  renderStockRange = () => {
    // if (isHO) return null;
    return (
      <Row>
      <Col xs={5}>
        <label><Translate value="stock_range" /></label>
      </Col>
      <Col xs={3}>
        <Row>
          <Col xs={4}>
            <label><Translate value="min" /></label>
          </Col>
          <Col xs={8}>
            <Field
              name="MinStockRange"
              withRef={true}
              ref="MinStockRange"
              component={InputField}
              onFocus={this.handleOnFocus}
              onKeyPress={(event) => {
                this.handleKeyPress('MaxStockRange', event)
              }}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={1} style={{textAlign: 'center'}}>
        <label><Translate value="~" /></label>
      </Col>
      <Col xs={3}>
        <Row>
          <Col xs={4}>
            <label><Translate value="max" /></label>
          </Col>
          <Col xs={8}>
            <Field name="MaxStockRange" withRef={true} ref="MaxStockRange" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                this.handleKeyPress('Zone', event)
            }}/>
          </Col>
        </Row>
      </Col>
    </Row>
    )
  }

  renderMSRP = () => {
    if (isOCM) {
      return <Row className="formRow">
        <Col xs={3}>
          <label><Translate value="msrp" /></label>
        </Col>
        <Col xs={3}>
          <Field placeholder='0' name="msrp" component={InputField} />
        </Col>
      </Row>
    }
  }

  renderFoodStamp = () => {
    if (!(isARC || isGFD)) return null;
    return <div>
    <Col xs={4}>
      <label><Translate value="food_stamp" /></label>
    </Col>
    <Col xs={2}>
      <Field name="IsNonFood" component={Checkbox} />
    </Col>
  </div>
  }

  renderCategoryNum = () => {
    if (isARC) {
      return <div className="form-group">
      <label className="col-xs-5">
       <Translate value="category_num"/>
      </label>
      <div className="col-xs-7">
        <Field style={{ marginBottom: 8 }} name="CategoryNum" withRef={true} ref="CategoryNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
            this.handleKeyPress('CustomerNum', event)
        }}/>
      </div>
    </div>
    }
  }

  renderSyncInventory = () => {
    if (!isSKH) return null;
    return <Col xs={6}>
    <Row>
      <Col xs={7}>
        <label><Translate value="sync_inventory"/></label>
      </Col>
       <Col xs={5}>
         <Field name="SyncInventory" component={Checkbox} />
       </Col>
    </Row>
  </Col>
  }

  renderPopularity = () => {
    if (isARC) {
      const options = [{
        label: 'A',
        value: 'A',
      }, {
        label: 'B',
        value: 'B',
      }, {
        label: 'C',
        value: 'C',
      }]

      return <Col xs={6}>
      <Row>
        <Col xs={7}>
          <label><Translate value="popularity" /></label>
        </Col>
        <Col xs={5}>
          <Field name="popularity" component={Selection} options={options} />
        </Col>
      </Row>
    </Col>
    }
  }

  renderSyncESL = () => {
    if (isARC || isSUN || isGFD) {
      const options = isSUN ? [{
        label: `2.6"Red,White,Black`,
        value: `2.6"Red,White,Black`,
      }] : [{
        label: `2.6" Black, White`,
        value: `2.6" Black, White`,
      }, {
        label: `2.9"Red,White,Black`,
        value: `2.9"Red,White,Black`,
      }, {
        label: `4.2"Red,White,Black`,
        value: `4.2"Red,White,Black`,
      },{
        label: `7.5"Red,White,Black`,
        value: `7.5"Red,White,Black`,
      }]
      return <Col xs={6}>
      {/* <Row>
        <Col xs={7}>
          <label><Translate value="food_stamp"/></label>
        </Col>
         <Col xs={5}>
           <Field name="IsFoodStamp" component={Checkbox} />
         </Col>
      </Row> */}
      <Row>
        <Col xs={7}>
          <label><Translate value="esl_sync"/></label>
        </Col>
         <Col xs={5}>
           <Field name="IsSyncToESL" component={Checkbox} />
         </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <label><Translate value="name"/></label>
        </Col>
         <Col xs={9}>
           <Field name="TemplateName" component={Selection}  options={options} disabled={!this.props.IsSyncToESL}/>
         </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <label><Translate value="code"/></label>
        </Col>
         <Col xs={9}>
           <Field name="ESLCode" component={InputField} disabled={!this.props.IsSyncToESL}/>
         </Col>
      </Row>
    </Col>
    }
  }

  handlePricelvlChangeSunsun = ({ priceLevel, lvlPriceSun }) => {
    // document.getElementById(id).value = (parseFloat(this.props.RefPriceValue) + parseFloat(value)).toFixed(2);
    // const event = new Event('input', { bubbles: true });
    // document.getElementById(id).dispatchEvent(event);
    const price = lvlPriceSun ? lvlPriceSun : 0;
    const value = (parseFloat(price) + parseFloat(this.props.RefPriceValue)).toFixed(2);
    const percentage = calculatePricePercentage(value, this.props.RefPriceValue, null);
    const priceLevelPercentage = lowerFirst(priceLevelFieldsMap[upperFirst(priceLevel)]);
    this.setState({
      [priceLevel]: value,
      [priceLevelPercentage]: percentage,
    });
  }

  renderPriceLevel1 = () => {
    if (isSUN) {
      return <Col xs={8}>
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_1" />%</label>
              <div className="col-xs-7">
                <Field
                  name="P1Percentage"
                  className="control-label"
                  component={ControlledInputField}
                  onFocus={this.handleOnFocus}
                  withRef={true}
                  ref="LV1"
                  placeholder={this.state.p1Percentage ? parseInt(this.state.p1Percentage) : ''}
                  onChange={(event) => { this.handlePercentageChange("p1Percentage", event) }}
                  onKeyPress={(event) => {this.handleKeyPress('LV2', event)}}
                  disabled={isJML && !checkPermission('change_price_level')}
                />
              </div>
            </div>
            <span className="equal-sign">||</span>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_1" />$</label>
              <div className="col-xs-7">
                <input value={ this.state.priceLevel1Sunsun } style={{ ...customizedInputStyle, backgroundColor: 'white' }} onChange={({ target }) => this.setState({ priceLevel1Sunsun: target.value }, () => {
                  this.handlePricelvlChangeSunsun({ priceLevel: 'priceLv1', lvlPriceSun: this.state.priceLevel1Sunsun });
                })}/>
              </div>
            </div>
            <span className="equal-sign">=</span>
          </Col>
        </Row>
    </Col>
    }
    return (
      <Col xs={4}>
        <div className="form-group">
          <label className="col-xs-4"><Translate value="lv_1" />%</label>
          <div className="col-xs-7">
            <Field
              name="P1Percentage"
              className="control-label"
              component={ControlledInputField}
              onFocus={this.handleOnFocus}
              withRef={true}
              ref="LV1"
              placeholder={this.state.p1Percentage}
              onChange={(event) => { this.handlePercentageChange("p1Percentage", event) }}
              onKeyPress={(event) => {this.handleKeyPress('LV2', event)}}
              disabled={isJML && !checkPermission('change_price_level')}
            />
          </div>
        </div>
        <span className="equal-sign">=</span>
      </Col>
    )
  }

  renderPriceLevel2 = () => {
    if (isSUN) {
      return <Col xs={8}>
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_2" /> %</label>
              <div className="col-xs-7">
                <Field name="P2Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV2" placeholder={this.state.p2Percentage ? parseInt(this.state.p2Percentage) : ''} onChange={(event) => { this.handlePercentageChange("p2Percentage", event) }} onKeyPress={(event) => {
                  this.handleKeyPress('LV3', event)}} disabled={isJML && !checkPermission('change_price_level')} />
              </div>
            </div>
            <span className="equal-sign">||</span>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_2" />$</label>
              <div className="col-xs-7">
                <input value={ this.state.priceLevel2Sunsun } style={{ ...customizedInputStyle, backgroundColor: 'white' }} onChange={({ target }) => this.setState({ priceLevel2Sunsun: target.value }, () => {
                  this.handlePricelvlChangeSunsun({ priceLevel: 'priceLv2', lvlPriceSun: this.state.priceLevel2Sunsun });
                })}/>
              </div>
            </div>
            <span className="equal-sign">=</span>
          </Col>
        </Row>
      </Col>
    }
    return (
      <Col xs={4}>
        <div className="form-group">
          <label className="col-xs-4"><Translate value="lv_2" /> %</label>
          <div className="col-xs-7">
            <Field name="P2Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV2" placeholder={this.state.p2Percentage} onChange={(event) => { this.handlePercentageChange("p2Percentage", event) }} onKeyPress={(event) => {
              this.handleKeyPress('LV3', event)}} disabled={isJML && !checkPermission('change_price_level')} />
          </div>
        </div>
        <span className="equal-sign">=</span>
      </Col>
    )
  }

  renderPriceLevel3 = () => {
    if (isSUN) {
      return <Col xs={8}>
        <Row>
          <Col xs={6} className="level-col-percentages">
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_3" /> %</label>
              <div className="col-xs-7">
                <Field name="P3Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV3" placeholder={this.state.p3Percentage ? parseInt(this.state.p3Percentage) : ''} onChange={(event) => { this.handlePercentageChange("p3Percentage", event) }} onKeyPress={(event) => {
                  this.handleKeyPress('LV4', event)}} disabled={isJML && !checkPermission('change_price_level')} />
              </div>
            </div>
            <span className="equal-sign">||</span>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_3" />$</label>
              <div className="col-xs-7">
                <input value={ this.state.priceLevel3Sunsun } style={{ ...customizedInputStyle, backgroundColor: 'white' }} onChange={({ target }) => this.setState({ priceLevel3Sunsun: target.value }, () => {
                  this.handlePricelvlChangeSunsun({ priceLevel: 'priceLv3', lvlPriceSun: this.state.priceLevel3Sunsun });
                })}/>
              </div>
            </div>
            <span className="equal-sign">=</span>
          </Col>
        </Row>
      </Col>
    }
    return (
      <Col xs={4} className="level-col-percentages">
        <div className="form-group">
          <label className="col-xs-4"><Translate value="lv_3" /> %</label>
          <div className="col-xs-7">
            <Field name="P3Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV3" placeholder={this.state.p3Percentage} onChange={(event) => { this.handlePercentageChange("p3Percentage", event) }} onKeyPress={(event) => {
              this.handleKeyPress('LV4', event)}} disabled={isJML && !checkPermission('change_price_level')} />
          </div>
        </div>
        <span className="equal-sign">=</span>
      </Col>
    )
  }


  renderPriceLevel4 = () => {
    if (isSUN) {
      return <Col xs={8}>
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_4" /> %</label>
              <div className="col-xs-7">
                <Field name="P4Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV4" placeholder={this.state.p4Percentage ? parseInt(this.state.p4Percentage) : ''} onChange={(event) => { this.handlePercentageChange("p4Percentage", event) }} onKeyPress={(event) => {
                  this.handleKeyPress('LV5', event)}} disabled={isJML && !checkPermission('change_price_level')} />
              </div>
            </div>
            <span className="equal-sign">||</span>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_4" />$</label>
              <div className="col-xs-7">
                <input value={ this.state.priceLevel4Sunsun } style={{ ...customizedInputStyle, backgroundColor: 'white' }} onChange={({ target }) => this.setState({ priceLevel4Sunsun: target.value }, () => {
                  this.handlePricelvlChangeSunsun({ priceLevel: 'priceLv4', lvlPriceSun: this.state.priceLevel4Sunsun });
                })}/>
              </div>
            </div>
            <span className="equal-sign">=</span>
          </Col>
        </Row>
      </Col>
    }
    return (
      <Col xs={4}>
        <div className="form-group">
          <label className="col-xs-4"><Translate value="lv_4" /> %</label>
          <div className="col-xs-7">
            <Field name="P4Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV4" placeholder={this.state.p4Percentage} onChange={(event) => { this.handlePercentageChange("p4Percentage", event) }} onKeyPress={(event) => {
              this.handleKeyPress('LV5', event)}} disabled={isJML && !checkPermission('change_price_level')} />
          </div>
        </div>
        <span className="equal-sign">=</span>
      </Col>
    )
  }

  renderPriceLevel5 = () => {
    if (isSUN) {
      return <Col xs={8}>
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_5" /> %</label>
              <div className="col-xs-7">
                <Field name="P5Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV5" placeholder={this.state.p5Percentage ? parseInt(this.state.p5Percentage) : ''} onChange={(event) => { this.handlePercentageChange("p5Percentage", event) }} onKeyPress={(event) => {
                  this.handleKeyPress('LV1_2', event)}} disabled={isJML && !checkPermission('change_price_level')} />
              </div>
            </div>
            <span className="equal-sign">||</span>
          </Col>
          <Col xs={6}>
            <div className="form-group">
              <label className="col-xs-4"><Translate value="lv_5" />$</label>
              <div className="col-xs-7">
                <input value={ this.state.priceLevel5Sunsun } style={{ ...customizedInputStyle, backgroundColor: 'white' }} onChange={({ target }) => this.setState({ priceLevel5Sunsun: target.value }, () => {
                  this.handlePricelvlChangeSunsun({ priceLevel: 'priceLv5', lvlPriceSun: this.state.priceLevel5Sunsun });
                })}/>
              </div>
            </div>
            <span className="equal-sign">=</span>
          </Col>
        </Row>
      </Col>
    }
    return (
      <Col xs={4}>
        <div className="form-group">
          <label className="col-xs-4"><Translate value="lv_5" /> %</label>
          <div className="col-xs-7">
            <Field name="P5Percentage" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV5" placeholder={this.state.p5Percentage} onChange={(event) => { this.handlePercentageChange("p5Percentage", event) }} onKeyPress={(event) => {
              this.handleKeyPress('LV1_2', event)}} disabled={isJML && !checkPermission('change_price_level')} />
          </div>
        </div>
        <span className="equal-sign">=</span>
      </Col>
    )
  }

  renderBarcodeHalf = () => {
    if (isARC) {
      const url = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_half/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      return <Button
        type="button"
        bsStyle="primary"
        className="textAlignStyle"
        href={url}
        disabled={!this.props.currentProduct && !this.props.params.id}
      >
        <em className="fa fa-barcode" /><Translate value={ "barcode_half" } />
      </Button>
    }
  }

  renderPdfBarcode = () => {
    if(isCCW) {
      return <Button
        type="button"
        bsStyle="primary"
        className="textAlignStyle"
        disabled={!this.props.currentProduct && !this.props.params.id}
        onClick={this.handleBarcodePdfPrint}
      >
        <em className="fa fa-barcode" /><Translate value={ "barcode" } />
      </Button>
    }
  }


  renderBarcodeTranslate = () => {
    if (isSV) {
      return <Translate value={"label_10"} />
    }
    if (isARC) {
      return <Translate value={"barcode_8_11"} />
    }
    return <Translate value={"barcode"} />

  }

handleAddProductParts = product => {
  let productPartsList = JSON.parse(JSON.stringify(this.state.productParts.rows));
  const existingParts = lodashFind(productPartsList, productParts => productParts.ProductNum === product.ProductNum);
  if (existingParts) {
      productPartsList = lodashFilter(productPartsList, productParts => productParts.ProductNum !== existingParts.ProductNum);
  } else {
    const newProduct = {
      PackageType: product.PackageType,
      ProductType: product.ProductType,
      ProductNum: product.ProductNum,
      RefNum: product.RefNum,
      Product_id: product.Product_id,
      auto_convert: false,
      index: productPartsList.length,
      ConvertNum: 1,
      MeasureUnit: product.MeasureUnit,
      Name: product.Name,
    };
    productPartsList.push(newProduct);
  }
  this.setState({
    productParts: {
      ...this.state.productParts,
      rows: productPartsList,
    }
  });
}

handlePartsInput = (part, e) => {
  const productPartsList = JSON.parse(JSON.stringify(this.state.productParts.rows));
  let upIndex = part.index;
  let index = productPartsList.findIndex(item => item.ProductNum == part.ProductNum)
  if(index != -1) {
    upIndex = index;
  }
  productPartsList[upIndex].ConvertNum = e;
  this.setState({
    productParts: {
      ...this.state.productParts,
      rows: productPartsList,
    }
  }, () => {
    let name = `pro_bom_input${part.ProductNum}`;
    var inputElement = document.querySelector(`[name=${name}]`)
    inputElement.focus();
  });
}

  render() {
    const productDetailsPanelHeader = (<h2><Translate value="basic_info" /></h2>);
    const productDetailsPanelHeader2 = (<h2><Translate value="basic_info2" /></h2>);
    const packageDetailsPanelHeader = (<h2><Translate value="packaging" /></h2>);
    const productFamilyPanelHeader = (<h2><Translate value="product_family" /></h2>);
    const mixProductPanelHeader = (<h2><Translate value="mix_product" /></h2>)
    const costsDetailsPanelHeader = (<h2><Translate value="cost" /></h2>);
    const saleDetailsPanelHeader = (<h2><Translate value="sale" /></h2>);
    const buyerDetailsPanelHeader = (<h2><Translate value="purchase" /></h2>);
    const vendorDetailsPanelHeader = (<h2><Translate value="vendor_associated" /></h2>);
    const convertDetailsPanelHeader = (<h2><Translate value={isVAK ? 'combination' : 'convert'} /></h2>);
    const inventoryDetailsPanelHeader = (<h2><Translate value="inventory" /></h2>);
    const vendorPanelHeader = (isVAK ? <h2><Translate value="vendor" /></h2> : <h2><Translate value="barcode" /></h2>);
    const amzInfolHeader = (<h2><Translate value="amazon_info" /></h2>);
    const productInformation = (<Translate value="product_information" />);
    const inventoryInformation = (<Translate value="inventory_information" />);
    const productCostAndPrice = (<Translate value="product_cost_and_price" />);
    const packageAndWeight = (<Translate value="package_slashsign_weight" />);
    const bardcodeTranslation = (<Translate value="barcode" />);
    const productGroupAndCategory = (<Translate value="product_group_and_category" />);
    const productDetail = (<Translate value="product_detail" />);
    const productDetailsHeader = (<h2><Translate value="product_details" /></h2>);
    const viewPromotionHeader = (<Translate value="view_promotions" />);
    const editRecPermissionChange = (<Translate value="permission_for_changing_product_number" />);
    const editRecPermissionDuplicate = (<Translate value="permission_for_duplicating_product" />);
    const editGroupFormChangeGroupTitle = (<Translate value="edit_group" />);
    const editGroupFormDuplicateProdTitle = (<Translate value="duplicate_product" />);
    const mobileDescBoxTitle = (<Translate value="mobile_description_box" />);
    const displayCategoryBoxTitle = (<Translate value="edit_display_category" />);
    const imagesModalTitle = (<Translate value="upload_images" />);
    const addConvertProductsTitle = (<Translate value="products" />)
    const deleteProduct = (<Translate value="delete_product" />);
    const editPromotionTitle = <Translate value="edit_promotion" />;
    const skusModalTitle = <Translate value="skus" />;
    const marketModalTitle = <Translate value="Marketing" />;
    const productMetaInfoTitle = <Translate value="edit_product_meta" />;
    const eslTitle = <Translate value="edit_esl" />;

    const productGroupPanelHeader = (
      <h2>
        <Translate value="packaging" />
        {
          (this.props.currentProduct)
          ?
          <Button bsStyle="warning" className="edit-product-group-button" onClick={this.openEditRecPermission}>
            <em className="fa fa-pencil"></em>
          </Button>
          :
          <span />
        }
      </h2>
    );
    const { handleSubmit, invalid, submitting, pristine } = this.props;

    const createDialogStyle = {
      width: '650px',
      height: '430px',
      marginLeft: '-15%',
    };
    const createLargeDialogStyle = {
      width: '850px',
      height: '530px',
      marginLeft: '-25%',
    };
    const createDisplayCategoryDialogStyle = {
      width: '700px',
      height: '500px',
      marginLeft: '-15%',
    };
    const promotionsStyle = {
      width: '800px',
      height: '480',
      marginLeft: '-15%',
    };
    const deletePromotionDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-10%',
      marginTop: '-100px',
    };
    const editPromotionDialog = {
      width: '550px',
      height: '300px',
      marginLeft: '-10%',
      marginTop: '-100px',
    };
    const imagesModalStyle = {
      width: '700px',
      height: '700px',
      top: '30%',
      marginLeft: '-15%',
    };
    const convertProductListStyle = {
      width: '800px',
      height: '470px',
      marginLeft: '-20%',
    };
    const bomProductListStyle = {
      width: '1000px',
      height: '600px',
      marginTop: '-20%',
      marginLeft: '-30%'
    }
    const createProductMetaStyle = {
      width: '700px',
      height: '280px',
      marginLeft: '-15%',
    };
    const createESLStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };

    const createLAPLARGEStyle = {
      width: '1000px',
      height: '500px',
    };
    const renderRichTextEditor = () => {
      if(isLE || isOLG) {
        return <SkyLightStateless
          dialogStyles={createLargeDialogStyle}
          isVisible={this.state.mobileDescBoxOpen}
          onCloseClicked={() => { this.closeMobileDescBox(); }}
          title={mobileDescBoxTitle}
        >
          <TuiEditor
            htmlString={this.state.mobileDescriptionHTML}
            placeholder="Enter the product description."
            saveHtml={(htmlText) => { this.saveRichText(htmlText); }}
            isLoadingSave={this.props.isLoadingDescriptionBoxSave}
            saveSuccess={this.props.saveMobileDescriptionTextSuccess}
          />
        </SkyLightStateless>
      }
      return <SkyLightStateless
        dialogStyles={createDialogStyle}
        isVisible={this.state.mobileDescBoxOpen}
        onCloseClicked={() => { this.closeMobileDescBox(); }}
        title={mobileDescBoxTitle}
      >
        <RichTextEditor
          htmlString={this.state.mobileDescriptionHTML}
          placeholder="Enter the product description."
          saveHtml={(htmlText) => { this.saveRichText(htmlText); }}
          isLoadingSave={this.props.isLoadingDescriptionBoxSave}
          saveSuccess={this.props.saveMobileDescriptionTextSuccess}
        />
      </SkyLightStateless>
    }

    const renderIsLap = () => {
      return isLAP && <SkyLightStateless dialogStyles={createLAPLARGEStyle} isVisible={this.state.isShowProductLargeImg} onCloseClicked={() => { this.changeShowProductLargeImage(false); }}>
      <LargeImageModal
       img={((this.state.updatedImage || (this.props.currentProductDetail && (this.props.currentProductDetail.Thumbnail || this.props.currentProductDetail.Images && this.props.currentProductDetail.Images != null &&  this.props.currentProductDetail.Images[1]))))}
       />
    </SkyLightStateless>
    }

    if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...reading data</ContentWrapper>
    else {
      let measureUnitOptions = this.getMeasureUnitOptions();
      let getZoneOptions = this.getZoneOptions();
      let getBinOptions = this.getBinOptions();
      let getLevelOptions = this.getLevelOptions();
      // let getZone2Options = this.getZone2Options();
      let getBin2Options = this.getBin2Options();
      let getLevel2Options = this.getLevel2Options();
      // let getZone3Options = this.getZone3Options();
      let getBin3Options = this.getBin3Options();
      let getLevel3Options = this.getLevel3Options();
      let packageTypeOptions = this.getPackageTypeOptions();
      
      let url = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      if (isGFD) {
        url = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode/${this.props.ProductNumber}?warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}&Bearer=${localStorage.getItem('token')}`;
      }
      const urlForLabel = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode2/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForLargeLabelWin = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_large/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForLargeLabelMac = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_large_mac/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForSmallLabelWin = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_small/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      const urlForSmallLabelMac = this.props.ProductNumber && `${ROOT_URL}v1/warehouse/printbarcode_small_mac/${this.props.ProductNumber}?Bearer=${localStorage.getItem('token')}`;
      let editGroupFormSaveAction;
      let editGroupFormSaveActionCallback;
      let editRecPermission;
      let editGroupFormTitle;
      if (this.state.editGroupFormAction === 'duplicate') {
        editGroupFormSaveAction = this.props.duplicateProduct;
        editGroupFormSaveActionCallback = () => {};
        editRecPermission = editRecPermissionDuplicate;
        editGroupFormTitle = editGroupFormDuplicateProdTitle;
      } else if (this.state.editGroupFormAction === 'changeGroup') {
        editGroupFormSaveAction = this.props.updateProductGroup;
        editGroupFormSaveActionCallback = (productId) => this.props.fetchProductDetail(productId, this.props.selectedCompany, this.props.selectedWarehouse);
        editRecPermission = editRecPermissionChange;
        editGroupFormTitle = editGroupFormChangeGroupTitle;
      }

      const productEditDisablePermission = (isOLG || isVAK) && !checkPermissionLocal('change_product') || checkPermissionLocal('disable_product_edit');
      const productDeletePermission = !checkPermissionLocal('delete_product');
      const ProductType = this.props.ProductType ? (this.props.ProductType.value || this.props.ProductType) : undefined;
      const productCategoryId = this.props.currentProductDetail
        ? this.props.currentProductDetail.ProductCategory1_id
        : this.state.productNavigation_1.ProductCategory1_id
          ? this.state.productNavigation_1.ProductCategory1_id.value
          : null;
      const dateFlagOptions = [{
        label: 'No Print',
        value: 'No Print',
      }, {
        label: 'Pack Date',
        value: 'Pack Date',
      }, {
        label: 'Sell By Date',
        value: 'Sell By Date',
      }, {
        label: 'Pack+Sell By',
        value: 'Pack+Sell By',
      }];
      const popularityOptions = [
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
        { value: 'D', label: 'D' },
        { value: 'N', label: 'N' },
      ];
      return (
        //---------------
        // Begin HTML: Create New/Edit Purchase Order
        //---------------
        <ContentWrapper>
          <form className="form-horizontal" method="get" action="#" onSubmit={() => { console.log('attempting to submit')}} >
            {/* Navigation Trail */}
            <Breadcrumb style={this.state.crumbStyle}>
              <Breadcrumb.Item>
                <Translate value="general_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/products"><Translate value="products" /></Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="edit_product" />
              </Breadcrumb.Item>
              <span style={{ color: 'red', display: 'inline', 'padding-left': '30px' }}>{(this.props.detailError) ? 'Product does not exist': ''}</span>
            </Breadcrumb> {/* End Navigation Trail */}
            {/* Product Header Nav */}
            <div id="search-product-header-nav">
              {/* <Row style={{ "margin-right": "50%" }}> */}
              <Row style={{ marginRight: isEcity ? "770px" : "45%" }}>
                {/* <Col xs={1} xsOffset={3}> */}
                <Col xs={1}>
                  <span style={{ display: "inline" }} className="fa fa-arrow-circle-left btn-lg prev-arrow" onClick={() => {
                    if (this.props.currentProductDetail && checkPermission('change_product')) {
                      this.setState({ updatedImage: undefined });
                      if (isHMM) {
                        this.props.fetchPreviousProductWithGeno(this.props.currentProductDetail.GeneralNum, this.props.selectedCompany, this.props.selectedWarehouse);
                        return;
                      }
                      this.props.fetchPreviousProduct(this.props.currentProductDetail.ProductNum, this.props.selectedCompany, this.props.selectedWarehouse);
                    }
                  }}
                  >
                  </span>
                </Col>
                <Col xs={4} className="centerStyle" style={{ 'width': '37%' }}>
                  <Field
                    style={{ display: "inline", 'max-width': "100%" }}
                    name={ isHMM ? "GeneralNumber" : "ProductNumber"}
                    component={InputField}
                    disabled={!checkPermission('change_product')}
                    onKeyPress={(event) => {
                      if (event.charCode == 13) {
                        event.preventDefault();

                        // if (this.props.ProductNumber === this.props.ProductNum) {
                        //   alert('please search using different product number')
                        //   return;
                        // }
                        this.setState({ updatedImage: undefined });
                        let trimNumber = this.props.ProductNumber;
                        if(this.props.ProductNumber) {
                          trimNumber = this.props.ProductNumber.trim();
                        }
                        this.props.fetchProductByNum(trimNumber, this.props.selectedCompany, this.props.selectedWarehouse, { isHMM, GeneralNumber: this.props.GeneralNumber });
                      }
                    }}
                  />
                 </Col>
                 <Col xs={1}>
                  <span style={{ display: "inline" }} className="fa fa-arrow-circle-right btn-lg next-arrow" onClick={() =>{
                    if (this.props.currentProductDetail && checkPermission('change_product')) {
                      this.setState({ updatedImage: undefined });
                      if (isHMM) {
                        this.props.fetchNextProductWithGeno(this.props.currentProductDetail.GeneralNum, this.props.selectedCompany, this.props.selectedWarehouse);
                        return;
                      }
                      this.props.fetchNextProduct(this.props.currentProductDetail.ProductNum, this.props.selectedCompany, this.props.selectedWarehouse);
                    }
                  }}>
                  </span>
                </Col>
              </Row>
            </div> {/* End Product Header Nav */}

            {/* Button Actions */}
            <ButtonToolbar id="breadcrumbButtonGroup">
            {
              (!(isEcity) || checkPermission('delete_product')) &&
              <span>
                <Button
                  type="button"
                  bsStyle="danger"
                  onClick={this.openDeleteModal}
                  disabled={(isSUN || productEditDisablePermission && !(isGGI || isVAK) || (isGGI || isVAK) && productDeletePermission)}
                >
                  <em className="fa" /><Translate value="delete" />
                </Button>
                <Button
                  style={{marginLeft: '5px'}}
                  type="button"
                  bsStyle="warning"
                  onClick={() => {
                    if (this.props.currentProductDetail) {
                      if (this.props.currentProductDetail.IsDiscontinued) {
                        this.props.continueProduct(this.props.currentProductDetail.Product_id);
                      } else {
                        this.props.discontinueProduct(this.props.currentProductDetail.Product_id);
                      }
                    }
                  }}
                  disabled={productEditDisablePermission}
                >
                  <Translate value={this.props.currentProductDetail && this.props.currentProductDetail.IsDiscontinued ? 'continue_product' : 'discontinue'} />
                </Button>
              </span>
            }
              <Button
                type="button"
                bsStyle="primary"
                onClick={this.viewPromotion}
                disabled={!this.state.Product_id}
              >
                <em className="fa fa-eye" /><Translate value="promo" />
              </Button>
              {this.renderBarcodeHalf()}
              {!isCCW && <Button
                type="button"
                bsStyle="primary"
                className="textAlignStyle"
                href={url}
                disabled={!this.props.currentProduct && !this.props.params.id}
              >
                <em className="fa fa-barcode" />{this.renderBarcodeTranslate()}
              </Button>}
              {isGFD && <Button
                type="button"
                bsStyle="primary"
                className="textAlignStyle"
                // href={url}
                disabled={!this.props.currentProduct && !this.props.params.id}
                onClick={this.openScaleLabelModal}
              >
                <em className="fa fa-barcode" /><Translate value="nonfixed_barcode" />
              </Button>}
              {this.renderPdfBarcode()}
              {
                (!isEcity && !isGFD) &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForLabel}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value={ isSV ? "label_30" : "label"} />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForSmallLabelWin}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="small_label_win" />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForSmallLabelMac}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="small_label_mac" />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForLargeLabelWin}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="large_label_win" />
                </Button>
              }
              {
                isEcity &&
                <Button
                  type="button"
                  bsStyle="primary"
                  className="textAlignStyle"
                  href={urlForLargeLabelMac}
                  disabled={!this.props.currentProduct && !this.props.params.id}
                >
                  <em className="fa fa-print" /><Translate value="large_label_mac" />
                </Button>
              }
              <Button
                type="button"
                bsStyle="primary"
                onClick={this.pushInventoryDetail.bind(this)}>
                <em className="fa fa-eye" /><Translate value="inv" />
              </Button>
              <Button
                type="button"
                action="submit"
                bsStyle="success"
                onClick={handleSubmit(this.handleFormSubmit.bind(this))}
                disabled={ invalid || submitting || pristine || productEditDisablePermission }
              >
                <em className="fa fa-save" /><Translate value="save" />
              </Button>
              <Button
                type="button"
                bsStyle="danger"
                onClick={() => window.history.back()}
                //onClick={(event) => { this.context.router.push(`/${this.props.originPage || "products"}`) }}
              >
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
            </ButtonToolbar> {/* End Button Actions */}
            <div className="formContainer">
              {/* if discontinued render a transparent overlay that prevent use */}
              {
                this.props.currentProductDetail && this.props.currentProductDetail.IsDiscontinued &&
                <div className="overlay"></div>
              }
              <Grid id="manage-products">
                {/* Row Wrapper */}
                <Row className="row-wrapper">
                  {/* Product Details Column */}
                  <Col xs={4}>
                    <Row>
                      <Col xs={12}>
                        {/* Product Details Panel */}
                        <Panel id="product-details" header={productDetailsPanelHeader}>
                          <Row>
                            {/* Product No. Input Fields */}
                            <Col xs={7} className="pr0 ">
                              {this.renderProductNum()}
                              <div className="form-group">
                                <label className="col-xs-5"><Translate value={(isMyuMyu || isAFG) ? "index_no": (isSH ? "item_no" : "general_no")}/></label>
                                <div className="col-xs-7">
                                  <Field name="GeneralNum" withRef={true} ref="GeneralNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('RefNum', event)
                                  }}/>
                                </div>
                              </div>
                              {
                                !isSH && 
                                <div className="form-group">
                                  <label className="col-xs-5">
                                    {
                                      (isSV || isOLG) ? <Translate value="item_num"/> : (isVAK) ? <Translate value="sku"/> : <Translate value="ref_num"/>
                                    }
                                    {
                                      (isSKH) && <span className="asteriksReq">*</span>
                                    }
                                  </label>
                                  <div className="col-xs-7">
                                    <Field style={{ marginBottom: 8 }} name="RefNum" withRef={true} ref="RefNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        this.handleKeyPress('CustomerNum', event)
                                    }}/>
                                  </div>
                                  {this.renderGenerateReferenceNumber()}
                                </div>
                              }
                              {this.renderCategoryNum()}
                              <div className="form-group">
                                <label className="col-xs-5"><Translate value="vendor_no"/></label>
                                <div className="col-xs-7">
                                  <Field name="VendorProdNo" withRef={true} ref="CustomerNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      if (isAFM) {
                                        this.handleKeyPress('Brand', event);
                                        return;
                                      }
                                      if (isSH) {
                                        this.handleKeyPress('Color', event);
                                        return;
                                      }
                                      this.handleKeyPress('Name', event);
                                  }}/>
                                </div>
                              </div>
                              {
                                isSH ?
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="front_color"/></label>
                                  <div className="col-xs-7">
                                    <Field name="Color" withRef={true} ref="Color" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        this.handleKeyPress('Name', event)
                                    }}/>
                                  </div>
                                </div>
                              :
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="brand"/></label>
                                  <div className="col-xs-7">
                                    <Field name="Brand" withRef={true} ref="Brand" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        this.handleKeyPress('Name', event)
                                    }}/>
                                  </div>
                                </div>
                              }
                              {
                                (isSDR || isCRW || isSC) &&
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="color" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Color" withRef={true} ref="Color" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              }
                              {
                                isSV &&
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="class_no"/></label>
                                  <div className="col-xs-7">
                                    <Field name="ClassNo" withRef={true} ref="ClassNo" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                       this.handleKeyPress('Name', event)
                                    }}/>
                                  </div>
                                </div>
                              }
                              {
                                isSV &&
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="create_date"/></label>
                                  <div className="col-xs-7">
                                    <Field name="ProdCreateDate" component={DatePicker} />
                                  </div>
                                </div>
                              }
                              {
                                isSV &&
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="catalog_pg"/></label>
                                  <div className="col-xs-7">
                                    <Field name="CatalogPage" withRef={true} ref="CatalogPage" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                       this.handleKeyPress('Name', event)
                                    }}/>
                                  </div>
                                </div>
                              }
                              {
                                isPTS &&
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="mfr_no"/></label>
                                  <div className="col-xs-7">
                                    <Field name="MFRNum" withRef={true} ref="MFRNum" disabled={true} component={ InputField }
                                    />
                                  </div>
                                </div>
                              }
                            </Col> {/* Product No. Input Fields */}

                            <Col xs={5}>
                              <div className="img-container">
                                {this.renderImage()}
                                <div className="product-img-uploader">
                                  <div className="well dropzone" >
                                    <Row>
                                      <Col xs={12}>
                                        <Button
                                          bsStyle="primary"
                                          type="button"
                                          className="pull-right"
                                          onClick={() => this.openImageModal()}
                                        >
                                          <em className={`fa ${this.state.isLoadingImages ? 'fa-spinner fa-spin' : 'fa-plus'}`} />
                                          {/* <Translate value="upload"/> */}
                                        </Button>
                                        {/* <SpinnerButton
                                          className="pull-right"
                                          bsStyle="primary"
                                          icon="fa-plus"
                                          onClick={() => this.fetchImages(() => this.openImageModal())}
                                          disabled={this.state.isLoadingImages}
                                          loading={this.state.isLoadingImages}
                                        /> */}
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                                {
                                  this.props.attachingProductImage &&
                                  <div className="alert alert-info">
                                    <span><Translate value="saving"/></span>
                                  </div>
                                }
                                {
                                  this.props.productImageAttached &&
                                  <div className="alert alert-success">
                                    <span><Translate value="saved" /></span>
                                  </div>
                                }
                              </div>
                            </Col> {/* End Img Uploader */}
                            {/* Product Description Fields */}
                            {
                              isSH && 
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="sku"/><span className="asteriksReq">*</span></label>
                                  <div className="col-xs-9">
                                    <Field style={{ marginBottom: 8 }} name="RefNum" withRef={true} ref="RefNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        this.handleKeyPress('CustomerNum', event)
                                    }}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            <Col xs={12}>
                              <div className="form-group prod-name-input">
                                {
                                  !isWecom &&
                                  <label className="col-xs-3"><Translate value="prod_name"/><span className="asteriksReq">*</span></label>
                                }
                                {
                                  isWecom &&
                                  <label className="col-xs-3"><Translate value="eng_name"/><span className="asteriksReq">*</span></label>
                                }
                                <div className="col-xs-9">
                                  <Field name="Name" withRef={true} ref="Name" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('Description', event)
                                  }}/>
                                </div>
                              </div>
                            </Col>
                            <Col xs={12}>
                              <div className="form-group prod-name-input">
                                {
                                  !isWecom &&
                                  <label className="col-xs-3"><Translate value="description" /></label>
                                }
                                {
                                  isWecom &&
                                  <label className="col-xs-3"><Translate value="chi_name" /></label>
                                }
                                <div className="col-xs-9">
                                  <Field name="Description" withRef={true} ref="Description" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                    if (event.charCode == 13) {
                                      event.preventDefault();
                                      this.refs["MadeIn"].getRenderedComponent().refs.select.focus();
                                    }
                                  }}/>
                                </div>
                              </div>
                            </Col>
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="customer" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Customer" component={Selection} options={this.props.customerOptions}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="vendor_style" /></label>
                                  <div className="col-xs-9">
                                  <Field name="VendorStyleNum" withRef={true} ref="VendorStyleNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3">TJX Style</label>
                                  <div className="col-xs-9">
                                    <Field name="TJXStyleNum" withRef={true} ref="TJXStyleNum" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isABCFF &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3">Size/Ratio</label>
                                  <div className="col-xs-9">
                                    <Field name="Size" withRef={true} ref="Size" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              (isSUN || isSKH) &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="description" />2</label>
                                  <div className="col-xs-9">
                                    <Field name="Description2" withRef={true} ref="Description2" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        if (event.charCode == 13) {
                                          event.preventDefault();
                                          this.refs["MadeIn"].getRenderedComponent().refs.select.focus();
                                        }
                                    }}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isSKH &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="description" />3</label>
                                  <div className="col-xs-9">
                                    <Field name="Description3" withRef={true} ref="Description3" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      if (event.charCode == 13) {
                                        event.preventDefault();
                                        this.refs["MadeIn"].getRenderedComponent().refs.select.focus();
                                      }
                                    }}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              (isSKH || isABCFF) &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="upc" /><span className="asteriksReq">*</span></label>
                                  <div className="col-xs-9">
                                    <Field name="UPC" withRef={true} ref="UPC" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              (isSKH || isABCFF || isLMH) &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="color" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Color" withRef={true} ref="Color" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              (isSKH || isABCFF) &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="gtin" /></label>
                                  <div className="col-xs-9">
                                    <Field name="GTIN" withRef={true} ref="GTIN" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {
                              isSV &&
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                    <label className="col-xs-3"><Translate value="notes"/></label>
                                  <div className="col-xs-9">
                                  <Field name="Notes" withRef={true} ref="Notes" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                              </Col>
                            }
                            {this.renderBasicInfoBottom()}
                            <Col xs={12}>
                              <div className="mobile-description-box-button">
                                <SpinnerButton
                                  bsStyle="primary"
                                  icon="fa-pencil"
                                  onClick={this.handleMobileDescBoxClick}
                                  disabled={this.state.isLoadingMobileDescBoxText}
                                  loading={this.state.isLoadingMobileDescBoxText}
                                  translation={isSV ? <Translate value="marketing_copy" /> : <Translate value="mobile_description_box" />}
                                />
                                <SpinnerButton
                                  style={{ marginLeft: '10px' }}
                                  bsStyle="primary"
                                  icon="fa-pencil"
                                  onClick={this.handleSkusClick}
                                  disabled={this.state.skusModal}
                                  loading={this.state.skusModal}
                                  translation={<Translate value="skus" />}
                                />
                                <Button
                                  style={{ marginLeft: '10px' }}
                                  bsStyle="primary"
                                  onClick={() => { this.setProductMetaInfoVisibility(true) }}
                                >
                                  <em className="fa fa-pencil" /><Translate value="meta_info" />
                                </Button>

                              </div>
                            </Col>
                            <Col xs={12}>
                            {isGGI && <SpinnerButton
                                  bsStyle="primary"
                                  icon="fa-pencil"
                                  onClick={this.handleMarketingClick}
                                  disabled={this.state.marketingModal}
                                  loading={this.state.marketingModal}
                                  translation={<Translate value="Marketing" />}
                                />}
                            </Col>
                            <Col xs={12}>
                              <div className="formSubHeaderContainer">
                                <Row>
                                  <Col xs={6}>
                                    <p className="formSubHeader"><Translate value="group" /> / <Translate value="category" /></p>
                                  </Col>
                                  <Col xs={1} xsOffset={3}>
                                    {
                                      (this.props.currentProduct || this.props.params.id) &&
                                        <Button
                                          bsStyle="primary"
                                          className="edit-product-group-button"
                                          onClick={() => this.openCheckAuthorize('duplicate')}
                                          style={{ position: "relative", left: "-10px" }}
                                        >
                                          <em className="fa fa-copy"></em>
                                        </Button>
                                    }
                                  </Col>
                                  <Col xs={1}>
                                  {
                                    (this.props.currentProduct || this.props.params.id) &&
                                      <Button
                                        bsStyle="warning"
                                        className="edit-product-group-button"
                                        onClick={() => this.openEditRecPermission('changeGroup')}
                                        style={{ position: "relative", left: "0px" }}
                                      >
                                        <em className="fa fa-pencil"></em>
                                      </Button>
                                  }
                                </Col>
                                </Row>
                              </div>

                              {
                                isGFD &&
                                <Row className="formRow">
                                  <Col xs={3}>
                                    <label><Translate value="division" /></label>
                                  </Col>
                                  <Col xs={9}>
                                    <Field name="SubjectCategory" withRef={true} ref="CustomerNum" component={InputField} onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      // this.handleKeyPress('Name', event);
                                    }} />
                                  </Col>
                                </Row>
                              }

                              {isGFD && this.renderDepartments()}
                              {this.renderGroups() }
                              {this.renderCategories() }
                              {(isAFG || isWecom || isHF) && this.renderDisplayCategories()}
                            </Col>
                          <Col xs={12}>
                            {isAFM && this.renderBrandInformation() }
                          </Col>
                          </Row>
                        </Panel> {/* End Product Details Panel */}
                      </Col>
                    </Row>

                    {isSH &&
                      <Row>
                        <Col xs={12}>
                          {/* SH Panel */}
                          <Panel id="" header={productDetailsPanelHeader2}>
                            <Row>
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="item_name" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ItemName" withRef={true} ref="ItemName" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="short_item_name" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ShortName" withRef={true} ref="ShortName" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="full_color_code" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ColorCode" withRef={true} ref="ColorCode" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="short_color_code" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ShortColorCode" withRef={true} ref="ShortColorCode" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="QB_item_no" /></label>
                                  <div className="col-xs-8">
                                    <Field name="QBItemNum" withRef={true} ref="QBItemNum" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="root_des" /></label>
                                  <div className="col-xs-8">
                                    <Field name="RootDescription" withRef={true} ref="RootDescription" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="packing_size_code" /></label>
                                  <div className="col-xs-8">
                                    <Field name="PackingSizeCode" withRef={true} ref="PackingSizeCode" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="root_item_name" /></label>
                                <div className="col-xs-8">
                                    <Field name="RootItemName" withRef={true} ref="RootItemName" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="back_PO_color" /></label>
                                  <div className="col-xs-8">
                                    <Field name="FrontPOColor" withRef={true} ref="FrontPOColor" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-4"><Translate value="front_PO_color" /></label>
                                  <div className="col-xs-8">
                                    <Field name="BackPOColor" withRef={true} ref="BackPOColor" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="root_item_no" /></label>
                                  <div className="col-xs-7">
                                    <Field name="RootItemNum" withRef={true} ref="RootItemNum" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="old_print_no" /></label>
                                  <div className="col-xs-7">
                                    <Field name="OldPrintNum" withRef={true} ref="OldPrintNum" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="back_color" /></label>
                                  <div className="col-xs-7">
                                    <Field name="BackColor" withRef={true} ref="BackColor" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="design_print_no" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DesignPrintNum" withRef={true} ref="DesignPrintNum" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="box_packing" /></label>
                                  <div className="col-xs-7">
                                    <Field name="BoxPacking" withRef={true} ref="BoxPacking" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="size" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Size" withRef={true} ref="Size" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Panel> {/* End SH Panel */}
                        </Col>
                      </Row>
                    }
                    {isAGD && <Row>
                      <Col xs={12}>
                        <Panel id="product-family" header={productFamilyPanelHeader} style={{ height: '250px' }}>
                          <Row>
                            <Col xs={12}>
                              <div className="form-group prod-name-input">
                                <label className="col-xs-3"><Translate value="family_sku"/><span className="asteriksReq">*</span></label>
                                <div className="col-xs-9">
                                  <Field name="ProductFamilySKU" withRef={true} ref="ProductFamilySKU" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('ProductFamilyName', event)
                                  }}/>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <div className="form-group prod-name-input">
                                <label className="col-xs-3"><Translate value="family_name"/><span className="asteriksReq">*</span></label>
                                <div className="col-xs-9">
                                  <Field name="ProductFamilyName" withRef={true} ref="ProductFamilyName" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('Description', event)
                                  }}/>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="option1_name" /></label>
                                <div className="col-xs-6">
                                  <Field name="ProductFamilyOption1Name" withRef={true} ref="ProductFamilyOption1Name" component={ InputField } onFocus={this.handleOnFocus} />
                                </div>
                              </div>
                            </Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="option1_value" /></label>
                                <div className="col-xs-6">
                                  <Field name="ProductFamilyOption1Value" withRef={true} ref="ProductFamilyOption1Value" component={ InputField } onFocus={this.handleOnFocus} />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="option2_name" /></label>
                                <div className="col-xs-6">
                                  <Field name="ProductFamilyOption2Name" withRef={true} ref="ProductFamilyOption2Name" component={ InputField } onFocus={this.handleOnFocus} />
                                </div>
                              </div>
                            </Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="option2_value" /></label>
                                <div className="col-xs-6">
                                  <Field name="ProductFamilyOption2Value" withRef={true} ref="ProductFamilyOption2Value" component={ InputField } onFocus={this.handleOnFocus} />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="option3_name" /></label>
                                <div className="col-xs-6">
                                  <Field name="ProductFamilyOption3Name" withRef={true} ref="ProductFamilyOption3Name" component={ InputField } onFocus={this.handleOnFocus} />
                                </div>
                              </div>
                            </Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="option3_value" /></label>
                                <div className="col-xs-6">
                                  <Field name="ProductFamilyOption3Value" withRef={true} ref="ProductFamilyOption3Value" component={ InputField } onFocus={this.handleOnFocus} />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Panel>
                      </Col>
                    </Row>}
                    <Row>
                      <Col xs={12}>
                        {/* Package Details Panel */}
                        <Panel id="package-details" header={packageDetailsPanelHeader} style={{ height: '660px' }}>
                          <Row>
                            <Col xs={12}>
                              {this.renderProductType()}
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={6}>
                              {this.renderPackageInfo()}
                            </Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <label className="col-xs-6"><Translate value="measure_unit" /><span className="asteriksReq">*</span></label>
                                <div className="col-xs-6">
                                  <Field disabled={(isAFG && !isHF) || isMyuMyu || isWecom} name="MeasureUnit" className="control-label" component={ Selection } withRef={true} ref="MeasureUnit" options={measureUnitOptions} onKeyPress={(event) => {
                                      event.stopPropagation();
                                    if (event.keyCode == 13) {
                                      this.refs["PackageType"].getRenderedComponent().refs.select.focus();
                                    }
                                  }}/>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          {
                            isSV &&
                            <Row>
                              <Col xs={6}>
                                <div className="form-group">
                                  <label className="col-xs-6"><Translate value="units/case" /></label>
                                  <div className="col-xs-6">
                                    <Field
                                      name="Units_Case"
                                      className="control-label"
                                      withRef={true}
                                      ref="Units_Case"
                                      component={ InputField }
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group">
                                  <label className="col-xs-6"><Translate value="units/box" /></label>
                                  <div className="col-xs-6">
                                  <Field
                                    name="Units_InnerBox"
                                    className="control-label"
                                    withRef={true}
                                    ref="Units_InnerBox"
                                    component={ InputField }
                                    onFocus={this.handleOnFocus}
                                    onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          }
                          {
                            !isHMM &&
                            <Row>
                              <Col xs={6}>
                                <div className="row">
                                  {this.renderNetWeightLabel()}
                                  <div className="col-xs-4" style={{ paddingRight: 0 }}>
                                    <Field name={isSV ? "CaseWt": "NetWeight"} className="control-label" withRef={true} ref={isSV ? "CaseWt": "NetWeight"} component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('ShippingWeight', event);}}
                                    />
                                  </div>
                                  <div className="col-xs-4" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                    <Field name="MeasureUnit" className="control-label" component={DisabledSelection}  options={measureUnitOptions} />
                                  </div>
                                </div>
                              </Col>
                              {
                                isSV ?
                                <Col xs={6}>
                                  <div className="form-group">
                                  <label className="col-xs-4"><Translate value="box_wt"/></label>
                                    <div className="col-xs-4" style={{ paddingRight: 0 }}>
                                      {/* <Field name="BoxWt" className="control-label" withRef={true} ref="BoxWt" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        }}/> */}
                                        {this.renderBoxWt()}
                                    </div>
                                    <div className="col-xs-4" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                      <Field name="MeasureUnit" className="control-label" component={DisabledSelection}  options={measureUnitOptions} />
                                    </div>
                                  </div>
                                </Col>
                                :
                                <Col xs={6}>
                                  <div className="form-group">
                                    {this.renderShipWeightLabel()}
                                    <div className="col-xs-4" style={{ paddingRight: 0 }}>
                                      <Field name="ShippingWeight" className="control-label" withRef={true} ref="ShippingWeight" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        this.handleKeyPress('MinWeightRange', event)
                                      }}/>
                                    </div>
                                    <div className="col-xs-4" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                      <Field name="MeasureUnit" className="control-label" component={DisabledSelection}  options={measureUnitOptions} />
                                    </div>
                                  </div>
                                </Col>
                              }
                              {
                                isGGI && (
                                <Col xs={6}>
                                  <div className="row">
                                    <label className="col-xs-6"><Translate value="actual_net_wt"/></label>
                                    <div className="col-xs-5" style={{ paddingRight: 0, paddingBottom: '5px' }}>
                                      <Field name="ActualNW" className="control-label" withRef={true} ref="NetWeight" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                        this.handleKeyPress('ShippingWeight', event);}}
                                      />
                                    </div>
                                    %
                                  </div>
                                </Col>
                                )
                              }
                            </Row>
                          }
                          {
                            !isHMM && !isHF &&
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="weight_range"/></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="min" /></label>
                                  </Col>
                                  <Col xs={9}>
                                    <Field name="MinWeightRange" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="MinWeightRange" standalone type="text" standalone addonAfter=".00" onKeyPress={(event) => {
                                      this.handleKeyPress('MaxWeightRange', event)
                                    }} />
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={1} style={{ textAlign: 'center' }}>
                                <label><Translate value="~" /></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="max" /></label>
                                  </Col>
                                  <Col xs={9}>
                                    <Field
                                      name="MaxWeightRange"
                                      className="control-label"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      standalone
                                      type="text"
                                      addonAfter=".00"
                                      withRef={true}
                                      ref="MaxWeightRange"
                                      onKeyPress={(event) => {
                                        if (!this.props.currentProductDetail) {
                                          this.handleKeyPress('NetCost', event)
                                        } else {
                                          this.handleKeyPress('RefPrice', event)
                                        }
                                      }}
                                    />
                                  </Col>
                                </Row>
                            {/* End Weight Range */}
                              </Col>
                            </Row>
                          }
                          {
                            isHF &&
                            <Row className="formRow">{/* Weight Range */}
                              <Col xs={3}>
                                <label><Translate value="weight_range"/></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="min" /></label>
                                  </Col>
                                  <Col xs={5}>
                                    <Field name="MinWeightRange" className="control-label" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="MinWeightRange" standalone type="text" standalone addonAfter=".00" onKeyPress={(event) => {
                                      this.handleKeyPress('MaxWeightRange', event)
                                    }} />
                                  </Col>
                                  <Col xs={3}>
                                    <label><Translate value="lbs" /></label>
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={1} style={{ textAlign: 'center' }}>
                                <label><Translate value="~" /></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={3}>
                                    <label><Translate value="max" /></label>
                                  </Col>
                                  <Col xs={5}>
                                    <Field
                                      name="MaxWeightRange"
                                      className="control-label"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      standalone
                                      type="text"
                                      addonAfter=".00"
                                      withRef={true}
                                      ref="MaxWeightRange"
                                      onKeyPress={(event) => {
                                        if (!this.props.currentProductDetail) {
                                          this.handleKeyPress('NetCost', event)
                                        } else {
                                          this.handleKeyPress('RefPrice', event)
                                        }
                                      }}
                                    />
                                  </Col>
                                  <Col xs={3}>
                                    <label><Translate value="lbs" /></label>
                                  </Col>
                                </Row>
                            {/* End Weight Range */}
                              </Col>
                            </Row>
                          }
                          {
                            isJTB &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderCBMUnit()}
                              </Col>
                            </Row>
                          }
                          {
                            isHF &&
                            <Row className="formRow">{/* Temperature */}
                              <Col xs={3}>
                                <label><Translate value="temperature"/></label>
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xs={9}>
                                    <Field name="Temperature" className="control-label" component={InputField}/>
                                  </Col>
                                  <Col xs={1} style={{ textAlign: 'left' }}>
                                    <label><Translate value="°F" /></label>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          }
                          <Row style={{ marginBottom: '-10' }}>
                            <Col xs={12}>
                              {this.renderVolumeDimension()}
                            </Col>
                          </Row>
                          {isVAK &&  
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderPKGDimension()}
                              </Col>
                            </Row>
                          }
                          {
                            isAGD &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderCartonInfo()}
                              </Col>
                            </Row>
                          }
                          {
                            isSV &&
                            <Row>
                              <Col xs={12}>
                                <div className="form-group">
                                  {this.renderShipWeightLabel()}
                                  <div className="col-xs-4" style={{ paddingRight: 0 }}>
                                    <Field name="ShippingWeight" className="control-label" withRef={true} ref="ShippingWeight" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      this.handleKeyPress('MinWeightRange', event)
                                    }}/>
                                  </div>
                                  <div className="col-xs-4" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                    <Field name="MeasureUnit" className="control-label" component={DisabledSelection}  options={measureUnitOptions} />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          }
                          {
                            isSKH &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderPackageDimension()}
                              </Col>
                              <Col xs={12}>
                                {this.renderPackageWeight()}
                              </Col>
                            </Row>
                          }
                          {this.renderItemMeasurement()}
                          {
                            isSV &&
                            <Row>
                              <Col xs={6}>
                                <div className="row">
                                <label className="col-xs-5"><Translate value="unit_cbf"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                    {this.renderUnitCBF()}
                                    {/* <Field name="UnitCBF"  className="control-label" withRef={true} ref="UnitCBF" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      }}/> */}
                                  </div>
                                    <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group">
                                <label className="col-xs-5"><Translate value="unit_cbm"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                  {this.renderUnitCBM()}
                                    {/* <Field name="UnitCBM"  className="control-label" withRef={true} ref="UnitCBM" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      }}/> */}
                                  </div>
                                  <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          }
                          {
                            isSV &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderCaseVolumeDimension()}
                              </Col>
                            </Row>
                          }
                          { isSV &&
                            <Row>
                              <Col xs={6}>
                                <div className="row">
                                <label className="col-xs-5"><Translate value="case_cbf"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                  {this.renderCaseCBF()}
                                    {/* <Field name="CaseCBF"  className="control-label" withRef={true} ref="CaseCBF" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                     }}/> */}
                                  </div>
                                    <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group">
                                <label className="col-xs-5"><Translate value="case_cbm"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                    {this.renderCaseCBM()}
                                    {/* <Field name="CaseCBM"  className="control-label" withRef={true} ref="CaseCBM" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      }}/> */}
                                  </div>
                                  <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          }
                          {
                            isSV &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderPalletVolumeDimension()}
                              </Col>
                            </Row>
                          }
                          {isSV &&
                            <Row>
                              <Col xs={6}>
                                <div className="row">
                                <label className="col-xs-5"><Translate value="pallet_cbf"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                  {this.renderPalletCBF()}
                                    {/* <Field name="CaseCBF"  className="control-label" withRef={true} ref="CaseCBF" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                     }}/> */}
                                  </div>
                                    <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group">
                                <label className="col-xs-5"><Translate value="pallet_cbm"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                    {this.renderPalletCBM()}
                                    {/* <Field name="CaseCBM"  className="control-label" withRef={true} ref="CaseCBM" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      }}/> */}
                                  </div>
                                  <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          }
                          {isSV &&
                            <Row>
                              <Col xs={6}>
                                <div className="row">
                                <label className="col-xs-5">Case/Pallet</label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                  {this.renderCasePerPallet()}
                                    {/* <Field name="CaseCBF"  className="control-label" withRef={true} ref="CaseCBF" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                     }}/> */}
                                  </div>
                                    <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                              </Col>
                            </Row>
                          }
                          {
                            isJTB &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderCBM()}
                              </Col>
                            </Row>
                          }
                          {
                            isWIZ &&
                            <Row style={{ marginBottom: '-10' }}>
                              <Col xs={12}>
                                {this.renderTotalVolume()}
                              </Col>
                            </Row>
                          }
                          {/* Package Size */}
                          {
                            !isHF &&
                            <div className="formSubHeaderContainer">
                              <Row>
                                <Col xs={3}>
                                  <p className="formSubHeader">

                                    <Translate value={isSV ? "prod_size" : isSKH ? "case_pack_quantity" : isVAK ? "pkg_size_new" : "package_size"}/>
                                  </p>
                                </Col>
                                <Col xs={9}>
                                  <Field
                                    name="PackageSize"
                                    className="control-label"
                                    withRef={true}
                                    ref="PackageSize"
                                    component={DisabledInputField}
                                    onFocus={this.handleOnFocus}
                                    onKeyPress={(event) => {
                                      this.handleKeyPress('NetWeight', event)
                                    }}
                                  />
                                </Col>
                              </Row>
                            </div>
                          }
                          {
                            isHF &&
                            <div>
                              <Row>
                                <label className="col-xs-3"><Translate value="packageSize"/></label>
                                <Col xs={9}>
                                  <Field
                                    name="PackageSize"
                                    component={InputField}
                                  />
                                </Col>
                              </Row>
                            </div>
                          }
                          {/* End Package Size */}
                          {
                            !isHF &&
                            <div>
                              <Row style={{ marginTop: '-6'}}>
                                <Col sm={2}><Field name="PackageSize_1" component={InputField} /></Col>
                                {
                                  !isEcity &&
                                  <Col sm={3} className="select-menu-drop-up"><Field name="PackageType_2" component={Selection} options={packageTypeOptions} /></Col>
                                }
                                {
                                  isEcity &&
                                  < Col sm={3}><Field name="PackageType_2" component={InputField} placeholder="Type"/></Col>
                                }
                                <Col sm={2} className="textAlignStyle"><em className="fa fa-times times-sign"/></Col>
                                <Col sm={2}><Field name="PackageSize_2" component={InputField} /></Col>
                                {
                                  !isEcity &&
                                  < Col sm={3} className="select-menu-drop-up"><Field name="MeasureUnit_2" component={Selection} options={measureUnitOptions} /></Col>
                                }
                                {
                                  isEcity &&
                                  < Col sm={3}><Field name="MeasureUnit_2" component={InputField} placeholder="Unit"/></Col>
                                }
                              </Row>
                              <Row className="nonbold-label-description textAlignStyle">
                                <Col sm={2}><Translate value="(num)"/><span className="asteriksReq">*</span></Col>
                                <Col sm={3}><Translate value={isVAK ? "(pkg_size_1_new)" : "(pkg_size_1)" }/><span className="asteriksReq">*</span></Col>
                                <Col sm={2}></Col>
                                <Col sm={2}><Translate value="(num)"/></Col>
                                <Col sm={3}><Translate value={isVAK ? "(pkg_size_2_new)" : "(pkg_size_2)"}/></Col>
                              </Row>

                              <Row style={{ marginTop: '-6'}}>
                                <Col sm={2}></Col>
                                {
                                  !isEcity &&
                                  <Col sm={3} className="select-menu-drop-up"></Col>
                                }
                                {
                                  isEcity &&
                                  < Col sm={3}><Field name="PackageType_2" component={InputField} placeholder="Type"/></Col>
                                }
                                <Col sm={2} className="textAlignStyle"><em className="fa fa-times times-sign"/></Col>
                                <Col sm={2}><Field name="PackageSize_3" component={InputField} /></Col>
                                {
                                  !isEcity &&
                                  < Col sm={3} className="select-menu-drop-up"><Field name="MeasureUnit_3" component={Selection} options={measureUnitOptions} /></Col>
                                }
                                {
                                  isEcity &&
                                  < Col sm={3}><Field name="MeasureUnit_2" component={InputField} placeholder="Unit"/></Col>
                                }
                              </Row>
                              <Row className="nonbold-label-description textAlignStyle">
                                <Col sm={2}></Col>
                                <Col sm={3}></Col>
                                <Col sm={2}></Col>
                                <Col sm={2}><Translate value="(num)"/></Col>
                                <Col sm={3}><Translate value={ isSoleStage() ? "eu_size" : isVAK ? "(pkg_size_3_new)" : "(pkg_size_3)" }/></Col>
                              </Row>
                            </div>
                          }
                          {
                            ((isCalco || isMultiWH) && !isSV) &&
                            <div>
                              <Row style={{ marginTop: '10' }}>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>1</label>
                                </Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Pallet</label>
                                </Col>
                                <Col xs={1}>
                                  {/* <Field name="PalletSize" component={InputField} /> */}
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '16px' }}>
                                  <label>=</label>
                                </Col>
                                <Col sm={2}>
                                  <Field name="CalcoDispatchCase" component={InputField} />
                                </Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Case</label>
                                </Col>
                              </Row>
                              <Row style={{ marginTop: '10' }}>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  {/* <label>1</label> */}
                                  {isOCM && <Input
                                    type="text"
                                    name="palletBoxes"
                                    value={this.state.palletBoxes}
                                    onChange={(e) => {
                                      this.setState({ palletBoxes: e.target.value });
                                    }}
                                  />}
                                </Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  {isOCM && <label>x</label>}
                                </Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  {isOCM && <Input
                                    type="text"
                                    name="palletLevels"
                                    value={this.state.palletLevels}
                                    onChange={(e) => {
                                      this.setState({ palletLevels: e.target.value });
                                    }}
                                  />}
                                </Col>
                                <Col xs={1}>
                                  {/* <Field name="PalletSize" component={InputField} /> */}
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '16px' }}>
                                  <label>=</label>
                                </Col>
                                <Col sm={5}>
                                  <Field name="PalletSize" component={InputField} onKeyPress={(event) => {
                                    if (event.charCode === 13) {
                                      this.props.setValue('productForm', 'PalletSize', event.target.value);
                                      this.syncPalletSize(event.target.value);
                                    }
                                  }}/>
                                </Col>
                                {/* <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Case</label>
                                </Col> */}
                              </Row>
                            </div>
                          }
                          {
                            isCalco &&
                            <div>
                              <Row style={{ marginTop: '5' }}>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>1</label>
                                </Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Case</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '16px' }}>
                                  <label>=</label>
                                </Col>
                                <Col sm={2}><Field name="CalcoDispatchBag" component={InputField} /></Col>
                                <Col xs={1} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>x</label>
                                </Col>
                                <Col xs={2} style={{ textAlign: 'center', fontSize: '15px' }}>
                                  <label>Bag</label>
                                </Col>
                              </Row>
                            </div>
                          }
                        </Panel> {/* End Package Details Panel */}
                      </Col>
                    </Row>
                    {/* MIX PRODUCT */}
                    {
                      isJML &&
                      <Row>
                        <Col xs={12}>
                          <Panel id="mix-product" header={mixProductPanelHeader}>
                            <div>
                              <Row>
                                <Col xs={12}>
                                <MixProductTypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} />
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={4}>
                                  <label style={{ paddingLeft: '0px' }} className="col-xs-4 search-by-max-width">
                                    <Translate value="search_prod"/>
                                  </label>
                                  </Col>
                                  <Col xs={6}>
                                    {this.renderAutoSuggest()}
                                </Col>
                              </Row>
                            </div>
                            <div className="formSubHeaderContainer" style={{ marginTop: '20px' }}>
                              <Row>
                                <Col xs={3}>
                                <p className="formSubHeader">
                                  <Translate value="mix_setting" />
                                </p>
                                </Col>
                              </Row>
                            </div>
                            <div>
                              <Row>
                                <Col sm={2}><input value="1" disabled style={customizedInputStyle} /></Col>
                                <Col sm={3} className="select-menu-drop-up"><Field name="MixedProductBaseUnit" component={Selection} options={packageTypeOptions} /></Col>
                                <Col sm={1} className="textAlignStyle" style={{ fontWeight: 'bold', fontSize: '15px' }}>=</Col>
                              </Row>
                              <Row className="nonbold-label-description textAlignStyle">
                                <Col sm={2}><Translate value="(num)" /></Col>
                                <Col sm={3}><Translate value="(pkg_size)" /></Col>
                              </Row>
                            </div>
                            <div>
                              <Row>
                                <Col xs={12}>
                                {this.renderMixedProduct()}
                                </Col>
                              </Row>
                            </div>
                          </Panel>
                        </Col>
                      </Row>
                    }
                     {/* MIX PRODUCT */}
                  </Col> {/* End Product Details Column */}

                  {/* Cost Details Column */}
                  <Col xs={4}>
                    <Row>
                      <Col xs={12}>
                        {/* Cost Details */}
                        {/* <Panel id="cost-details" style={{height: checkPermissionLocal('no_show_price_for_warehouser') ? '350px' : '500px'}} header={costsDetailsPanelHeader} > */}
                        <Panel id="cost-details" style={{height: (!isSV || checkPermissionLocal('show_production_cost')) ? '500px' : '350px'}} header={costsDetailsPanelHeader} >
                          {
                            // !checkPermissionLocal('no_show_price_for_warehouser') &&
                            (!isSV || checkPermissionLocal('show_production_cost')) &&
                          <Row>
                            <Col xs={6} className="avg-and-inv-cost">
                              {this.renderAvgCost()}
                            </Col>
                            <Col xs={6}>
                              {!isSV &&
                              <div className="form-group">
                                {
                                  !isSUN &&
                                  <label className="col-xs-6">
                                    <Translate value={isSH ? "selling_price" : "ref_price"}/>
                                    <span className="asteriksReq">*</span>
                                  </label>
                                }
                                {
                                  (isSUN && this.props.RefPriceMode && this.props.RefPriceMode !== 'as_is' && this.props.RefPriceMode.value !== 'as_is') &&
                                   <div className="col-xs-12" style={{paddingLeft: '0px', paddingRight: '0px'}}>
                                     <Field name="RefPriceMode" component={ Selection } options={refOptions}
                                      onKeyPress={(event) => {
                                        setTimeout(() => {
                                          this.props.setValue('productForm', 'RefPriceMode', event.target.value);
                                          // this.props.setValue('productForm', 'RefPrice', event.target.value);
                                        }, 200);
                                      }}
                                    />
                                  {/* <Field
                                    name="RefPriceMode"
                                    component={Selection}
                                    options={refOptions}
                                    onKeyPress={(event) => {
                                      event.stopPropagation();
                                    } }                                 // disabled={!this.props.RefPriceMode}
                                  /> */}
                                  </div>
                                }
                                {
                                  (isSUN && (this.props.RefPriceMode && this.props.RefPriceMode.value !== 'avg_cost' && this.props.RefPriceMode.value !== 'prod_cost' && this.props.RefPriceMode !== 'avg_cost' && this.props.RefPriceMode !== 'prod_cost')) &&
                                  <div className="col-xs-7" style={{paddingLeft: '0px', paddingRight: '0px'}}>
                                  <Field name="RefPriceMode" component={ Selection } options={refOptions}
                                   onKeyPress={(event) => {
                                     setTimeout(() => {
                                       this.props.setValue('productForm', 'RefPriceMode', event.target.value);
                                     }, 200);
                                   }}
                                  />
                                  </div>
                                }
                                {
                                  (isSUN && (this.props.RefPriceMode && this.props.RefPriceMode.value !== 'avg_cost' && this.props.RefPriceMode.value !== 'prod_cost' && this.props.RefPriceMode !== 'avg_cost' && this.props.RefPriceMode !== 'prod_cost')) &&
                                  <div className="col-xs-5">
                                    <Field
                                      name="RefPrice"
                                      value={this.props.RefPriceValue}
                                      withRef={true}
                                      ref="RefPrice"
                                      component={ InputField }
                                      disabled={isJML && !checkPermission('change_price_reference')}
                                      normalize={normalizeFourDecimals}
                                      onFocus={this.handleOnFocus}
                                      onChange={(event, newValue, previousValue, name) => {
                                        this.props.setValue('productForm', 'RefPrice', event.target.value);
                                        if (isARC) return;
                                        if(!isEcity) {
                                          let priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, event.target.value, this.props.ArrivalPrice);
                                          let priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, event.target.value, this.props.ArrivalPrice);
                                          let priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, event.target.value, this.props.ArrivalPrice);
                                          let priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, event.target.value, this.props.ArrivalPrice);
                                          let priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, event.target.value, this.props.ArrivalPrice);
                                          const smallUnitPrice1 = getSmallUnitPrice(priceLv1, this.props.ConvertNum);
                                          const smallUnitPrice2 = getSmallUnitPrice(priceLv2, this.props.ConvertNum);
                                          const smallUnitPrice3 = getSmallUnitPrice(priceLv3, this.props.ConvertNum);
                                          const smallUnitPrice4 = getSmallUnitPrice(priceLv4, this.props.ConvertNum);
                                          const smallUnitPrice5 = getSmallUnitPrice(priceLv5, this.props.ConvertNum);
                                          if (isSUN) {
                                            priceLv1 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel1Sunsun) || 0)).toFixed(2)
                                            priceLv2 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel2Sunsun) || 0)).toFixed(2)
                                            priceLv3 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel3Sunsun) || 0)).toFixed(2)
                                            priceLv4 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel4Sunsun) || 0)).toFixed(2)
                                            priceLv5 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel5Sunsun) || 0)).toFixed(2)
                                          }
                                          this.setState({
                                            priceLv1,
                                            priceLv2,
                                            priceLv3,
                                            priceLv4,
                                            priceLv5,
                                            smallUnitPrice1,
                                            smallUnitPrice2,
                                            smallUnitPrice3,
                                            smallUnitPrice4,
                                            smallUnitPrice5,
                                          });
                                        }
                                      }}
                                      onKeyPress={(event) => { this.handleKeyPress('LowestSalePrice', event)}}
                                    />
                                  </div>
                                }
                                {
                                  (!isSUN) &&
                                <div className="col-xs-6">
                                  <Field
                                    name="RefPrice"
                                    value={this.props.RefPriceValue}
                                    withRef={true}
                                    ref="RefPrice"
                                    component={ isOLG ? DisabledInputField: InputField }
                                    disabled={isLAP || (isJML && !checkPermission('change_price_reference'))}
                                    normalize={normalizeFourDecimals}
                                    onFocus={this.handleOnFocus}
                                    onChange={(event, newValue, previousValue, name) => {
                                      this.props.setValue('productForm', 'RefPrice', event.target.value);
                                      if (isARC) return;
                                      if(!isEcity && !isHMM) {
                                        if ((isCPG || isVIP) && this.state.priceLv5 && event.target.value) {
                                          this.state.p5Percentage = ((this.state.priceLv5/event.target.value)-1)*100;
                                        }
                                        if ((isCPG || isVIP) && this.state.priceLv5 && !event.target.value) {
                                          this.state.p5Percentage = 0;
                                        }
                                        let priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, event.target.value, this.props.ArrivalPrice);
                                        let priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, event.target.value, this.props.ArrivalPrice);
                                        let priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, event.target.value, this.props.ArrivalPrice);
                                        let priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, event.target.value, this.props.ArrivalPrice);
                                        let priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, event.target.value, this.props.ArrivalPrice);
                                        const smallUnitPrice1 = getSmallUnitPrice(priceLv1, this.props.ConvertNum);
                                        const smallUnitPrice2 = getSmallUnitPrice(priceLv2, this.props.ConvertNum);
                                        const smallUnitPrice3 = getSmallUnitPrice(priceLv3, this.props.ConvertNum);
                                        const smallUnitPrice4 = getSmallUnitPrice(priceLv4, this.props.ConvertNum);
                                        const smallUnitPrice5 = getSmallUnitPrice(priceLv5, this.props.ConvertNum);
                                        if (isSUN) {
                                          priceLv1 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel1Sunsun) || 0)).toFixed(2)
                                          priceLv2 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel2Sunsun) || 0)).toFixed(2)
                                          priceLv3 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel3Sunsun) || 0)).toFixed(2)
                                          priceLv4 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel4Sunsun) || 0)).toFixed(2)
                                          priceLv5 = (parseFloat(event.target.value) + (parseFloat(this.state.priceLevel5Sunsun) || 0)).toFixed(2)
                                        }
                                        if (isCPG || isVIP) {
                                          this.setState({
                                            priceLv1,
                                            priceLv2,
                                            priceLv3,
                                            priceLv4,
                                            smallUnitPrice1,
                                            smallUnitPrice2,
                                            smallUnitPrice3,
                                            smallUnitPrice4,
                                          });
                                        } else {
                                          this.setState({
                                            priceLv1,
                                            priceLv2,
                                            priceLv3,
                                            priceLv4,
                                            priceLv5,
                                            smallUnitPrice1,
                                            smallUnitPrice2,
                                            smallUnitPrice3,
                                            smallUnitPrice4,
                                            smallUnitPrice5,
                                          });
                                        }
                                      }
                                    }}
                                    onKeyPress={(event) => { this.handleKeyPress('LowestSalePrice', event)}}
                                  />
                                </div>
                              }
                              </div>
                              }
                              <div className="form-group mb0">
                                <label className="col-xs-6">
                                  <Translate value="lowest_sale_dollarsign"/><span className="asteriksReq">*</span>
                                </label>
                                <div className="col-xs-6">
                                {
                                  isHMM ?
                                  (checkPermission('hmm_view_arrival') || this.state.permissionChecked) ?
                                  <Field
                                    name="LowestSalePrice"
                                    withRef={true}
                                    ref="LowestSalePrice"
                                    component={InputField}
                                    normalize={normalizeFourDecimals}
                                    onFocus={this.handleOnFocus}
                                    onKeyPress={(event) => {this.handleKeyPress('LV1', event)}}
                                  />
                                  :
                                  <div onClick={e => this.checkPasscode(e)}>
                                    <input
                                      disabled
                                      type="text"
                                      placeholder='Click to view'
                                      style={{ borderRadius: '2px', width: '100%', border: '1px solid black', paddingLeft: '2px' }}
                                    />
                                  </div>
                                  :
                                  <Field
                                    name="LowestSalePrice"
                                    withRef={true}
                                    ref="LowestSalePrice"
                                    component={InputField}
                                    normalize={normalizeFourDecimals}
                                    onFocus={this.handleOnFocus}
                                    onKeyPress={(event) => {this.handleKeyPress('LV1', event)}}
                                  />
                                }
                                </div>
                              </div>
                              {this.renderArrivalPrice()}
                              {
                                ((isHMM && checkPermission('hmm_view_arrival')) || isUSPride)&& <div className="form-group mb0">
                                <label className="col-xs-6">
                                  <Translate value="arrival_price"/>
                                </label>
                                <div className="col-xs-6">
                                  <input value={ this.props.ArrivalPrice } disabled style={customizedInputStyle}/>
                                </div>
                              </div>
                              }
                              {
                                isGFD &&
                                <div className="form-group mb0" style={{ marginTop: '10px' }}>
                                  <label className="col-xs-6">
                                    <Translate value="pos_unit_price" />
                                  </label>
                                  <div className="col-xs-6">
                                    <Field name="POSUnitPrice" component={InputField} onFocus={this.handleOnFocus} withRef={true} ref="POSUnitPrice" onKeyPress={(event) => { }} />
                                  </div>
                                </div>
                              }
                              {
                                isSV &&
                                <div className="form-group mb0" style={{marginTop: '10px'}}>
                                  <label className="col-xs-6">
                                    <Translate value="base_cost"/>
                                  </label>
                                  <div className="col-xs-6">
                                  <Field name="BaseCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="BaseCost" onKeyPress={(event) => {}}/>
                                    {/* <input value={ this.props.BaseCost } disabled style={customizedInputStyle}/> */}
                                  </div>
                                </div>
                              }
                              {
                                isSV &&
                                <div className="form-group mb0" style={{marginTop: '10px'}}>
                                  <label className="col-xs-6">
                                    <Translate value="cstm_duty"/> (%)
                                  </label>
                                  <div className="col-xs-6">
                                  <Field name="CustomDutyPercent" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="CustomDutyPercent" onKeyPress={(event) => {}}/>
                                  </div>
                                </div>
                              }
                              {isSV && this.renderCustomDutyCost()}
                            </Col>
                          </Row>
                          }
                          {/* <div className="position-relative">
                            <h3><Translate value="price_level_setup" /></h3>
                            <div className="col-xs-6 col-xs-offset-5" id="price-type">
                              <Field name="PriceType" component={renderPriceTypeRadio}/>
                            </div>
                          </div> */}
                          <div className="formSubHeaderContainer">
                            <Row>
                              <Col xs={5} style={{ padding: 0 }}>
                                <p className="formSubHeader"><Translate value="sales_price_levels" /></p>
                              </Col>
                              {
                                (checkPermission('view_price_level') && isSUN) &&<Col xs={7} style={{ padding: 0 }}>
                                  <Field name="LevelType" component={renderPriceTypeRadio}/>
                                </Col>
                              }
                            </Row>
                          </div>
                          {
                            (!isHMM || checkPermission('view_price_level')) &&
                            <div>
                              <Row>
                                <Col xs={12} className="centerStyle price-level-setup">
                                  <Row>
                                    {!isSV &&
                                      this.renderPriceLevel1()
                                    }
                                    {isSV &&
                                      <Col xs={4}>
                                        <div className="form-group">
                                          <label className="col-xs-11">Quantity: 1 - {this.props.PromoTier1Qty ? Number(this.props.PromoTier1Qty) : 0}</label>
                                        </div>
                                        <span className="equal-sign">=</span>
                                      </Col>
                                    }
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_1" /><span className="dollar-sign">$</span></label>
                                        <div className="col-xs-7">
                                          <Field id="pricelevel1_sunsun" name="PriceLv1" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV1_2" placeholder={this.state.priceLv1} onChange={(event) => { this.handlePriceChange("priceLv1", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV2_2', event)}} disabled={!checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                    </Col>
                                    {(!isSV && !isSUN) &&
                                      <Col xs={4} className="pull-right">
                                        <div className="form-group">
                                          <label className="col-xs-4"><Translate value={isGGI ? 'unit' : "lv_1"} /><span className="dollar-sign">$</span></label>
                                          <div className="col-xs-8">
                                            <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={isGGI ? roundUp(this.state.smallUnitPrice1) : (isSW ? roundTo(this.state.priceLv1, 2) : roundUp(this.state.priceLv1))} />
                                          </div>
                                        </div>
                                      </Col>
                                    }
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12} className="centerStyle">
                                  <Row>
                                    {!isSV &&
                                      this.renderPriceLevel2()
                                    }
                                    {isSV &&
                                      <Col xs={4}>
                                        <div className="form-group">
                                          <label className="col-xs-11">Quantity: {this.props.PromoTier1Qty ? Number(this.props.PromoTier1Qty)+1 : 0} - {this.props.PromoTier2Qty ? Number(this.props.PromoTier2Qty) : this.props.PromoTier2Qty}</label>
                                        </div>
                                        <span className="equal-sign">=</span>
                                      </Col>
                                    }
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_2" /><span className="dollar-sign">$</span></label>
                                        <div className="col-xs-7">
                                          <Field id="pricelevel2_sunsun" name="PriceLv2" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV2_2" placeholder={this.state.priceLv2} onChange={(event) => { this.handlePriceChange("priceLv2", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV3_2', event)}} disabled={!checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                    </Col>
                                    {(!isSV && !isSUN) &&
                                      <Col xs={4}>
                                        <div className="form-group">
                                          <label className="col-md-4"><Translate value={isGGI? "unit" : "lv_2"} /><span className="dollar-sign">$</span></label>
                                          <div className="col-md-8">
                                            <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={isGGI? roundUp(this.state.smallUnitPrice2) : (isSW ? roundTo(this.state.priceLv2, 2) : roundUp(this.state.priceLv2))} />
                                          </div>
                                        </div>
                                      </Col>
                                    }
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12} className="centerStyle">
                                  <Row>
                                    {!isSV &&
                                      this.renderPriceLevel3()
                                    }
                                    {
                                      isSV &&
                                      <Col xs={4} className="level-col-percentages">
                                        <div className="form-group">
                                        <label className="col-xs-11">Quantity: {this.props.PromoTier2Qty ? Number(this.props.PromoTier2Qty)+1 : 0} +</label>
                                        </div>
                                        <span className="equal-sign">=</span>
                                      </Col>
                                    }
                                    <Col xs={4} className="level-col-dollar">
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="lv_3" /><span className="dollar-sign">$</span></label>
                                        <div className="col-xs-7">
                                          <Field id="pricelevel3_sunsun" name="PriceLv3" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV3_2" placeholder={this.state.priceLv3} onChange={(event) => { this.handlePriceChange("priceLv3", event) }} onKeyPress={(event) => {
                                            this.handleKeyPress('LV4_2', event)}} disabled={!checkPermission('change_price_level')} />
                                        </div>
                                      </div>
                                    </Col>
                                    {(!isSV && !isSUN) &&
                                      <Col xs={4}>
                                        <div className="form-group">
                                          <label className="col-md-4"><Translate value={isGGI? "unit" : "lv_3"}  /><span className="dollar-sign">$</span></label>
                                          <div className="col-md-8">
                                            <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={isGGI? roundUp(this.state.smallUnitPrice3) : (isSW ? roundTo(this.state.priceLv3, 2) : roundUp(this.state.priceLv3))} />
                                          </div>
                                        </div>
                                      </Col>
                                    }
                                  </Row>
                                </Col>
                              </Row>
                              {
                                !isSV && (
                                  <div>
                                    <Row>
                                      <Col xs={12} className="centerStyle">
                                        <Row>
                                          {this.renderPriceLevel4()}
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-xs-4"><Translate value="lv_4" /><span className="dollar-sign">$</span></label>
                                              <div className="col-xs-7">
                                                <Field id="pricelevel4_sunsun" name="PriceLv4" className="control-label" component={ControlledInputField} onFocus={this.handleOnFocus} withRef={true} ref="LV4_2" placeholder={this.state.priceLv4} onChange={(event) => { this.handlePriceChange("priceLv4", event) }} onKeyPress={(event) => {
                                                  this.handleKeyPress('LV5_2', event)}} disabled={!checkPermission('change_price_level')} />
                                              </div>
                                            </div>
                                          </Col>
                                          {!isSUN && <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-md-4"><Translate value={isGGI? "unit" : "lv_4"} /><span className="dollar-sign">$</span></label>
                                              <div className="col-md-8">
                                                <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={isGGI ? roundUp(this.state.smallUnitPrice4) : (isSW ? roundTo(this.state.priceLv4, 2) : roundUp(this.state.priceLv4))} />
                                              </div>
                                            </div>
                                          </Col>}
                                        </Row>
                                      </Col>
                                    </Row>
                                    {
                                      isAGD &&<Row><label className="col-xs-4" style={{ marginTop: -10 }}>(Wholesale)</label></Row>
                                    }
                                    <Row>
                                      <Col xs={12} className="centerStyle">
                                        <Row>
                                          {this.renderPriceLevel5()}
                                          <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-xs-4"><Translate value="lv_5" /><span className="dollar-sign">$</span></label>
                                              <div className="col-xs-7">
                                                <Field
                                                  id="pricelevel5_sunsun"
                                                  name="PriceLv5"
                                                  className="control-label"
                                                  component={ControlledInputField}
                                                  onFocus={this.handleOnFocus}
                                                  withRef={true}
                                                  ref="LV5_2"
                                                  placeholder={this.state.priceLv5}
                                                  onChange={(event) => { this.handlePriceChange("priceLv5", event) }}
                                                  onKeyPress={(event) => {
                                                    if (event.charCode === 13) {
                                                      event.preventDefault();
                                                      this.refs["CRVOptions"].getRenderedComponent().refs.select.focus();
                                                    }
                                                  }}
                                                  disabled={!checkPermission('change_price_level')}
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                          {!isSUN && <Col xs={4}>
                                            <div className="form-group">
                                              <label className="col-md-4">
                                                <Translate value={isGGI? "unit" : "lv_5"}  />
                                                <span className="dollar-sign">$</span>
                                              </label>
                                              <div className="col-md-8">
                                                <Field name="PriceLv1Rounded" className="control-label" component={DisabledInputField} placeholder={isGGI ? roundUp(this.state.smallUnitPrice5) : (isSW ? roundTo(this.state.priceLv5, 2) : roundUp(this.state.priceLv5))} />
                                              </div>
                                            </div>
                                          </Col>}
                                        </Row>
                                      </Col>
                                    </Row>
                                    {
                                      isAGD && <Row><label className="col-xs-4" style={{ marginTop: -10 }}>(Retail)</label></Row>
                                    }
                                  </div>
                                )
                              }
                              <div className="formDivider"></div>
                            </div>
                          }
                          {/* Per Michael: Do not include for demo
                          <Row>
                            <Col xs={ 12 } className="centerStyle">
                              <Field name="RoundPriceLevels" labelName="is_two_decimal" component={ renderRadios } />
                            </Col>
                          </Row> */}

                          {isSV &&
                            <Row>
                              <Col xs={6}>
                                <div className="row">
                                <label className="col-xs-5"><Translate value="tier_1_qty"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                    <Field name="PromoTier1Qty" className="control-label" withRef={true} ref="PromoTier1Qty" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                     }}
                                    />
                                  </div>
                                    <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group">
                                <label className="col-xs-5"><Translate value="tier_2_qty"/></label>
                                  <div className="col-xs-6" style={{ paddingRight: 0 }}>
                                    <Field name="PromoTier2Qty" className="control-label" withRef={true} ref="PromoTier2Qty" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      }}/>
                                  </div>
                                  <div className="col-xs-1" style={{ marginLeft: 0, paddingLeft: 0 }}>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          }
                          {this.renderMSRP()}
                          <Row className="formRow">
                            <Col xs={3}>
                              <label><Translate value="taxable" /></label>
                            </Col>
                            <Col xs={3}>
                              <Field
                                name="IsTaxable"
                                // disabled={(isAN && this.props.IsAllTaxable)}
                                component={Checkbox}
                              />
                            </Col>
                            {
                              (isAN || isVIP) &&
                              <div>
                                <Col xs={3}>
                                  <label><Translate value="all_taxable" /></label>
                                </Col>
                                <Col xs={3}>
                                  <Field name="IsAllTaxable" component={Checkbox} />
                                </Col>
                              </div>
                            }
                            {
                              isEcity &&
                              <div>
                                <Col xs={3}>
                                  <label><Translate value="non_food" /></label>
                                </Col>
                                <Col xs={3}>
                                  <Field name="IsNonFood" component={Checkbox} />
                                </Col>
                              </div>
                            }
                            {this.renderFoodStamp()}
                          </Row>
                          <Row className="formRow">
                            <Col xs={3}>
                              <label><Translate value="CRV" /></label>
                            </Col>
                            <Col xs={9}>
                              {this.CRV()}
                            </Col>
                          </Row>
                          {this.renderFobCost()}
                        </Panel> {/* Cost Details Column */}
                      </Col>
                    </Row>

                    <Panel id="sale-details" header={saleDetailsPanelHeader} style={{height: '350px'}}> {/* Sale */}
                      {
                        isEcity &&
                        <Row>
                          <Col xs={12}>
                            <Button
                              bsStyle="primary"
                              style={{ position: 'absolute', top: '-50px', right: '0px' }}
                              type="button"
                              onClick={() => { this.openESLModal(); }}
                              disabled={(!this.props.currentProduct && !this.props.params.id) || !this.state.eslEnabled}
                            >
                              <Translate value="ESL" />
                            </Button>
                          </Col>
                        </Row>
                      }

                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="stop_sale"/></label>
                            </Col>
                            <Col xs={5}>
                             <Field name="IsStopSale" component={Checkbox} />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="oversaleable"/></label>
                            </Col>
                            <Col xs={5}>
                              <Field name="IsOverSaleable" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="wholesale_only"/></label>
                            </Col>
                             <Col xs={5}>
                               <Field name="IsWholesaleOnly" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                             </Col>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          {
                            isOCM ? (
                              <Row>
                                <Col xs={7}>
                                  <label><Translate value="mobile_sale"/></label>
                                </Col>
                                <Col xs={5}>
                                  <Field name="InventoryIsMobile" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                                </Col>
                              </Row>
                            ) : (
                              <Row>
                                <Col xs={7}>
                                  <label><Translate value="mobile_sale"/></label>
                                </Col>
                                <Col xs={5}>
                                  <Field name="IsMobile" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                                </Col>
                              </Row>
                            )
                          }
                        </Col>
                      </Row>
                      {
                        isAFM &&
                        <Row className="formRow">
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="top_deal"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsGreatDeal" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="new_arrival"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsNewArrival" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      }
                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={7}>
                              <label><Translate value="nationwide"/></label>
                            </Col>
                             <Col xs={5}>
                               <Field name="IsSoldNationwide" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                             </Col>
                          </Row>
                        </Col>
                        {this.renderSyncInventory()}
                        {this.renderSyncESL()}
                        {isAGD &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="nuorder_sync"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsSyncNuOrder" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                              </Col>
                            </Row>
                          </Col>
                        }
                        {(isCPG || isVIP) &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="retail_pack"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsRetailPack" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                              </Col>
                            </Row>
                          </Col>
                        }
                        {(isSV || isCRW) &&
                         <Col xs={6}>
                           <Row>
                             <Col xs={7}>
                               <label><Translate value="combo_product"/></label>
                             </Col>
                              <Col xs={5}>
                                <Field name="IsCombo" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                              </Col>
                           </Row>
                          </Col>
                        }
                        {
                          (isAFG || isMyuMyu || isWecom) &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="Proposition65" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsProposition65" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                              </Col>
                            </Row>
                          </Col>
                        }
                      </Row>
                      {
                        isAGD &&
                        <Row className="formRow">
                          <Col xs={6}>
                          </Col>
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="shopify_sync"/></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsSyncShopify" component={Checkbox} disabled={this.props.IsStopSale && this.props.IsStopSale !== "false"} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      }
                      {
                        isHF &&
                        <Row className="formRow">
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="IsB2B" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsB2B" component={Checkbox} disabled={this.props.IsB2B} />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="IsB2C" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsB2C" component={Checkbox} disabled={this.props.IsB2C} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      }
                      <Row className="formRow">
                        {
                          isARC &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="sync_scale" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsSyncToScales" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        }
                        {this.renderPopularity()}
                        {
                          isEcity &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="sync_esl" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsSyncToESL" component={this.ESLCheckbox} disabled={this.props.IsStopSale || ((!this.props.currentProduct && !this.props.params.id))} />
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          isAFG &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="afg_choice" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsAFGChioce" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          isAFG &&
                          <Col xs={6}>
                            <Row>
                              <Col xs={7}>
                                <label><Translate value="alcohol" /></label>
                              </Col>
                              <Col xs={5}>
                                <Field name="IsAlcohol" component={Checkbox} disabled={this.props.IsStopSale} />
                              </Col>
                            </Row>
                          </Col>
                        }
                      </Row>
                      <Row className="formRow">
                        <Col xs={6}>
                          <Row>
                            <Col xs={8}>
                              <label><Translate value="limit_qty_order" /></label>
                            </Col>
                            <Col xs={4}>
                              <Field placeholder='0' name="LimitQuantityPerOrder" component={InputField} />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Col xs={8}>
                              <label><Translate value="limit_qty_order_desc" /></label>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                        {this.renderMultipleQtyOrder()}
                        {
                          isSV &&
                          <Row className="formRow">
                            <Col xs={6}>
                              <Row>
                                <Col xs={8}>
                                  <label><Translate value="min_order_qty" /></label>
                                </Col>
                                <Col xs={4}>
                                  <Field name="MinOrderQty" component={InputField} />
                                </Col>
                              </Row>
                            </Col>
                            <Col xs={6}>
                              <Row>
                                <Col xs={8}>
                                  {/* <label><Translate value="limit_qty_order_desc" /></label> */}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        }
                      <div className="formDivider"></div>
                      <Row className="formRow">
                        <Col xs={3}>
                          <label><Translate value="default_sales" /></label>
                        </Col>
                        <Col xs={9}>
                          {this.defaultSales()}
                        </Col>
                      </Row>
                      <Row className="formRow">
                        <Col xs={12}>
                          <label><Translate value="enable_for_languages" /></label>
                        </Col>
                        <Col xs={12}>
                          <Field
                            multi
                            removeSelected
                            simpleValue
                            closeOnSelect={false}
                            name="ViewableLanguages"
                            component={SelectionWithProps}
                            options={languages}
                            placeholder={I18n.t('enable_for_language')}
                          />
                        </Col>
                      </Row>
                    </Panel>
                    {/* End Sale */}
                    <Panel id="buyer-details" header={buyerDetailsPanelHeader}>
                      <Row className="formRow">
                        <Col xs={12}>
                          <Row>
                            <Col xs={4}>
                              <label><Translate value="stop_purchase"/></label>
                            </Col>
                            <Col xs={8}>
                              <Field name="IsStopPurchase" component={ Checkbox } />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className="formDivider"></div>
                      <Row className="formRow">
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={4}>
                              <label><Translate value="default_purchaser"/></label>
                            </Col>
                            <Col xs={8}>
                              {this.renderDefaultBuyers()}
                            </Col>
                          </div>
                        </Col>
                      </Row>
                    </Panel> {/* End Buyer Details */}
                    {
                      isGFD && 
                      <Panel id="vendor-accociated-details" header={vendorDetailsPanelHeader}>
                        {this.renderVendorAssociateds()}
                      </Panel>
                    }
                    {/* End Vendor Accociated Details */}
                  </Col> {/* End Cost Details Column */}
                  {/* Convert Details Column */}
                  <Col xs={4}>
                    {
                      // !isHMM &&
                      true &&
                    <Row>
                      <Col xs={12}>
                        {/* Convert Details */}
                        <Panel id="convert-details" header={convertDetailsPanelHeader}>
                          <Row>
                            <Col xs={12}>
                              {!isVAK && <Row>
                                <Col xs={12}>
                                  <Field name="ConvertType" component={convertNumRadios} />
                                </Col>
                              </Row>}
                              {!isVAK && <Row>
                                <Col xs={12}>
                                  <div className="form-group">
                                    {!isTN && <label className="col-xs-5"><Translate value="convert_prod_qty" /></label>}
                                    {isTN && <label className="col-xs-5"><Translate value="purchase_convert_unit" /></label>}
                                    <div className="col-xs-7 convert-prod-qty">
                                      {/* of */}
                                      <Field name="ConvertNum" component={DisabledInputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Row>}
                              {!isVAK && <Row>
                                <Col xs={12}>
                                  <div className="form-group">
                                    {!isTN && <label className="col-xs-5"><Translate value="purchase_convert_unit" /></label>}
                                    {isTN && <label className="col-xs-5"><Translate value="sales_convert_unit" /></label>}
                                    <div className="col-xs-7 convert-prod-qty">
                                      {/* of */}
                                      <Field name="PurchaseConvertUnit" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Row>}
                              {this.renderBigPrd()}
                            </Col>
                          </Row>
                          <Row>
                            {/* Prod No & Qty Label / Input Group */}
                            {this.renderConvertDetails()}
                          </Row>
                        </Panel> {/* End Convert Details */}
                      </Col>
                    </Row>
                    }
                    {/* Inventory Details */}
                    <Panel id="inventory-details-panel" header={inventoryDetailsPanelHeader}>
                      <Row>
                      {
                        isTQ &&
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={5}>
                              <label><Translate value="hmart_code"/></label>
                            </Col>
                            <Col xs={7}>
                              <Field name="InternalBarcode" withRef={true} ref="InternalBarcode" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                  this.handleKeyPress('UnitPerPallet', event)
                              }}/>
                            </Col>
                          </div>
                        </Col>
                      }
                      {
                        !(isTQ || isVAK || isOLG) &&
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={5}>
                              <label><Translate value="internal_barcode"/></label>
                            </Col>
                            <Col xs={7}>
                              <Field name="InternalBarcode" withRef={true} ref="InternalBarcode" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                this.handleKeyPress('UnitPerPallet', event)
                              }}/>
                            </Col>
                          </div>
                        </Col>
                      }
                      </Row>
                      {!(isTQ || isVAK || isOLG) && <Row>
                        <Col xs={12}>
                          <div className="form-group">
                            <Col xs={5}>
                              <label><Translate value="per_pallet" /></label>
                            </Col>
                            <Col xs={7}>
                              <Field name="UnitPerPallet" className="control-label" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="UnitPerPallet" onKeyPress={(event) => {
                                  this.handleKeyPress('MinStockRange', event)
                                }}
                              />
                            </Col>
                          </div>
                        </Col>
                      </Row>}
                      {this.renderStockRange()}
                      <h3 style={{marginBottom: '10px'}}><Translate value="location" /></h3>
                      {
                        isEcity &&
                        <Col xs={12}>
                          <Col sm={8}>
                          <label><Translate value="zone" /></label>
                          <Field name="Zone" component={InputField} />
                          </Col>
                        </Col>
                      }
                      {
                        (!isEcity && !isAFM) &&
                        <Col xs={12}>
                          <Col sm={4} style={{ width: isVAK ? 362 : 120 }} className="select-menu-drop-up" style={{width: isVAK ? 362 : 120}}>
                            <label><Translate value="zone" /></label>
                            <Field name="Zone" component={Selection} options={getZoneOptions} disabled={!this.props.zones}/>
                          </Col>
                          {!isVAK && <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="bin"/></label>
                            <Field
                              name="Bin"
                              component={Selection}
                              options={getBinOptions}
                              disabled={!this.props.Zone}
                            />
                          </Col>}
                          {!isVAK && <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="level"/></label>
                            <Field
                              name="Level"
                              component={Selection}
                              options={getLevelOptions}
                              disabled={!this.props.Bin}
                            />
                          </Col>}
                        </Col>
                      }
                      {
                        isAFM &&
                        <div>
                        <Col xs={12} style={{ marginTop: '5px' }}>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label>Bellevue</label>
                            <Field name="Zone" component={Selection} options={getZoneOptions} disabled={!this.props.zones} />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="bin" /></label>
                            <Field
                              name="Bin"
                              component={Selection}
                              options={getBinOptions}
                              disabled={!this.props.Zone}
                            />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="level" /></label>
                            <Field
                              name="Level"
                              component={Selection}
                              options={getLevelOptions}
                              disabled={!this.props.Bin}
                            />
                          </Col>
                        </Col>
                        <Col xs={12} style={{ marginTop: '5px' }}>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label>Beaverton</label>
                            <Field name="Zone2" component={Selection} options={getZoneOptions} disabled={!this.props.zones} />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="bin" /></label>
                            <Field
                              name="Bin2"
                              component={Selection}
                              options={getBin2Options}
                              disabled={!this.props.Zone2}
                            />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="level" /></label>
                            <Field
                              name="Level2"
                              component={Selection}
                              options={getLevel2Options}
                              disabled={!this.props.Bin2}
                            />
                          </Col>
                        </Col>
                        <Col xs={12} style={{ marginTop: '5px' }}>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label>Seattle</label>
                            <Field name="Zone3" component={Selection} options={getZoneOptions} disabled={!this.props.zones} />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="bin" /></label>
                            <Field
                              name="Bin3"
                              component={Selection}
                              options={getBin3Options}
                              disabled={!this.props.Zone3}
                            />
                          </Col>
                          <Col sm={4} style={{ width: 120 }} className="select-menu-drop-up" style={{ width: 120 }}>
                            <label><Translate value="level" /></label>
                            <Field
                              name="Level3"
                              component={Selection}
                              options={getLevel3Options}
                              disabled={!this.props.Bin3}
                            />
                          </Col>
                        </Col>
                        </div>
                      }
                      {
                        isMMD &&
                        <Col xs={12} style={{ position: 'relative', marginTop: 20}}>
                          <Row>
                            <Col xs={3}>
                                <label>Auto PO</label>
                            </Col>
                            <Col xs={1}>
                              <Field name="AutoPO" component={ Checkbox } />
                            </Col>
                            <Col xs={4}>
                              <p style={{fontWeight: "bold", position: "relative"}}>Auto PO Qty</p>
                            </Col>
                            <Col xs={2} style={{ paddingLeft: 10 }}>
                              <Field
                                name="default_po_quantity"
                                component={ InputField }
                              />
                            </Col>
                          </Row>
                        </Col>
                      }
                      <Col xs={12} style={{ position: 'relative', marginTop: 20}}>
                      {
                        isARC &&
                        <Row>
                          <Col xs={1} style={{ paddingRight: 0 }}>
                            <label><Translate value="tare" />:&nbsp;</label>
                          </Col>
                          <Col xs={3} style={{ paddingLeft: 10 }}>
                            <Field
                              name="Tare"
                              withRef={true}
                              ref="Tare"
                              component={InputField}
                              onFocus={this.handleOnFocus}
                              onKeyPress={(event) => {
                                if (event.charCode === 13)
                                  event.preventDefault();
                              }}
                            />
                          </Col>
                          <Col xs={1}></Col>
                          <Col xs={2}>
                            <label>DateFlag:&nbsp;</label>
                          </Col>
                          <Col xs={5}>
                            <Field name="DateFlag" component={Selection} options={dateFlagOptions} />
                          </Col>
                        </Row>
                      }
                        <Row>
                          <div style={{height: '10px'}}></div>
                        </Row>
                        <Row>
                          <Col xs={2} style={{ paddingRight: 0 }}>
                            <label><Translate value="shelf_life" /></label>
                          </Col>
                          <Col xs={2} style={{ paddingLeft: 10 }}>
                            <Field
                              name="ShiftLife"
                              withRef={true}
                              ref="ShelfLife"
                              component={ InputField }
                              onFocus={this.handleOnFocus}
                              onKeyPress={(event) => {
                                if (event.charCode === 13)
                                  event.preventDefault();
                                }}
                              />
                          </Col>
                          <Col xs={1}>
                            <p style={{fontWeight: "bold", position: "relative", left: "-10px"}}><Translate value="days" /></p>
                          </Col>
                          <Col xs={1}></Col>
                          <Col xs={2} style={{ paddingRight: 0, paddingLeft: 20 }}>
                            <label><Translate value="buffer" /></label>
                          </Col>
                          <Col xs={2} style={{ paddingLeft: 10 }}>
                            <Field
                              name="BufferTime"
                              withRef={true}
                              ref="BufferTime"
                              component={ InputField }
                              onFocus={this.handleOnFocus}
                              onKeyPress={(event) => {
                                if (event.charCode === 13)
                                  event.preventDefault();
                                }}
                              />
                          </Col>
                          <Col xs={1}>
                            <p style={{fontWeight: "bold", position: "relative", left: "-10px"}}><Translate value="days" /></p>
                          </Col>
                          {
                            isEcity &&
                            <Row>
                              <Col xs={3} style={{ paddingRight: 0 }}>
                                <label><Translate value="expire_date" /></label>
                              </Col>
                              <Col xs={3} style={{ paddingLeft: 0 }}>
                                <Field
                                  disabled={true}
                                  name="ShiftLifeTime"
                                  withRef={true}
                                  ref="ShelfLife"
                                  component={InputField}
                                />
                              </Col>
                            </Row>
                          }
                        </Row>
                      </Col>
                      {
                        isGFD && 
                        <Col xs={12} style={{marginTop: 20}}>
                          <Row className="formRow">
                            <Col xs={7} style={{ paddingRight: 0 }}>
                              <label><Translate value="sales_popularity_class" /></label>
                            </Col>
                            <Col xs={5} style={{ paddingLeft: 10 }}>
                              <Field 
                                name="popularity"
                                component={Selection}
                                withRef={true} ref="popularityOptions"
                                options={popularityOptions} />
                            </Col>
                          </Row>
                        </Col>
                      }
                      {
                        isFACEX &&
                        <Col xs={12} style={{ position: 'relative', marginTop: 20}}>
                          <Row>
                            <Col xs={4}>
                              <p style={{fontWeight: "bold", position: "relative"}}>Inventory QTY: </p>
                            </Col>
                            <Col xs={3} style={{ paddingLeft: 10 }}>
                              <Input
                                type="text"
                                name="qty"
                                value={this.state.productInventoryQty}
                                onFocus={this.handleOnFocus}
                                onChange={(e) => {
                                  this.setState({ productInventoryQty: e.target.value });
                                }}
                              />
                            </Col>
                            <Col xs={3} style={{ paddingLeft: 10 }}>
                              <Button
                                bsStyle="primary"
                                type="button"
                                onClick={() => this.props.postProductInventoryBatches(this.props.params.id, this.state.productInventoryQty) }
                              >
                                <em className="fa fa-save" />
                                <Translate value="modify_inventory" />
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      }
                    {/* </Row> */}
                    </Panel> {/* End Inventory Details */}

                    {isSH &&
                      <Row>
                        <Col xs={12}>
                          {/* SH Amazon info */}
                          <Panel id="" header={amzInfolHeader}>
                            <Row>
                              <Col xs={6}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="item_no" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AmazonItemNum" withRef={true} ref="AmazonItemNum" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>

                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="box_packing" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AmazonBoxPacking" withRef={true} ref="AmazonBoxPacking" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="sku" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AmazonSKU" withRef={true} ref="AmazonSKU" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-5"><Translate value="price" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AmazonPrice" withRef={true} ref="AmazonPrice" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12}>
                                <div className="form-group prod-name-input">
                                  <label className="col-xs-3"><Translate value="Description" /></label>
                                  <div className="col-xs-9">
                                    <Field name="AmazonDescription" withRef={true} ref="AmazonDescription" component={ InputField } onFocus={this.handleOnFocus}/>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Panel> {/* End SH Panel */}
                        </Col>
                      </Row>
                    }

                    <Row>
                      <Col xs={12}>
                        {/* Vendor Details */}
                        <Panel id={isGFD ? "vendor-details-380" : "vendor-details"} header={vendorPanelHeader}>
                          {this.renderVendors() }
                        </Panel> {/* End Vendor Details */}
                      </Col>
                    </Row> {/* Vendor Details */}
                  </Col> {/* End Convert Details */}

                </Row> {/* Row Wrapper */}
              </Grid>
            </div>
            <RefNumberVerifyModal
              title={<Translate value="Ref# verify" />}
              onConfirm={handleSubmit(this.submitForm)}
              onCancel={this.setRefNumVerifyModalVisibility}
              isVisible={this.state.isRefNumVerifyModalVisible}
              RefNum={this.props.RefNum}
            />
          </form>
          {/* <div>{ this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }</div> */}
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.deleteModalOpen}
            onCloseClicked={this.closeDeleteModal}
            title={deleteProduct}
          >
            <ConfirmActionModal
              case="confirmPassword"
              closeC={this.checkAuthorize}
              checkPasswordFailure={this.props.checkPasswordFailure}
            />
          </SkyLightStateless>
          <SkyLightStateless isVisible={this.state.vendorOpen} onCloseClicked={() => { this.closeVendor() } } title="Add A New Vendor">
            <VendorForm closeV={this.closeVendor} />
          </SkyLightStateless>
          <SkyLightStateless isVisible={this.state.groupOpen} onCloseClicked={() => { this.closeGroup() } } title="Add A New Group">
            <GroupForm closeG={this.closeGroup} />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editProductGroup} onCloseClicked={() => { this.closeProductGroupEdit() }} title={editGroupFormTitle}>
            <EditGroupForm
              closeG={this.closeProductGroupEdit}
              groups={this.props.groups}
              deps={this.props.deps}
              formContent={this.state.editGroupFormAction === 'changeGroup' && this.state.productNavigation_1}
              productId={this.props.currentProductDetail && this.props.currentProductDetail.Product_id}
              saveAction={editGroupFormSaveAction}
              saveCallback={editGroupFormSaveActionCallback}
              groupArc={this.props.currentProductDetail}
            />
          </SkyLightStateless>
          <SkyLightStateless isVisible={this.state.categoryOpen} onCloseClicked={() => { this.closeCategory() } } title="Create a new category">
              <CategoryForm closeC={this.closeCategory} type="productForm"/>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.showProductCreatedOpen}
            onCloseClicked={this.closeShowProductCreated.bind(this)}
          >
            <br /><br />
            <Row className="centerStyle">
              <h4><Translate value="product_saved"/></h4>
            </Row>
            <br />
            <Row className="centerStyle"><h4><Translate value="msg_ask_if_stay_on_current_page" /></h4></Row>
            <br /><br />
            <Row className="centerStyle">
              <Button bsStyle="primary" onClick={(event) => { this.refreshPage(event) }} type="button" ><Translate value="yes"/></Button>
              { this.renderCloseButton() }
            </Row>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.productNavigationOpen[0]} onCloseClicked={() => { this.closeNavigation() } }>
            <ProductFormNavigation_1
              groups = {this.props.groups}
              deps = {this.props.deps}
              handleClickNext={this.handleClickNext_1}
              formContent={this.state.productNavigation_1}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={{ ...createDialogStyle, height: 'auto' }} isVisible={this.state.productNavigationOpen[1]} onCloseClicked={() => { this.closeNavigation() } }>
            <ProductFormNavigation_2 handleClickPrev={this.handleClickPrev_2} handleClickNext={this.handleClickNext_2} formContent={this.state.productNavigation_2}/>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.productNavigationOpen[2]} onCloseClicked={() => { this.closeNavigation(); } }>
            <ProductFormNavigation_3
              handleClickPrev={this.handleClickPrev_3}
              closeNavigation={this.closeNavigation}
              saveProductFormNavigation_3={this.saveProductFormNavigation_3}
              formContent={this.state.productNavigation_3}
              ProductNum={this.state.productNavigation_1.ProductNum}
              ProductGroup_id={this.state.productNavigation_1.ProductGroup_id}
              ProductCategory1_id={this.state.productNavigation_1.ProductCategory1_id}
              suggestedProdNum={this.state.productNavigation_1.suggestedProdNum}
              LastDigit={this.state.productNavigation_1.LastDigit}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.packageTypeOpen} onCloseClicked={() => { this.closePackageType() } }>
            <PackageTypes selectPackageType={this.selectPackageType} />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={promotionsStyle || this.state.isLoadingSavePromotion}
            isVisible={this.state.viewPromotion}
            onCloseClicked={this.closeViewPromotion}
            title={viewPromotionHeader}
          >
            <div id="promotions-page" className="centerStyle">
              <Row>
                <Tabs activeKey={this.state.tabsKey} justified onSelect={this.handleTabSelect}>
                  { this.renderByQuantityTab() }
                  {/* { this.renderBuyAGetBTab() } */}
                  { this.renderByTotalPriceProductTab() }
                  {/* { this.renderByTotalPriceDiscountTab() } */}
                </Tabs>
              </Row>
              <Row>
                {this.renderPromoDetails()}
              </Row>
            </div>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.editRecPermissionOpen}
            onCloseClicked={() => { this.closeEditRecPermission(); }}
            title={editRecPermission}
          >
            <ConfirmActionModal
              case={this.state.case}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={deletePromotionDialogStyle}
            isVisible={this.state.deletePromotionOpen}
            onCloseClicked={this.closeDeletePromotion}
          >
            <ConfirmActionModal
              case="removeItem"
              closeC={this.closeDeletePromotion}
              caseAction={this.handleDeletePromotion}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={editPromotionDialog}
            isVisible={this.state.editPromotionOpen}
            onCloseClicked={() => this.closeEditPromotion()}
            title={editPromotionTitle}
          >
            <EditPromotionModal
              promotion={this.state.promotionToEdit}
              customerList={this.state.customerList}
              closeEditPromotion={this.closeEditPromotion}
              isLoadingPromoDetails={this.state.isLoadingPromoDetails}
              searchProduct={false}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.checkAuthorizeOpen}
            onCloseClicked={this.closeCheckAuthorize}
          >
            <ConfirmActionModal
              case='confirmPassword'
              closeC={this.checkAuthorize}
              checkPasswordFailure={this.props.checkPasswordFailure}
            />
          </SkyLightStateless>
          {renderRichTextEditor()}
          <SkyLightStateless
            dialogStyles={createDisplayCategoryDialogStyle}
            isVisible={this.state.displayCategoryBoxOpen}
            onCloseClicked={() => { this.closeDisplayCategoryBox(); }}
            title={displayCategoryBoxTitle}
          >
            <DisplayCategoryModal displayCategories={this.state.displayCategories} productId={this.props.params.id} editDisplayCategories={this.props.editDisplayCategories} closeModal={this.closeDisplayCategoryBox} getDisplayCategories={this.getDisplayCategories}/>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.skusModal}
            onCloseClicked={() => { this.closeSkusModal(); }}
            title={skusModalTitle}
          >
            <SkusTableModal
              close={this.closeSkusModal}
              skus={this.state.ProductSKU}
              updateSKU={this.updateSKU}
              Product_id={this.state.Product_id}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.marketingModal}
            onCloseClicked={() => { this.closeMarketingModal(); }}
            title={marketModalTitle}
          >
            <MarketingModal
              close={this.closeMarketingModal}
              all={this.state.marketingAll}
              enableSelect={true}
              update={this.updateMarketSelect}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={imagesModalStyle}
            isVisible={this.state.imagesModalOpen}
            onCloseClicked={this.closeImageModal}
            title={imagesModalTitle}
          >
            <ProductImagesTable
              productId={this.props.currentProductDetail && this.props.currentProductDetail.Product_id}
              handleImageUpdated={(image) => this.handleImageUpdated(image)}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={isVAK ? bomProductListStyle : convertProductListStyle}
            isVisible={this.state.addConvertProductsOpen}
            onCloseClicked={() => this.closeAddConvertProducts()}
            title={addConvertProductsTitle}
          >
            { isVAK ?
            <BomProductsModal
              productCategoryId={productCategoryId}
              previouslySelectedProducts={this.state.relatedProducts}
              modifyConvertableProductList={this.modifyConvertableProductList}
              isCombination={true}
            /> :
            <LinkProductsModal
              products={this.state.categoryProducts}
              previouslySelectedProducts={this.state.relatedProducts}
              modifyConvertableProductList={this.modifyConvertableProductList}
            />
            }
          </SkyLightStateless>
          <SkyLightStateless title={productMetaInfoTitle} dialogStyles={createProductMetaStyle} isVisible={this.state.productMetaInfoVisibility} onCloseClicked={() => { this.setProductMetaInfoVisibility(false) }}>
            <ProductMetaInfoModal meta_info={this.state.meta_info} handleProductMetaInfoSave={this.handleProductMetaInfoSave} />
          </SkyLightStateless>

          <SkyLightStateless title={eslTitle} dialogStyles={createESLStyle} isVisible={this.state.eslModalVisibility} onCloseClicked={() => { this.closeESLModal(); }}>
            <ESLModal eslFetchData={this.state.eslFetchData} fetchESLTemplate={this.props.fetchESLTemplate} handleSaveESL={this.handleSaveESL} handleFetchESL={this.handleFetchESL} />
          </SkyLightStateless>
          <SkyLightStateless   title={<Translate value="print_scale_barcode" />} dialogStyles={createESLStyle} isVisible={this.state.scaleLabelModalVisibility} onCloseClicked={() => { this.closeScaleLabelModal(); }}>
            <ScaleBarcodeModal 
              productNumber={this.props.ProductNumber}
              selectedWarehouse={this.props.selectedWarehouse}
              disable={!this.props.currentProduct && !this.props.params.id }
              onCancel={this.closeScaleLabelModal}
            />
          </SkyLightStateless>
          {renderIsLap()}
          <ConfirmModal
             title={<Translate value="Action Confirmation" />}
             content={<Translate value="Warning: Shipping Weight is lower then Net Weight" />}
             onConfirm={() => {
              this.setState({ confirmModalVisibility: false });
              this.submitForm(this.state.formProps);
            }}
             onCancel={() => { this.setState({confirmModalVisibility: false }) }}
             isVisible={this.state.confirmModalVisibility}
          />
          <BarcodeVerifyFailedModal
            barcodeVerifyFailedMsg={this.state.barcodeVerifyFailedMsg}
            isVisible={this.state.isBarcodeVerifyFailedModalVisible}
            onConfirm={this.handleOCMBarcodeVerifyFailedConfirm}
            onClose={this.setBarcodeVerifyFailedModalVisibility}
          />
        </ContentWrapper>
        //---------------
        // End HTML
        //---------------
      )
    }
  }
}

export default withRouter(ProductForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Products/productForm.jsx